/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.9.0 (NJsonSchema v10.6.8.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
// @ts-nocheck

import { ApiClientBase } from "./ApiClientBase";

export interface IAdHocGamesClient {

    newAdHocGame(file: FileParameter | null | undefined): Promise<number>;

    getAdHocGameById(adhocgameid: number): Promise<AdHocMatchSummaryVm>;
}

export class AdHocGamesClient extends ApiClientBase implements IAdHocGamesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    newAdHocGame(file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/AdHocGames/newadhocgame";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNewAdHocGame(_response);
        });
    }

    protected processNewAdHocGame(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getAdHocGameById(adhocgameid: number): Promise<AdHocMatchSummaryVm> {
        let url_ = this.baseUrl + "/api/AdHocGames/{adhocgameid}/summary";
        if (adhocgameid === undefined || adhocgameid === null)
            throw new Error("The parameter 'adhocgameid' must be defined.");
        url_ = url_.replace("{adhocgameid}", encodeURIComponent("" + adhocgameid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAdHocGameById(_response);
        });
    }

    protected processGetAdHocGameById(response: Response): Promise<AdHocMatchSummaryVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdHocMatchSummaryVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdHocMatchSummaryVm>(null as any);
    }
}

export interface IDemosClient {

    getMyDemos(): Promise<MyDemoVm>;

    getDemos(season: number | null | undefined, gametype: GameType | null | undefined, player: number | null | undefined): Promise<DemoVm>;

    getUnapprovedDemos(): Promise<UnapprovedDemoVm>;

    getOutstandingDemos(seasonId: number): Promise<OutstandingDemoVm>;

    markDemoAsMissing(command: MarkDemoAsMissingCommand): Promise<number>;

    approveDemo(command: ApproveDemoCommand): Promise<number>;

    rejectDemo(command: RejectDemoCommand): Promise<number>;
}

export class DemosClient extends ApiClientBase implements IDemosClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getMyDemos(): Promise<MyDemoVm> {
        let url_ = this.baseUrl + "/api/Demos/my";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMyDemos(_response);
        });
    }

    protected processGetMyDemos(response: Response): Promise<MyDemoVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MyDemoVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MyDemoVm>(null as any);
    }

    getDemos(season: number | null | undefined, gametype: GameType | null | undefined, player: number | null | undefined): Promise<DemoVm> {
        let url_ = this.baseUrl + "/api/Demos?";
        if (season !== undefined && season !== null)
            url_ += "season=" + encodeURIComponent("" + season) + "&";
        if (gametype !== undefined && gametype !== null)
            url_ += "gametype=" + encodeURIComponent("" + gametype) + "&";
        if (player !== undefined && player !== null)
            url_ += "player=" + encodeURIComponent("" + player) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDemos(_response);
        });
    }

    protected processGetDemos(response: Response): Promise<DemoVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DemoVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DemoVm>(null as any);
    }

    getUnapprovedDemos(): Promise<UnapprovedDemoVm> {
        let url_ = this.baseUrl + "/api/Demos/unapproved";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnapprovedDemos(_response);
        });
    }

    protected processGetUnapprovedDemos(response: Response): Promise<UnapprovedDemoVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnapprovedDemoVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnapprovedDemoVm>(null as any);
    }

    getOutstandingDemos(seasonId: number): Promise<OutstandingDemoVm> {
        let url_ = this.baseUrl + "/api/Demos/{seasonId}/outstanding";
        if (seasonId === undefined || seasonId === null)
            throw new Error("The parameter 'seasonId' must be defined.");
        url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOutstandingDemos(_response);
        });
    }

    protected processGetOutstandingDemos(response: Response): Promise<OutstandingDemoVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OutstandingDemoVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OutstandingDemoVm>(null as any);
    }

    markDemoAsMissing(command: MarkDemoAsMissingCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Demos/markdemomissing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMarkDemoAsMissing(_response);
        });
    }

    protected processMarkDemoAsMissing(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    approveDemo(command: ApproveDemoCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Demos/approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApproveDemo(_response);
        });
    }

    protected processApproveDemo(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    rejectDemo(command: RejectDemoCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Demos/reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRejectDemo(_response);
        });
    }

    protected processRejectDemo(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface IDraftClient {

    create(command: CreateDraftCommand): Promise<number>;
}

export class DraftClient extends ApiClientBase implements IDraftClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    create(command: CreateDraftCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Draft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface IEngineClient {

    get(): Promise<EnginesVm>;

    create(command: CreateEngineCommand): Promise<number>;

    update(engineId: number, command: UpdateEngineCommand): Promise<FileResponse>;
}

export class EngineClient extends ApiClientBase implements IEngineClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Promise<EnginesVm> {
        let url_ = this.baseUrl + "/api/Engine";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<EnginesVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnginesVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnginesVm>(null as any);
    }

    create(command: CreateEngineCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Engine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    update(engineId: number, command: UpdateEngineCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Engine/{engineId}";
        if (engineId === undefined || engineId === null)
            throw new Error("The parameter 'engineId' must be defined.");
        url_ = url_.replace("{engineId}", encodeURIComponent("" + engineId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IFilesClient {

    createWDLLogFile(file: FileParameter | null | undefined): Promise<number>;

    createWadFile(file: FileParameter | null | undefined): Promise<number>;

    createMapImage(file: FileParameter | null | undefined, caption: string | null | undefined, mapId: number | undefined): Promise<number>;

    createDemoFile(file: FileParameter | null | undefined, demoId: number | undefined): Promise<number>;

    changeImagePriority(command: ChangeMapImagesPriorityCommand): Promise<number>;

    getWadFiles(): Promise<WadFilesVm>;

    getRoundJsonFiles(): Promise<string[]>;

    getRoundObject(fileName: string | null | undefined): Promise<Round>;

    deleteMapImage(mapImageId: number, command: DeleteMapImageFileCommand): Promise<number>;
}

export class FilesClient extends ApiClientBase implements IFilesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createWDLLogFile(file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Files/wdllogfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateWDLLogFile(_response);
        });
    }

    protected processCreateWDLLogFile(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    createWadFile(file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Files/wad";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateWadFile(_response);
        });
    }

    protected processCreateWadFile(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    createMapImage(file: FileParameter | null | undefined, caption: string | null | undefined, mapId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Files/mapimage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (caption !== null && caption !== undefined)
            content_.append("Caption", caption.toString());
        if (mapId === null || mapId === undefined)
            throw new Error("The parameter 'mapId' cannot be null.");
        else
            content_.append("MapId", mapId.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateMapImage(_response);
        });
    }

    protected processCreateMapImage(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    createDemoFile(file: FileParameter | null | undefined, demoId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Files/playerdemo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (demoId === null || demoId === undefined)
            throw new Error("The parameter 'demoId' cannot be null.");
        else
            content_.append("DemoId", demoId.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateDemoFile(_response);
        });
    }

    protected processCreateDemoFile(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    changeImagePriority(command: ChangeMapImagesPriorityCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Files/changepriority";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangeImagePriority(_response);
        });
    }

    protected processChangeImagePriority(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getWadFiles(): Promise<WadFilesVm> {
        let url_ = this.baseUrl + "/api/Files/wads";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWadFiles(_response);
        });
    }

    protected processGetWadFiles(response: Response): Promise<WadFilesVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WadFilesVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WadFilesVm>(null as any);
    }

    getRoundJsonFiles(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Files/json";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRoundJsonFiles(_response);
        });
    }

    protected processGetRoundJsonFiles(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getRoundObject(fileName: string | null | undefined): Promise<Round> {
        let url_ = this.baseUrl + "/api/Files/json/rounddata?";
        if (fileName !== undefined && fileName !== null)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRoundObject(_response);
        });
    }

    protected processGetRoundObject(response: Response): Promise<Round> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Round.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Round>(null as any);
    }

    deleteMapImage(mapImageId: number, command: DeleteMapImageFileCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Files/{mapImageId}";
        if (mapImageId === undefined || mapImageId === null)
            throw new Error("The parameter 'mapImageId' must be defined.");
        url_ = url_.replace("{mapImageId}", encodeURIComponent("" + mapImageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteMapImage(_response);
        });
    }

    protected processDeleteMapImage(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface ILeaderboardStatsClient {

    get(seasonId: number | null | undefined, mapId: number | null | undefined, mode: LeaderboardStatsMode | undefined, statsType: LeaderboardStatsType | undefined, gameType: GameType | undefined): Promise<PlayerLeaderboardSeasonStatsVm>;
}

export class LeaderboardStatsClient extends ApiClientBase implements ILeaderboardStatsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(seasonId: number | null | undefined, mapId: number | null | undefined, mode: LeaderboardStatsMode | undefined, statsType: LeaderboardStatsType | undefined, gameType: GameType | undefined): Promise<PlayerLeaderboardSeasonStatsVm> {
        let url_ = this.baseUrl + "/api/LeaderboardStats?";
        if (seasonId !== undefined && seasonId !== null)
            url_ += "seasonId=" + encodeURIComponent("" + seasonId) + "&";
        if (mapId !== undefined && mapId !== null)
            url_ += "mapId=" + encodeURIComponent("" + mapId) + "&";
        if (mode === null)
            throw new Error("The parameter 'mode' cannot be null.");
        else if (mode !== undefined)
            url_ += "mode=" + encodeURIComponent("" + mode) + "&";
        if (statsType === null)
            throw new Error("The parameter 'statsType' cannot be null.");
        else if (statsType !== undefined)
            url_ += "statsType=" + encodeURIComponent("" + statsType) + "&";
        if (gameType === null)
            throw new Error("The parameter 'gameType' cannot be null.");
        else if (gameType !== undefined)
            url_ += "gameType=" + encodeURIComponent("" + gameType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<PlayerLeaderboardSeasonStatsVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlayerLeaderboardSeasonStatsVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlayerLeaderboardSeasonStatsVm>(null as any);
    }
}

export interface ILeagueClient {

    get(): Promise<LeaguesVm>;

    create(command: CreateLeagueCommand): Promise<number>;

    update(leagueId: number, command: UpdateLeagueCommand): Promise<FileResponse>;
}

export class LeagueClient extends ApiClientBase implements ILeagueClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Promise<LeaguesVm> {
        let url_ = this.baseUrl + "/api/League";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<LeaguesVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeaguesVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LeaguesVm>(null as any);
    }

    create(command: CreateLeagueCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/League";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    update(leagueId: number, command: UpdateLeagueCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/League/{leagueId}";
        if (leagueId === undefined || leagueId === null)
            throw new Error("The parameter 'leagueId' must be defined.");
        url_ = url_.replace("{leagueId}", encodeURIComponent("" + leagueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IMapsClient {

    get(): Promise<MapsVm>;

    create(command: CreateMapCommand): Promise<number>;

    getImages(mapId: number): Promise<MapImagesVm>;

    getMapSummaryById(mapId: number): Promise<MapSummaryVm>;

    getUnplayedMaps(): Promise<UnplayedMapsVm>;

    getMapsBySeasonAndGameType(season: number | null | undefined, gameType: GameType | undefined): Promise<PlayedSeasonGameTypeMapsVm>;

    edit(mapId: number, command: EditMapCommand): Promise<number>;

    delete(mapId: number, command: DeleteMapCommand): Promise<number>;
}

export class MapsClient extends ApiClientBase implements IMapsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Promise<MapsVm> {
        let url_ = this.baseUrl + "/api/Maps";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<MapsVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MapsVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MapsVm>(null as any);
    }

    create(command: CreateMapCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Maps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getImages(mapId: number): Promise<MapImagesVm> {
        let url_ = this.baseUrl + "/api/Maps/{mapId}/images";
        if (mapId === undefined || mapId === null)
            throw new Error("The parameter 'mapId' must be defined.");
        url_ = url_.replace("{mapId}", encodeURIComponent("" + mapId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetImages(_response);
        });
    }

    protected processGetImages(response: Response): Promise<MapImagesVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MapImagesVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MapImagesVm>(null as any);
    }

    getMapSummaryById(mapId: number): Promise<MapSummaryVm> {
        let url_ = this.baseUrl + "/api/Maps/{mapId}/summary";
        if (mapId === undefined || mapId === null)
            throw new Error("The parameter 'mapId' must be defined.");
        url_ = url_.replace("{mapId}", encodeURIComponent("" + mapId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMapSummaryById(_response);
        });
    }

    protected processGetMapSummaryById(response: Response): Promise<MapSummaryVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MapSummaryVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MapSummaryVm>(null as any);
    }

    getUnplayedMaps(): Promise<UnplayedMapsVm> {
        let url_ = this.baseUrl + "/api/Maps/unplayed";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnplayedMaps(_response);
        });
    }

    protected processGetUnplayedMaps(response: Response): Promise<UnplayedMapsVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnplayedMapsVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnplayedMapsVm>(null as any);
    }

    getMapsBySeasonAndGameType(season: number | null | undefined, gameType: GameType | undefined): Promise<PlayedSeasonGameTypeMapsVm> {
        let url_ = this.baseUrl + "/api/Maps/MapsBySeasonAndGameType?";
        if (season !== undefined && season !== null)
            url_ += "season=" + encodeURIComponent("" + season) + "&";
        if (gameType === null)
            throw new Error("The parameter 'gameType' cannot be null.");
        else if (gameType !== undefined)
            url_ += "gameType=" + encodeURIComponent("" + gameType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMapsBySeasonAndGameType(_response);
        });
    }

    protected processGetMapsBySeasonAndGameType(response: Response): Promise<PlayedSeasonGameTypeMapsVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlayedSeasonGameTypeMapsVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlayedSeasonGameTypeMapsVm>(null as any);
    }

    edit(mapId: number, command: EditMapCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Maps/{mapId}";
        if (mapId === undefined || mapId === null)
            throw new Error("The parameter 'mapId' must be defined.");
        url_ = url_.replace("{mapId}", encodeURIComponent("" + mapId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    delete(mapId: number, command: DeleteMapCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Maps/{mapId}";
        if (mapId === undefined || mapId === null)
            throw new Error("The parameter 'mapId' must be defined.");
        url_ = url_.replace("{mapId}", encodeURIComponent("" + mapId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface IMatchesClient {

    getMatchSummary(matchId: number): Promise<MatchSummaryVm>;

    getPlayerLineup(matchId: number): Promise<PlayerLineupVm>;

    getUnplayedGames(seasonId: number): Promise<UnplayedGamesVm>;

    getUnplayedPlayoffGames(seasonId: number): Promise<UnplayedPlayoffGamesVm>;

    getPlayedGames(): Promise<PlayedGamesVm>;

    getUpcomingGames(): Promise<UpcomingMatchesVm>;

    getPlayedMatchResults(offset: number | undefined, perPage: number | undefined): Promise<PlayedMatchResultsVm>;

    getGameMaps(matchId: number): Promise<GameMapsVm>;

    create(command: CreateMatchCommand): Promise<number>;

    createRegularSeason(command: CreateMatchesCommand): Promise<number>;

    process(command: ProcessMatchCommand): Promise<number>;

    undo(command: UndoMatchCommand): Promise<boolean>;

    forfeit(command: ForfeitMatchCommand): Promise<boolean>;

    schedule(command: ScheduleMatchCommand): Promise<boolean>;

    deletePlayoffMatch(command: DeletePlayoffMatchCommand): Promise<boolean>;
}

export class MatchesClient extends ApiClientBase implements IMatchesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getMatchSummary(matchId: number): Promise<MatchSummaryVm> {
        let url_ = this.baseUrl + "/api/Matches/{matchId}/summary";
        if (matchId === undefined || matchId === null)
            throw new Error("The parameter 'matchId' must be defined.");
        url_ = url_.replace("{matchId}", encodeURIComponent("" + matchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMatchSummary(_response);
        });
    }

    protected processGetMatchSummary(response: Response): Promise<MatchSummaryVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchSummaryVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchSummaryVm>(null as any);
    }

    getPlayerLineup(matchId: number): Promise<PlayerLineupVm> {
        let url_ = this.baseUrl + "/api/Matches/{matchId}/lineup";
        if (matchId === undefined || matchId === null)
            throw new Error("The parameter 'matchId' must be defined.");
        url_ = url_.replace("{matchId}", encodeURIComponent("" + matchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPlayerLineup(_response);
        });
    }

    protected processGetPlayerLineup(response: Response): Promise<PlayerLineupVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlayerLineupVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlayerLineupVm>(null as any);
    }

    getUnplayedGames(seasonId: number): Promise<UnplayedGamesVm> {
        let url_ = this.baseUrl + "/api/Matches/{seasonId}/unplayed";
        if (seasonId === undefined || seasonId === null)
            throw new Error("The parameter 'seasonId' must be defined.");
        url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnplayedGames(_response);
        });
    }

    protected processGetUnplayedGames(response: Response): Promise<UnplayedGamesVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnplayedGamesVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnplayedGamesVm>(null as any);
    }

    getUnplayedPlayoffGames(seasonId: number): Promise<UnplayedPlayoffGamesVm> {
        let url_ = this.baseUrl + "/api/Matches/{seasonId}/unplayedplayoff";
        if (seasonId === undefined || seasonId === null)
            throw new Error("The parameter 'seasonId' must be defined.");
        url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnplayedPlayoffGames(_response);
        });
    }

    protected processGetUnplayedPlayoffGames(response: Response): Promise<UnplayedPlayoffGamesVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnplayedPlayoffGamesVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnplayedPlayoffGamesVm>(null as any);
    }

    getPlayedGames(): Promise<PlayedGamesVm> {
        let url_ = this.baseUrl + "/api/Matches/played";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPlayedGames(_response);
        });
    }

    protected processGetPlayedGames(response: Response): Promise<PlayedGamesVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlayedGamesVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlayedGamesVm>(null as any);
    }

    getUpcomingGames(): Promise<UpcomingMatchesVm> {
        let url_ = this.baseUrl + "/api/Matches/upcoming";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUpcomingGames(_response);
        });
    }

    protected processGetUpcomingGames(response: Response): Promise<UpcomingMatchesVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpcomingMatchesVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpcomingMatchesVm>(null as any);
    }

    getPlayedMatchResults(offset: number | undefined, perPage: number | undefined): Promise<PlayedMatchResultsVm> {
        let url_ = this.baseUrl + "/api/Matches/playedmatchresults?";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPlayedMatchResults(_response);
        });
    }

    protected processGetPlayedMatchResults(response: Response): Promise<PlayedMatchResultsVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlayedMatchResultsVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlayedMatchResultsVm>(null as any);
    }

    getGameMaps(matchId: number): Promise<GameMapsVm> {
        let url_ = this.baseUrl + "/api/Matches/{matchId}/maps";
        if (matchId === undefined || matchId === null)
            throw new Error("The parameter 'matchId' must be defined.");
        url_ = url_.replace("{matchId}", encodeURIComponent("" + matchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGameMaps(_response);
        });
    }

    protected processGetGameMaps(response: Response): Promise<GameMapsVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GameMapsVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GameMapsVm>(null as any);
    }

    create(command: CreateMatchCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Matches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    createRegularSeason(command: CreateMatchesCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Matches/CreateRegularSeason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRegularSeason(_response);
        });
    }

    protected processCreateRegularSeason(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    process(command: ProcessMatchCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Matches/process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProcess(_response);
        });
    }

    protected processProcess(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    undo(command: UndoMatchCommand): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Matches/undo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUndo(_response);
        });
    }

    protected processUndo(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    forfeit(command: ForfeitMatchCommand): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Matches/forfeit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processForfeit(_response);
        });
    }

    protected processForfeit(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    schedule(command: ScheduleMatchCommand): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Matches/schedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSchedule(_response);
        });
    }

    protected processSchedule(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deletePlayoffMatch(command: DeletePlayoffMatchCommand): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Matches/deleteplayoffgame";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeletePlayoffMatch(_response);
        });
    }

    protected processDeletePlayoffMatch(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IPlayersClient {

    get(): Promise<PlayersVm>;

    create(command: CreatePlayerCommand): Promise<number>;

    getPlayersWithDemos(seasonId: number | null | undefined, gameType: GameType | undefined): Promise<PlayersWithDemosVm>;

    getPlayerAppearances(seasonId: number | null | undefined, gameType: GameType | undefined): Promise<PlayerAppearancesListVm>;

    getPlayerSummaryById(playerId: number): Promise<PlayerSummaryVm>;

    associate(command: AssociatePlayerWithUserCommand): Promise<boolean>;

    disassociate(command: DisassociatePlayerWithUserCommand): Promise<boolean>;

    update(playerId: number, command: UpdatePlayerCommand): Promise<number>;
}

export class PlayersClient extends ApiClientBase implements IPlayersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Promise<PlayersVm> {
        let url_ = this.baseUrl + "/api/Players";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<PlayersVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlayersVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlayersVm>(null as any);
    }

    create(command: CreatePlayerCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Players";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getPlayersWithDemos(seasonId: number | null | undefined, gameType: GameType | undefined): Promise<PlayersWithDemosVm> {
        let url_ = this.baseUrl + "/api/Players/WithDemos?";
        if (seasonId !== undefined && seasonId !== null)
            url_ += "seasonId=" + encodeURIComponent("" + seasonId) + "&";
        if (gameType === null)
            throw new Error("The parameter 'gameType' cannot be null.");
        else if (gameType !== undefined)
            url_ += "gameType=" + encodeURIComponent("" + gameType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPlayersWithDemos(_response);
        });
    }

    protected processGetPlayersWithDemos(response: Response): Promise<PlayersWithDemosVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlayersWithDemosVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlayersWithDemosVm>(null as any);
    }

    getPlayerAppearances(seasonId: number | null | undefined, gameType: GameType | undefined): Promise<PlayerAppearancesListVm> {
        let url_ = this.baseUrl + "/api/Players/ByAppearances?";
        if (seasonId !== undefined && seasonId !== null)
            url_ += "seasonId=" + encodeURIComponent("" + seasonId) + "&";
        if (gameType === null)
            throw new Error("The parameter 'gameType' cannot be null.");
        else if (gameType !== undefined)
            url_ += "gameType=" + encodeURIComponent("" + gameType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPlayerAppearances(_response);
        });
    }

    protected processGetPlayerAppearances(response: Response): Promise<PlayerAppearancesListVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlayerAppearancesListVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlayerAppearancesListVm>(null as any);
    }

    getPlayerSummaryById(playerId: number): Promise<PlayerSummaryVm> {
        let url_ = this.baseUrl + "/api/Players/{playerId}/summary";
        if (playerId === undefined || playerId === null)
            throw new Error("The parameter 'playerId' must be defined.");
        url_ = url_.replace("{playerId}", encodeURIComponent("" + playerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPlayerSummaryById(_response);
        });
    }

    protected processGetPlayerSummaryById(response: Response): Promise<PlayerSummaryVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlayerSummaryVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlayerSummaryVm>(null as any);
    }

    associate(command: AssociatePlayerWithUserCommand): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Players/associate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssociate(_response);
        });
    }

    protected processAssociate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    disassociate(command: DisassociatePlayerWithUserCommand): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Players/disassociate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDisassociate(_response);
        });
    }

    protected processDisassociate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    update(playerId: number, command: UpdatePlayerCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Players/{playerId}";
        if (playerId === undefined || playerId === null)
            throw new Error("The parameter 'playerId' must be defined.");
        url_ = url_.replace("{playerId}", encodeURIComponent("" + playerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface IPlayerTransactionsClient {

    tradePlayerToTeam(command: TradePlayerToTeamCommand): Promise<boolean>;

    tradePlayerToFreeAgency(command: TradePlayerToFreeAgencyCommand): Promise<boolean>;

    promotePlayerToCaptain(command: PromotePlayerToCaptainCommand): Promise<boolean>;

    reverseLastTrade(command: ReverseLastTradeCommand): Promise<boolean>;
}

export class PlayerTransactionsClient extends ApiClientBase implements IPlayerTransactionsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    tradePlayerToTeam(command: TradePlayerToTeamCommand): Promise<boolean> {
        let url_ = this.baseUrl + "/api/PlayerTransactions/TradePlayerToTeam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTradePlayerToTeam(_response);
        });
    }

    protected processTradePlayerToTeam(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    tradePlayerToFreeAgency(command: TradePlayerToFreeAgencyCommand): Promise<boolean> {
        let url_ = this.baseUrl + "/api/PlayerTransactions/TradePlayerToFreeAgency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTradePlayerToFreeAgency(_response);
        });
    }

    protected processTradePlayerToFreeAgency(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    promotePlayerToCaptain(command: PromotePlayerToCaptainCommand): Promise<boolean> {
        let url_ = this.baseUrl + "/api/PlayerTransactions/PromotePlayerToCaptain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPromotePlayerToCaptain(_response);
        });
    }

    protected processPromotePlayerToCaptain(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    reverseLastTrade(command: ReverseLastTradeCommand): Promise<boolean> {
        let url_ = this.baseUrl + "/api/PlayerTransactions/ReverseLastTrade";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReverseLastTrade(_response);
        });
    }

    protected processReverseLastTrade(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IRoundsClient {

    get(output: RoundsOutputFileType | null | undefined): Promise<FileResponse>;
}

export class RoundsClient extends ApiClientBase implements IRoundsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(output: RoundsOutputFileType | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Rounds?";
        if (output !== undefined && output !== null)
            url_ += "output=" + encodeURIComponent("" + output) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ISeasonsClient {

    get(): Promise<SeasonsVm>;

    create(command: CreateSeasonCommand): Promise<number>;

    getPlayedSeasons(): Promise<PlayedSeasonsVm>;

    getSeasonsWithDemos(gameType: GameType | undefined): Promise<SeasonsWithDemosVm>;

    getSeasonsWithPlayers(gameType: GameType | undefined): Promise<SeasonsWithPlayersVm>;

    getSeasonSummaryById(seasonId: number): Promise<SeasonSummaryVm>;

    getCurrentSeasonsStandings(): Promise<SeasonListVm>;

    getSeasonStandingsById(seasonId: number): Promise<SeasonStandingsVm>;

    getUnfinishedSeasons(): Promise<UnfinishedSeasonsVm>;

    getActiveInactive(): Promise<ActiveInactiveSeasonVm>;

    getSeasonPlayers(seasonId: number): Promise<SeasonPlayersVm>;

    getFreeAgencyForSeason(seasonId: number): Promise<FreeAgencyPlayersVm>;

    update(seasonId: number, command: UpdateSeasonCommand): Promise<number>;

    delete(seasonId: number, command: DeleteSeasonCommand): Promise<number>;

    createWeeks(command: CreateSeasonWeeksCommand): Promise<number>;
}

export class SeasonsClient extends ApiClientBase implements ISeasonsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Promise<SeasonsVm> {
        let url_ = this.baseUrl + "/api/Seasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<SeasonsVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SeasonsVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeasonsVm>(null as any);
    }

    create(command: CreateSeasonCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Seasons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getPlayedSeasons(): Promise<PlayedSeasonsVm> {
        let url_ = this.baseUrl + "/api/Seasons/played";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPlayedSeasons(_response);
        });
    }

    protected processGetPlayedSeasons(response: Response): Promise<PlayedSeasonsVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlayedSeasonsVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlayedSeasonsVm>(null as any);
    }

    getSeasonsWithDemos(gameType: GameType | undefined): Promise<SeasonsWithDemosVm> {
        let url_ = this.baseUrl + "/api/Seasons/WithDemos?";
        if (gameType === null)
            throw new Error("The parameter 'gameType' cannot be null.");
        else if (gameType !== undefined)
            url_ += "gameType=" + encodeURIComponent("" + gameType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSeasonsWithDemos(_response);
        });
    }

    protected processGetSeasonsWithDemos(response: Response): Promise<SeasonsWithDemosVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SeasonsWithDemosVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeasonsWithDemosVm>(null as any);
    }

    getSeasonsWithPlayers(gameType: GameType | undefined): Promise<SeasonsWithPlayersVm> {
        let url_ = this.baseUrl + "/api/Seasons/WithPlayers?";
        if (gameType === null)
            throw new Error("The parameter 'gameType' cannot be null.");
        else if (gameType !== undefined)
            url_ += "gameType=" + encodeURIComponent("" + gameType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSeasonsWithPlayers(_response);
        });
    }

    protected processGetSeasonsWithPlayers(response: Response): Promise<SeasonsWithPlayersVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SeasonsWithPlayersVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeasonsWithPlayersVm>(null as any);
    }

    getSeasonSummaryById(seasonId: number): Promise<SeasonSummaryVm> {
        let url_ = this.baseUrl + "/api/Seasons/{seasonId}/summary";
        if (seasonId === undefined || seasonId === null)
            throw new Error("The parameter 'seasonId' must be defined.");
        url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSeasonSummaryById(_response);
        });
    }

    protected processGetSeasonSummaryById(response: Response): Promise<SeasonSummaryVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SeasonSummaryVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeasonSummaryVm>(null as any);
    }

    getCurrentSeasonsStandings(): Promise<SeasonListVm> {
        let url_ = this.baseUrl + "/api/Seasons/current/standings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrentSeasonsStandings(_response);
        });
    }

    protected processGetCurrentSeasonsStandings(response: Response): Promise<SeasonListVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SeasonListVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeasonListVm>(null as any);
    }

    getSeasonStandingsById(seasonId: number): Promise<SeasonStandingsVm> {
        let url_ = this.baseUrl + "/api/Seasons/{seasonId}/standings";
        if (seasonId === undefined || seasonId === null)
            throw new Error("The parameter 'seasonId' must be defined.");
        url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSeasonStandingsById(_response);
        });
    }

    protected processGetSeasonStandingsById(response: Response): Promise<SeasonStandingsVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SeasonStandingsVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeasonStandingsVm>(null as any);
    }

    getUnfinishedSeasons(): Promise<UnfinishedSeasonsVm> {
        let url_ = this.baseUrl + "/api/Seasons/unfinished";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnfinishedSeasons(_response);
        });
    }

    protected processGetUnfinishedSeasons(response: Response): Promise<UnfinishedSeasonsVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnfinishedSeasonsVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnfinishedSeasonsVm>(null as any);
    }

    getActiveInactive(): Promise<ActiveInactiveSeasonVm> {
        let url_ = this.baseUrl + "/api/Seasons/activeinactive";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetActiveInactive(_response);
        });
    }

    protected processGetActiveInactive(response: Response): Promise<ActiveInactiveSeasonVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActiveInactiveSeasonVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActiveInactiveSeasonVm>(null as any);
    }

    getSeasonPlayers(seasonId: number): Promise<SeasonPlayersVm> {
        let url_ = this.baseUrl + "/api/Seasons/{seasonId}/players";
        if (seasonId === undefined || seasonId === null)
            throw new Error("The parameter 'seasonId' must be defined.");
        url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSeasonPlayers(_response);
        });
    }

    protected processGetSeasonPlayers(response: Response): Promise<SeasonPlayersVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SeasonPlayersVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeasonPlayersVm>(null as any);
    }

    getFreeAgencyForSeason(seasonId: number): Promise<FreeAgencyPlayersVm> {
        let url_ = this.baseUrl + "/api/Seasons/{seasonId}/freeagency";
        if (seasonId === undefined || seasonId === null)
            throw new Error("The parameter 'seasonId' must be defined.");
        url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFreeAgencyForSeason(_response);
        });
    }

    protected processGetFreeAgencyForSeason(response: Response): Promise<FreeAgencyPlayersVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FreeAgencyPlayersVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FreeAgencyPlayersVm>(null as any);
    }

    update(seasonId: number, command: UpdateSeasonCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Seasons/{seasonId}";
        if (seasonId === undefined || seasonId === null)
            throw new Error("The parameter 'seasonId' must be defined.");
        url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    delete(seasonId: number, command: DeleteSeasonCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Seasons/{seasonId}";
        if (seasonId === undefined || seasonId === null)
            throw new Error("The parameter 'seasonId' must be defined.");
        url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    createWeeks(command: CreateSeasonWeeksCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Seasons/CreateWeeks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateWeeks(_response);
        });
    }

    protected processCreateWeeks(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface ITeamsClient {

    getTeamSummaryById(teamId: number): Promise<TeamSummaryVm>;

    getTeamsBySeasonId(seasonId: number): Promise<TeamsVm>;

    getTeamPlayers(teamId: number): Promise<TeamPlayersVm>;

    getNonCaptainPlayers(teamId: number): Promise<NonCaptainTeamPlayersVm>;

    create(command: CreateTeamCommand): Promise<number>;

    createTeams(command: CreateTeamsCommand): Promise<number>;

    assignHomeField(command: AssignTeamHomefieldCommand): Promise<number>;

    update(teamId: number, command: UpdateTeamCommand): Promise<number>;
}

export class TeamsClient extends ApiClientBase implements ITeamsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTeamSummaryById(teamId: number): Promise<TeamSummaryVm> {
        let url_ = this.baseUrl + "/api/Teams/{teamId}/summary";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTeamSummaryById(_response);
        });
    }

    protected processGetTeamSummaryById(response: Response): Promise<TeamSummaryVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamSummaryVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamSummaryVm>(null as any);
    }

    getTeamsBySeasonId(seasonId: number): Promise<TeamsVm> {
        let url_ = this.baseUrl + "/api/Teams/{seasonId}";
        if (seasonId === undefined || seasonId === null)
            throw new Error("The parameter 'seasonId' must be defined.");
        url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTeamsBySeasonId(_response);
        });
    }

    protected processGetTeamsBySeasonId(response: Response): Promise<TeamsVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamsVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamsVm>(null as any);
    }

    getTeamPlayers(teamId: number): Promise<TeamPlayersVm> {
        let url_ = this.baseUrl + "/api/Teams/{teamId}/players";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTeamPlayers(_response);
        });
    }

    protected processGetTeamPlayers(response: Response): Promise<TeamPlayersVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamPlayersVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamPlayersVm>(null as any);
    }

    getNonCaptainPlayers(teamId: number): Promise<NonCaptainTeamPlayersVm> {
        let url_ = this.baseUrl + "/api/Teams/{teamId}/noncaptainplayers";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNonCaptainPlayers(_response);
        });
    }

    protected processGetNonCaptainPlayers(response: Response): Promise<NonCaptainTeamPlayersVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NonCaptainTeamPlayersVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NonCaptainTeamPlayersVm>(null as any);
    }

    create(command: CreateTeamCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Teams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    createTeams(command: CreateTeamsCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Teams/teams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateTeams(_response);
        });
    }

    protected processCreateTeams(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    assignHomeField(command: AssignTeamHomefieldCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Teams/assignhomefield";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssignHomeField(_response);
        });
    }

    protected processAssignHomeField(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    update(teamId: number, command: UpdateTeamCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Teams/{teamId}";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface IUsersClient {

    get(): Promise<UsersVm>;

    getRolesForUsers(userId: string | null): Promise<RolesForUserVm>;

    setRoleForUser(command: SetRolesForUserCommand): Promise<boolean>;
}

export class UsersClient extends ApiClientBase implements IUsersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Promise<UsersVm> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<UsersVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UsersVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UsersVm>(null as any);
    }

    getRolesForUsers(userId: string | null): Promise<RolesForUserVm> {
        let url_ = this.baseUrl + "/api/Users/{userId}/roles";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRolesForUsers(_response);
        });
    }

    protected processGetRolesForUsers(response: Response): Promise<RolesForUserVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RolesForUserVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RolesForUserVm>(null as any);
    }

    setRoleForUser(command: SetRolesForUserCommand): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Users/setroles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetRoleForUser(_response);
        });
    }

    protected processSetRoleForUser(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IWeeksClient {

    getRegularSeasonWeeks(seasonId: number): Promise<RegularSeasonWeeksVm>;

    getPlayoffWeeks(seasonId: number): Promise<PlayoffWeeksVm>;
}

export class WeeksClient extends ApiClientBase implements IWeeksClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getRegularSeasonWeeks(seasonId: number): Promise<RegularSeasonWeeksVm> {
        let url_ = this.baseUrl + "/api/Weeks/{seasonId}/RegularSeason";
        if (seasonId === undefined || seasonId === null)
            throw new Error("The parameter 'seasonId' must be defined.");
        url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRegularSeasonWeeks(_response);
        });
    }

    protected processGetRegularSeasonWeeks(response: Response): Promise<RegularSeasonWeeksVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegularSeasonWeeksVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegularSeasonWeeksVm>(null as any);
    }

    getPlayoffWeeks(seasonId: number): Promise<PlayoffWeeksVm> {
        let url_ = this.baseUrl + "/api/Weeks/{seasonId}/Playoffs";
        if (seasonId === undefined || seasonId === null)
            throw new Error("The parameter 'seasonId' must be defined.");
        url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPlayoffWeeks(_response);
        });
    }

    protected processGetPlayoffWeeks(response: Response): Promise<PlayoffWeeksVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlayoffWeeksVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlayoffWeeksVm>(null as any);
    }
}

export class AdHocMatchSummaryVm implements IAdHocMatchSummaryVm {
    roundId?: number;
    gamePlayedTime?: Date | undefined;
    gameTimeTotal?: string;
    gameMode?: GameModeType;
    serverName?: string | undefined;
    lives?: number;
    attackDefend?: boolean;
    mapPlayed?: AdHocMatchMapsPlayedDto | undefined;
    lineScore?: AdHocMatchLineScoreDto | undefined;
    winnerInfo?: AdHocMatchWinnerInfoDto | undefined;
    roundBoxScore?: AdHocRoundBoxScoreDto | undefined;

    constructor(data?: IAdHocMatchSummaryVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roundId = _data["roundId"];
            this.gamePlayedTime = _data["gamePlayedTime"] ? new Date(_data["gamePlayedTime"].toString()) : <any>undefined;
            this.gameTimeTotal = _data["gameTimeTotal"];
            this.gameMode = _data["gameMode"];
            this.serverName = _data["serverName"];
            this.lives = _data["lives"];
            this.attackDefend = _data["attackDefend"];
            this.mapPlayed = _data["mapPlayed"] ? AdHocMatchMapsPlayedDto.fromJS(_data["mapPlayed"]) : <any>undefined;
            this.lineScore = _data["lineScore"] ? AdHocMatchLineScoreDto.fromJS(_data["lineScore"]) : <any>undefined;
            this.winnerInfo = _data["winnerInfo"] ? AdHocMatchWinnerInfoDto.fromJS(_data["winnerInfo"]) : <any>undefined;
            this.roundBoxScore = _data["roundBoxScore"] ? AdHocRoundBoxScoreDto.fromJS(_data["roundBoxScore"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AdHocMatchSummaryVm {
        data = typeof data === 'object' ? data : {};
        let result = new AdHocMatchSummaryVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roundId"] = this.roundId;
        data["gamePlayedTime"] = this.gamePlayedTime ? this.gamePlayedTime.toISOString() : <any>undefined;
        data["gameTimeTotal"] = this.gameTimeTotal;
        data["gameMode"] = this.gameMode;
        data["serverName"] = this.serverName;
        data["lives"] = this.lives;
        data["attackDefend"] = this.attackDefend;
        data["mapPlayed"] = this.mapPlayed ? this.mapPlayed.toJSON() : <any>undefined;
        data["lineScore"] = this.lineScore ? this.lineScore.toJSON() : <any>undefined;
        data["winnerInfo"] = this.winnerInfo ? this.winnerInfo.toJSON() : <any>undefined;
        data["roundBoxScore"] = this.roundBoxScore ? this.roundBoxScore.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAdHocMatchSummaryVm {
    roundId?: number;
    gamePlayedTime?: Date | undefined;
    gameTimeTotal?: string;
    gameMode?: GameModeType;
    serverName?: string | undefined;
    lives?: number;
    attackDefend?: boolean;
    mapPlayed?: AdHocMatchMapsPlayedDto | undefined;
    lineScore?: AdHocMatchLineScoreDto | undefined;
    winnerInfo?: AdHocMatchWinnerInfoDto | undefined;
    roundBoxScore?: AdHocRoundBoxScoreDto | undefined;
}

export enum GameModeType {
    Coop = 0,
    DeathMatch = 1,
    TeamDeathmatch = 2,
    CaptureTheFlag = 3,
    Horde = 4,
}

export class AdHocMatchMapsPlayedDto implements IAdHocMatchMapsPlayedDto {
    mapNumber?: string | undefined;
    mapName?: string | undefined;

    constructor(data?: IAdHocMatchMapsPlayedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapNumber = _data["mapNumber"];
            this.mapName = _data["mapName"];
        }
    }

    static fromJS(data: any): AdHocMatchMapsPlayedDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdHocMatchMapsPlayedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapNumber"] = this.mapNumber;
        data["mapName"] = this.mapName;
        return data;
    }
}

export interface IAdHocMatchMapsPlayedDto {
    mapNumber?: string | undefined;
    mapName?: string | undefined;
}

export class AdHocMatchLineScoreDto implements IAdHocMatchLineScoreDto {
    roundScore?: AdHocScoreDto | undefined;

    constructor(data?: IAdHocMatchLineScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roundScore = _data["roundScore"] ? AdHocScoreDto.fromJS(_data["roundScore"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AdHocMatchLineScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdHocMatchLineScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roundScore"] = this.roundScore ? this.roundScore.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAdHocMatchLineScoreDto {
    roundScore?: AdHocScoreDto | undefined;
}

export class AdHocScoreDto implements IAdHocScoreDto {
    redScore?: number;
    blueScore?: number;
    greenScore?: number;
    roundWinner?: string | undefined;
    roundDuration?: string;

    constructor(data?: IAdHocScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.redScore = _data["redScore"];
            this.blueScore = _data["blueScore"];
            this.greenScore = _data["greenScore"];
            this.roundWinner = _data["roundWinner"];
            this.roundDuration = _data["roundDuration"];
        }
    }

    static fromJS(data: any): AdHocScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdHocScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["redScore"] = this.redScore;
        data["blueScore"] = this.blueScore;
        data["greenScore"] = this.greenScore;
        data["roundWinner"] = this.roundWinner;
        data["roundDuration"] = this.roundDuration;
        return data;
    }
}

export interface IAdHocScoreDto {
    redScore?: number;
    blueScore?: number;
    greenScore?: number;
    roundWinner?: string | undefined;
    roundDuration?: string;
}

export class AdHocMatchWinnerInfoDto implements IAdHocMatchWinnerInfoDto {
    winner?: string | undefined;

    constructor(data?: IAdHocMatchWinnerInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.winner = _data["winner"];
        }
    }

    static fromJS(data: any): AdHocMatchWinnerInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdHocMatchWinnerInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["winner"] = this.winner;
        return data;
    }
}

export interface IAdHocMatchWinnerInfoDto {
    winner?: string | undefined;
}

export class AdHocRoundBoxScoreDto implements IAdHocRoundBoxScoreDto {
    redTeamBoxScore?: AdHocMatchStatsDto | undefined;
    blueTeamBoxScore?: AdHocMatchStatsDto | undefined;
    greenTeamBoxScore?: AdHocMatchStatsDto | undefined;
    captures?: AdHocMatchCapturesDto[] | undefined;
    redTeamPlayerRoundBoxScore?: AdHocGamePlayersDto[] | undefined;
    blueTeamPlayerRoundBoxScore?: AdHocGamePlayersDto[] | undefined;
    greenTeamPlayerRoundBoxScore?: AdHocGamePlayersDto[] | undefined;
    nonTeamPlayerRoundBoxScore?: AdHocGamePlayersDto[] | undefined;

    constructor(data?: IAdHocRoundBoxScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.redTeamBoxScore = _data["redTeamBoxScore"] ? AdHocMatchStatsDto.fromJS(_data["redTeamBoxScore"]) : <any>undefined;
            this.blueTeamBoxScore = _data["blueTeamBoxScore"] ? AdHocMatchStatsDto.fromJS(_data["blueTeamBoxScore"]) : <any>undefined;
            this.greenTeamBoxScore = _data["greenTeamBoxScore"] ? AdHocMatchStatsDto.fromJS(_data["greenTeamBoxScore"]) : <any>undefined;
            if (Array.isArray(_data["captures"])) {
                this.captures = [] as any;
                for (let item of _data["captures"])
                    this.captures!.push(AdHocMatchCapturesDto.fromJS(item));
            }
            if (Array.isArray(_data["redTeamPlayerRoundBoxScore"])) {
                this.redTeamPlayerRoundBoxScore = [] as any;
                for (let item of _data["redTeamPlayerRoundBoxScore"])
                    this.redTeamPlayerRoundBoxScore!.push(AdHocGamePlayersDto.fromJS(item));
            }
            if (Array.isArray(_data["blueTeamPlayerRoundBoxScore"])) {
                this.blueTeamPlayerRoundBoxScore = [] as any;
                for (let item of _data["blueTeamPlayerRoundBoxScore"])
                    this.blueTeamPlayerRoundBoxScore!.push(AdHocGamePlayersDto.fromJS(item));
            }
            if (Array.isArray(_data["greenTeamPlayerRoundBoxScore"])) {
                this.greenTeamPlayerRoundBoxScore = [] as any;
                for (let item of _data["greenTeamPlayerRoundBoxScore"])
                    this.greenTeamPlayerRoundBoxScore!.push(AdHocGamePlayersDto.fromJS(item));
            }
            if (Array.isArray(_data["nonTeamPlayerRoundBoxScore"])) {
                this.nonTeamPlayerRoundBoxScore = [] as any;
                for (let item of _data["nonTeamPlayerRoundBoxScore"])
                    this.nonTeamPlayerRoundBoxScore!.push(AdHocGamePlayersDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdHocRoundBoxScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdHocRoundBoxScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["redTeamBoxScore"] = this.redTeamBoxScore ? this.redTeamBoxScore.toJSON() : <any>undefined;
        data["blueTeamBoxScore"] = this.blueTeamBoxScore ? this.blueTeamBoxScore.toJSON() : <any>undefined;
        data["greenTeamBoxScore"] = this.greenTeamBoxScore ? this.greenTeamBoxScore.toJSON() : <any>undefined;
        if (Array.isArray(this.captures)) {
            data["captures"] = [];
            for (let item of this.captures)
                data["captures"].push(item.toJSON());
        }
        if (Array.isArray(this.redTeamPlayerRoundBoxScore)) {
            data["redTeamPlayerRoundBoxScore"] = [];
            for (let item of this.redTeamPlayerRoundBoxScore)
                data["redTeamPlayerRoundBoxScore"].push(item.toJSON());
        }
        if (Array.isArray(this.blueTeamPlayerRoundBoxScore)) {
            data["blueTeamPlayerRoundBoxScore"] = [];
            for (let item of this.blueTeamPlayerRoundBoxScore)
                data["blueTeamPlayerRoundBoxScore"].push(item.toJSON());
        }
        if (Array.isArray(this.greenTeamPlayerRoundBoxScore)) {
            data["greenTeamPlayerRoundBoxScore"] = [];
            for (let item of this.greenTeamPlayerRoundBoxScore)
                data["greenTeamPlayerRoundBoxScore"].push(item.toJSON());
        }
        if (Array.isArray(this.nonTeamPlayerRoundBoxScore)) {
            data["nonTeamPlayerRoundBoxScore"] = [];
            for (let item of this.nonTeamPlayerRoundBoxScore)
                data["nonTeamPlayerRoundBoxScore"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAdHocRoundBoxScoreDto {
    redTeamBoxScore?: AdHocMatchStatsDto | undefined;
    blueTeamBoxScore?: AdHocMatchStatsDto | undefined;
    greenTeamBoxScore?: AdHocMatchStatsDto | undefined;
    captures?: AdHocMatchCapturesDto[] | undefined;
    redTeamPlayerRoundBoxScore?: AdHocGamePlayersDto[] | undefined;
    blueTeamPlayerRoundBoxScore?: AdHocGamePlayersDto[] | undefined;
    greenTeamPlayerRoundBoxScore?: AdHocGamePlayersDto[] | undefined;
    nonTeamPlayerRoundBoxScore?: AdHocGamePlayersDto[] | undefined;
}

export class AdHocMatchStatsDto implements IAdHocMatchStatsDto {
    timePlayed?: string;
    points?: number;
    captures?: number;
    pickupCaptures?: number;
    assists?: number;
    damageBetweenTouchAndCaptureMin?: number | undefined;
    damageBetweenTouchAndCaptureMax?: number | undefined;
    damageBetweenTouchAndCaptureAverage?: number | undefined;
    captureTimeMin?: string;
    captureTimeMax?: string;
    captureTimeAverage?: string;
    captureHealthMin?: number | undefined;
    captureHealthMax?: number | undefined;
    captureHealthAverage?: number | undefined;
    captureGreenArmorMin?: number | undefined;
    captureGreenArmorMax?: number | undefined;
    captureGreenArmorAverage?: number | undefined;
    captureBlueArmorMin?: number | undefined;
    captureBlueArmorMax?: number | undefined;
    captureBlueArmorAverage?: number | undefined;
    capturesWithSuperPickups?: number;
    flagCarriersKilledWhileHoldingFlag?: number;
    highestKillsBeforeCapturing?: number;
    pickupCaptureTimeMin?: string;
    pickupCaptureTimeMax?: string;
    pickupCaptureTimeAverage?: string;
    flagTouches?: number;
    pickupFlagTouches?: number;
    flagTouchesWithOverHundredHp?: number;
    flagDefenses?: number;
    flagReturns?: number;
    frags?: number;
    fragsWithFlag?: number;
    deaths?: number;
    environmentalDeaths?: number;
    environmentalFlagCarrierDeaths?: number;
    teamKills?: number;
    suicides?: number;
    suicidesWithFlag?: number;
    longestSpree?: number;
    highestMultiKill?: number;
    pickupHealthGained?: number;
    healthFromNonPowerPickups?: number;
    healthFromPowerPickups?: number;
    healthWhenTouchingFlagMin?: number | undefined;
    healthWhenTouchingFlagMax?: number | undefined;
    healthWhenTouchingFlagAverage?: number | undefined;
    greenArmorWhenTouchingFlagMin?: number | undefined;
    greenArmorWhenTouchingFlagMax?: number | undefined;
    greenArmorWhenTouchingFlagAverage?: number | undefined;
    blueArmorWhenTouchingFlagMin?: number | undefined;
    blueArmorWhenTouchingFlagMax?: number | undefined;
    blueArmorWhenTouchingFlagAverage?: number | undefined;
    healthWhenTouchingFlagThatResultsInCaptureMin?: number | undefined;
    healthWhenTouchingFlagThatResultsInCaptureMax?: number | undefined;
    healthWhenTouchingFlagThatResultsInCaptureAverage?: number | undefined;
    damage?: number;
    selfDamage?: number;
    selfDamageWithFlag?: number;
    damageTakenFromEnvironment?: number;
    damageTakenFromEnvironmentAsFlagCarrier?: number;
    damageToFlagCarriers?: number;
    damageAsFlagCarrier?: number;
    damageAsFlagCarrierWhileHoldingFlag?: number;
    damageToGreenArmor?: number;
    damageToBlueArmor?: number;
    powerups?: number;
    kdr?: number;
    wdlrat?: number;

    constructor(data?: IAdHocMatchStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timePlayed = _data["timePlayed"];
            this.points = _data["points"];
            this.captures = _data["captures"];
            this.pickupCaptures = _data["pickupCaptures"];
            this.assists = _data["assists"];
            this.damageBetweenTouchAndCaptureMin = _data["damageBetweenTouchAndCaptureMin"];
            this.damageBetweenTouchAndCaptureMax = _data["damageBetweenTouchAndCaptureMax"];
            this.damageBetweenTouchAndCaptureAverage = _data["damageBetweenTouchAndCaptureAverage"];
            this.captureTimeMin = _data["captureTimeMin"];
            this.captureTimeMax = _data["captureTimeMax"];
            this.captureTimeAverage = _data["captureTimeAverage"];
            this.captureHealthMin = _data["captureHealthMin"];
            this.captureHealthMax = _data["captureHealthMax"];
            this.captureHealthAverage = _data["captureHealthAverage"];
            this.captureGreenArmorMin = _data["captureGreenArmorMin"];
            this.captureGreenArmorMax = _data["captureGreenArmorMax"];
            this.captureGreenArmorAverage = _data["captureGreenArmorAverage"];
            this.captureBlueArmorMin = _data["captureBlueArmorMin"];
            this.captureBlueArmorMax = _data["captureBlueArmorMax"];
            this.captureBlueArmorAverage = _data["captureBlueArmorAverage"];
            this.capturesWithSuperPickups = _data["capturesWithSuperPickups"];
            this.flagCarriersKilledWhileHoldingFlag = _data["flagCarriersKilledWhileHoldingFlag"];
            this.highestKillsBeforeCapturing = _data["highestKillsBeforeCapturing"];
            this.pickupCaptureTimeMin = _data["pickupCaptureTimeMin"];
            this.pickupCaptureTimeMax = _data["pickupCaptureTimeMax"];
            this.pickupCaptureTimeAverage = _data["pickupCaptureTimeAverage"];
            this.flagTouches = _data["flagTouches"];
            this.pickupFlagTouches = _data["pickupFlagTouches"];
            this.flagTouchesWithOverHundredHp = _data["flagTouchesWithOverHundredHp"];
            this.flagDefenses = _data["flagDefenses"];
            this.flagReturns = _data["flagReturns"];
            this.frags = _data["frags"];
            this.fragsWithFlag = _data["fragsWithFlag"];
            this.deaths = _data["deaths"];
            this.environmentalDeaths = _data["environmentalDeaths"];
            this.environmentalFlagCarrierDeaths = _data["environmentalFlagCarrierDeaths"];
            this.teamKills = _data["teamKills"];
            this.suicides = _data["suicides"];
            this.suicidesWithFlag = _data["suicidesWithFlag"];
            this.longestSpree = _data["longestSpree"];
            this.highestMultiKill = _data["highestMultiKill"];
            this.pickupHealthGained = _data["pickupHealthGained"];
            this.healthFromNonPowerPickups = _data["healthFromNonPowerPickups"];
            this.healthFromPowerPickups = _data["healthFromPowerPickups"];
            this.healthWhenTouchingFlagMin = _data["healthWhenTouchingFlagMin"];
            this.healthWhenTouchingFlagMax = _data["healthWhenTouchingFlagMax"];
            this.healthWhenTouchingFlagAverage = _data["healthWhenTouchingFlagAverage"];
            this.greenArmorWhenTouchingFlagMin = _data["greenArmorWhenTouchingFlagMin"];
            this.greenArmorWhenTouchingFlagMax = _data["greenArmorWhenTouchingFlagMax"];
            this.greenArmorWhenTouchingFlagAverage = _data["greenArmorWhenTouchingFlagAverage"];
            this.blueArmorWhenTouchingFlagMin = _data["blueArmorWhenTouchingFlagMin"];
            this.blueArmorWhenTouchingFlagMax = _data["blueArmorWhenTouchingFlagMax"];
            this.blueArmorWhenTouchingFlagAverage = _data["blueArmorWhenTouchingFlagAverage"];
            this.healthWhenTouchingFlagThatResultsInCaptureMin = _data["healthWhenTouchingFlagThatResultsInCaptureMin"];
            this.healthWhenTouchingFlagThatResultsInCaptureMax = _data["healthWhenTouchingFlagThatResultsInCaptureMax"];
            this.healthWhenTouchingFlagThatResultsInCaptureAverage = _data["healthWhenTouchingFlagThatResultsInCaptureAverage"];
            this.damage = _data["damage"];
            this.selfDamage = _data["selfDamage"];
            this.selfDamageWithFlag = _data["selfDamageWithFlag"];
            this.damageTakenFromEnvironment = _data["damageTakenFromEnvironment"];
            this.damageTakenFromEnvironmentAsFlagCarrier = _data["damageTakenFromEnvironmentAsFlagCarrier"];
            this.damageToFlagCarriers = _data["damageToFlagCarriers"];
            this.damageAsFlagCarrier = _data["damageAsFlagCarrier"];
            this.damageAsFlagCarrierWhileHoldingFlag = _data["damageAsFlagCarrierWhileHoldingFlag"];
            this.damageToGreenArmor = _data["damageToGreenArmor"];
            this.damageToBlueArmor = _data["damageToBlueArmor"];
            this.powerups = _data["powerups"];
            this.kdr = _data["kdr"];
            this.wdlrat = _data["wdlrat"];
        }
    }

    static fromJS(data: any): AdHocMatchStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdHocMatchStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timePlayed"] = this.timePlayed;
        data["points"] = this.points;
        data["captures"] = this.captures;
        data["pickupCaptures"] = this.pickupCaptures;
        data["assists"] = this.assists;
        data["damageBetweenTouchAndCaptureMin"] = this.damageBetweenTouchAndCaptureMin;
        data["damageBetweenTouchAndCaptureMax"] = this.damageBetweenTouchAndCaptureMax;
        data["damageBetweenTouchAndCaptureAverage"] = this.damageBetweenTouchAndCaptureAverage;
        data["captureTimeMin"] = this.captureTimeMin;
        data["captureTimeMax"] = this.captureTimeMax;
        data["captureTimeAverage"] = this.captureTimeAverage;
        data["captureHealthMin"] = this.captureHealthMin;
        data["captureHealthMax"] = this.captureHealthMax;
        data["captureHealthAverage"] = this.captureHealthAverage;
        data["captureGreenArmorMin"] = this.captureGreenArmorMin;
        data["captureGreenArmorMax"] = this.captureGreenArmorMax;
        data["captureGreenArmorAverage"] = this.captureGreenArmorAverage;
        data["captureBlueArmorMin"] = this.captureBlueArmorMin;
        data["captureBlueArmorMax"] = this.captureBlueArmorMax;
        data["captureBlueArmorAverage"] = this.captureBlueArmorAverage;
        data["capturesWithSuperPickups"] = this.capturesWithSuperPickups;
        data["flagCarriersKilledWhileHoldingFlag"] = this.flagCarriersKilledWhileHoldingFlag;
        data["highestKillsBeforeCapturing"] = this.highestKillsBeforeCapturing;
        data["pickupCaptureTimeMin"] = this.pickupCaptureTimeMin;
        data["pickupCaptureTimeMax"] = this.pickupCaptureTimeMax;
        data["pickupCaptureTimeAverage"] = this.pickupCaptureTimeAverage;
        data["flagTouches"] = this.flagTouches;
        data["pickupFlagTouches"] = this.pickupFlagTouches;
        data["flagTouchesWithOverHundredHp"] = this.flagTouchesWithOverHundredHp;
        data["flagDefenses"] = this.flagDefenses;
        data["flagReturns"] = this.flagReturns;
        data["frags"] = this.frags;
        data["fragsWithFlag"] = this.fragsWithFlag;
        data["deaths"] = this.deaths;
        data["environmentalDeaths"] = this.environmentalDeaths;
        data["environmentalFlagCarrierDeaths"] = this.environmentalFlagCarrierDeaths;
        data["teamKills"] = this.teamKills;
        data["suicides"] = this.suicides;
        data["suicidesWithFlag"] = this.suicidesWithFlag;
        data["longestSpree"] = this.longestSpree;
        data["highestMultiKill"] = this.highestMultiKill;
        data["pickupHealthGained"] = this.pickupHealthGained;
        data["healthFromNonPowerPickups"] = this.healthFromNonPowerPickups;
        data["healthFromPowerPickups"] = this.healthFromPowerPickups;
        data["healthWhenTouchingFlagMin"] = this.healthWhenTouchingFlagMin;
        data["healthWhenTouchingFlagMax"] = this.healthWhenTouchingFlagMax;
        data["healthWhenTouchingFlagAverage"] = this.healthWhenTouchingFlagAverage;
        data["greenArmorWhenTouchingFlagMin"] = this.greenArmorWhenTouchingFlagMin;
        data["greenArmorWhenTouchingFlagMax"] = this.greenArmorWhenTouchingFlagMax;
        data["greenArmorWhenTouchingFlagAverage"] = this.greenArmorWhenTouchingFlagAverage;
        data["blueArmorWhenTouchingFlagMin"] = this.blueArmorWhenTouchingFlagMin;
        data["blueArmorWhenTouchingFlagMax"] = this.blueArmorWhenTouchingFlagMax;
        data["blueArmorWhenTouchingFlagAverage"] = this.blueArmorWhenTouchingFlagAverage;
        data["healthWhenTouchingFlagThatResultsInCaptureMin"] = this.healthWhenTouchingFlagThatResultsInCaptureMin;
        data["healthWhenTouchingFlagThatResultsInCaptureMax"] = this.healthWhenTouchingFlagThatResultsInCaptureMax;
        data["healthWhenTouchingFlagThatResultsInCaptureAverage"] = this.healthWhenTouchingFlagThatResultsInCaptureAverage;
        data["damage"] = this.damage;
        data["selfDamage"] = this.selfDamage;
        data["selfDamageWithFlag"] = this.selfDamageWithFlag;
        data["damageTakenFromEnvironment"] = this.damageTakenFromEnvironment;
        data["damageTakenFromEnvironmentAsFlagCarrier"] = this.damageTakenFromEnvironmentAsFlagCarrier;
        data["damageToFlagCarriers"] = this.damageToFlagCarriers;
        data["damageAsFlagCarrier"] = this.damageAsFlagCarrier;
        data["damageAsFlagCarrierWhileHoldingFlag"] = this.damageAsFlagCarrierWhileHoldingFlag;
        data["damageToGreenArmor"] = this.damageToGreenArmor;
        data["damageToBlueArmor"] = this.damageToBlueArmor;
        data["powerups"] = this.powerups;
        data["kdr"] = this.kdr;
        data["wdlrat"] = this.wdlrat;
        return data;
    }
}

export interface IAdHocMatchStatsDto {
    timePlayed?: string;
    points?: number;
    captures?: number;
    pickupCaptures?: number;
    assists?: number;
    damageBetweenTouchAndCaptureMin?: number | undefined;
    damageBetweenTouchAndCaptureMax?: number | undefined;
    damageBetweenTouchAndCaptureAverage?: number | undefined;
    captureTimeMin?: string;
    captureTimeMax?: string;
    captureTimeAverage?: string;
    captureHealthMin?: number | undefined;
    captureHealthMax?: number | undefined;
    captureHealthAverage?: number | undefined;
    captureGreenArmorMin?: number | undefined;
    captureGreenArmorMax?: number | undefined;
    captureGreenArmorAverage?: number | undefined;
    captureBlueArmorMin?: number | undefined;
    captureBlueArmorMax?: number | undefined;
    captureBlueArmorAverage?: number | undefined;
    capturesWithSuperPickups?: number;
    flagCarriersKilledWhileHoldingFlag?: number;
    highestKillsBeforeCapturing?: number;
    pickupCaptureTimeMin?: string;
    pickupCaptureTimeMax?: string;
    pickupCaptureTimeAverage?: string;
    flagTouches?: number;
    pickupFlagTouches?: number;
    flagTouchesWithOverHundredHp?: number;
    flagDefenses?: number;
    flagReturns?: number;
    frags?: number;
    fragsWithFlag?: number;
    deaths?: number;
    environmentalDeaths?: number;
    environmentalFlagCarrierDeaths?: number;
    teamKills?: number;
    suicides?: number;
    suicidesWithFlag?: number;
    longestSpree?: number;
    highestMultiKill?: number;
    pickupHealthGained?: number;
    healthFromNonPowerPickups?: number;
    healthFromPowerPickups?: number;
    healthWhenTouchingFlagMin?: number | undefined;
    healthWhenTouchingFlagMax?: number | undefined;
    healthWhenTouchingFlagAverage?: number | undefined;
    greenArmorWhenTouchingFlagMin?: number | undefined;
    greenArmorWhenTouchingFlagMax?: number | undefined;
    greenArmorWhenTouchingFlagAverage?: number | undefined;
    blueArmorWhenTouchingFlagMin?: number | undefined;
    blueArmorWhenTouchingFlagMax?: number | undefined;
    blueArmorWhenTouchingFlagAverage?: number | undefined;
    healthWhenTouchingFlagThatResultsInCaptureMin?: number | undefined;
    healthWhenTouchingFlagThatResultsInCaptureMax?: number | undefined;
    healthWhenTouchingFlagThatResultsInCaptureAverage?: number | undefined;
    damage?: number;
    selfDamage?: number;
    selfDamageWithFlag?: number;
    damageTakenFromEnvironment?: number;
    damageTakenFromEnvironmentAsFlagCarrier?: number;
    damageToFlagCarriers?: number;
    damageAsFlagCarrier?: number;
    damageAsFlagCarrierWhileHoldingFlag?: number;
    damageToGreenArmor?: number;
    damageToBlueArmor?: number;
    powerups?: number;
    kdr?: number;
    wdlrat?: number;
}

export class AdHocMatchCapturesDto implements IAdHocMatchCapturesDto {
    playerName?: string | undefined;
    teamName?: string | undefined;
    teamColor?: string | undefined;
    captureNumber?: number;
    eventTime?: string;
    captureAmountTime?: string;
    assists?: AdHocMatchAssistDto[] | undefined;

    constructor(data?: IAdHocMatchCapturesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerName = _data["playerName"];
            this.teamName = _data["teamName"];
            this.teamColor = _data["teamColor"];
            this.captureNumber = _data["captureNumber"];
            this.eventTime = _data["eventTime"];
            this.captureAmountTime = _data["captureAmountTime"];
            if (Array.isArray(_data["assists"])) {
                this.assists = [] as any;
                for (let item of _data["assists"])
                    this.assists!.push(AdHocMatchAssistDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdHocMatchCapturesDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdHocMatchCapturesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerName"] = this.playerName;
        data["teamName"] = this.teamName;
        data["teamColor"] = this.teamColor;
        data["captureNumber"] = this.captureNumber;
        data["eventTime"] = this.eventTime;
        data["captureAmountTime"] = this.captureAmountTime;
        if (Array.isArray(this.assists)) {
            data["assists"] = [];
            for (let item of this.assists)
                data["assists"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAdHocMatchCapturesDto {
    playerName?: string | undefined;
    teamName?: string | undefined;
    teamColor?: string | undefined;
    captureNumber?: number;
    eventTime?: string;
    captureAmountTime?: string;
    assists?: AdHocMatchAssistDto[] | undefined;
}

export class AdHocMatchAssistDto implements IAdHocMatchAssistDto {
    playerName?: string | undefined;
    teamColor?: string | undefined;
    captureNumber?: number;
    eventTime?: string;

    constructor(data?: IAdHocMatchAssistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerName = _data["playerName"];
            this.teamColor = _data["teamColor"];
            this.captureNumber = _data["captureNumber"];
            this.eventTime = _data["eventTime"];
        }
    }

    static fromJS(data: any): AdHocMatchAssistDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdHocMatchAssistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerName"] = this.playerName;
        data["teamColor"] = this.teamColor;
        data["captureNumber"] = this.captureNumber;
        data["eventTime"] = this.eventTime;
        return data;
    }
}

export interface IAdHocMatchAssistDto {
    playerName?: string | undefined;
    teamColor?: string | undefined;
    captureNumber?: number;
    eventTime?: string;
}

export class AdHocGamePlayersDto implements IAdHocGamePlayersDto {
    playerId?: number;
    playerName?: string | undefined;
    accuracyStats?: AdHocAccuracyStatsDto | undefined;
    killStats?: AdHocKillStatsDto | undefined;
    damageStats?: AdHocDamageStatsDto | undefined;
    matchStats?: AdHocMatchStatsDto | undefined;

    constructor(data?: IAdHocGamePlayersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.playerName = _data["playerName"];
            this.accuracyStats = _data["accuracyStats"] ? AdHocAccuracyStatsDto.fromJS(_data["accuracyStats"]) : <any>undefined;
            this.killStats = _data["killStats"] ? AdHocKillStatsDto.fromJS(_data["killStats"]) : <any>undefined;
            this.damageStats = _data["damageStats"] ? AdHocDamageStatsDto.fromJS(_data["damageStats"]) : <any>undefined;
            this.matchStats = _data["matchStats"] ? AdHocMatchStatsDto.fromJS(_data["matchStats"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AdHocGamePlayersDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdHocGamePlayersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["playerName"] = this.playerName;
        data["accuracyStats"] = this.accuracyStats ? this.accuracyStats.toJSON() : <any>undefined;
        data["killStats"] = this.killStats ? this.killStats.toJSON() : <any>undefined;
        data["damageStats"] = this.damageStats ? this.damageStats.toJSON() : <any>undefined;
        data["matchStats"] = this.matchStats ? this.matchStats.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAdHocGamePlayersDto {
    playerId?: number;
    playerName?: string | undefined;
    accuracyStats?: AdHocAccuracyStatsDto | undefined;
    killStats?: AdHocKillStatsDto | undefined;
    damageStats?: AdHocDamageStatsDto | undefined;
    matchStats?: AdHocMatchStatsDto | undefined;
}

export class AdHocAccuracyStatsDto implements IAdHocAccuracyStatsDto {
    accuracyByWeapon?: AdHocAccuracyByWeaponDto[] | undefined;
    accuracyByWeaponWithFlag?: AdHocAccuracyByWeaponDto[] | undefined;

    constructor(data?: IAdHocAccuracyStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accuracyByWeapon"])) {
                this.accuracyByWeapon = [] as any;
                for (let item of _data["accuracyByWeapon"])
                    this.accuracyByWeapon!.push(AdHocAccuracyByWeaponDto.fromJS(item));
            }
            if (Array.isArray(_data["accuracyByWeaponWithFlag"])) {
                this.accuracyByWeaponWithFlag = [] as any;
                for (let item of _data["accuracyByWeaponWithFlag"])
                    this.accuracyByWeaponWithFlag!.push(AdHocAccuracyByWeaponDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdHocAccuracyStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdHocAccuracyStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accuracyByWeapon)) {
            data["accuracyByWeapon"] = [];
            for (let item of this.accuracyByWeapon)
                data["accuracyByWeapon"].push(item.toJSON());
        }
        if (Array.isArray(this.accuracyByWeaponWithFlag)) {
            data["accuracyByWeaponWithFlag"] = [];
            for (let item of this.accuracyByWeaponWithFlag)
                data["accuracyByWeaponWithFlag"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAdHocAccuracyStatsDto {
    accuracyByWeapon?: AdHocAccuracyByWeaponDto[] | undefined;
    accuracyByWeaponWithFlag?: AdHocAccuracyByWeaponDto[] | undefined;
}

export class AdHocAccuracyByWeaponDto implements IAdHocAccuracyByWeaponDto {
    weapon?: Mods;
    accuracy?: AdHocAccuracyDto[] | undefined;

    constructor(data?: IAdHocAccuracyByWeaponDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weapon = _data["weapon"];
            if (Array.isArray(_data["accuracy"])) {
                this.accuracy = [] as any;
                for (let item of _data["accuracy"])
                    this.accuracy!.push(AdHocAccuracyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdHocAccuracyByWeaponDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdHocAccuracyByWeaponDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weapon"] = this.weapon;
        if (Array.isArray(this.accuracy)) {
            data["accuracy"] = [];
            for (let item of this.accuracy)
                data["accuracy"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAdHocAccuracyByWeaponDto {
    weapon?: Mods;
    accuracy?: AdHocAccuracyDto[] | undefined;
}

export enum Mods {
    Unknown = "Unknown",
    Fist = "Fist",
    Pistol = "Pistol",
    Shotgun = "Shotgun",
    Chaingun = "Chaingun",
    Rocket = "Rocket",
    RocketSplash = "RocketSplash",
    PlasmaRifle = "PlasmaRifle",
    BfgBall = "BfgBall",
    BfgSplash = "BfgSplash",
    Chainsaw = "Chainsaw",
    SuperShotgun = "SuperShotgun",
    Water = "Water",
    Slime = "Slime",
    Lava = "Lava",
    Crusher = "Crusher",
    Telefrag = "Telefrag",
    Falling = "Falling",
    Suicide = "Suicide",
    Barrel = "Barrel",
    Exit = "Exit",
    Splash = "Splash",
    Hit = "Hit",
    Railgun = "Railgun",
}

export class AdHocAccuracyDto implements IAdHocAccuracyDto {
    hitMissRatio?: number;
    spritePercent?: number;
    pinpointPercent?: number;
    totalShotsHit?: number;
    totalShotsMissed?: number;
    totalShotsAttempted?: number;
    totalPelletsHit?: number;
    totalPelletsMissed?: number;
    totalPelletsAttempted?: number;

    constructor(data?: IAdHocAccuracyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hitMissRatio = _data["hitMissRatio"];
            this.spritePercent = _data["spritePercent"];
            this.pinpointPercent = _data["pinpointPercent"];
            this.totalShotsHit = _data["totalShotsHit"];
            this.totalShotsMissed = _data["totalShotsMissed"];
            this.totalShotsAttempted = _data["totalShotsAttempted"];
            this.totalPelletsHit = _data["totalPelletsHit"];
            this.totalPelletsMissed = _data["totalPelletsMissed"];
            this.totalPelletsAttempted = _data["totalPelletsAttempted"];
        }
    }

    static fromJS(data: any): AdHocAccuracyDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdHocAccuracyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hitMissRatio"] = this.hitMissRatio;
        data["spritePercent"] = this.spritePercent;
        data["pinpointPercent"] = this.pinpointPercent;
        data["totalShotsHit"] = this.totalShotsHit;
        data["totalShotsMissed"] = this.totalShotsMissed;
        data["totalShotsAttempted"] = this.totalShotsAttempted;
        data["totalPelletsHit"] = this.totalPelletsHit;
        data["totalPelletsMissed"] = this.totalPelletsMissed;
        data["totalPelletsAttempted"] = this.totalPelletsAttempted;
        return data;
    }
}

export interface IAdHocAccuracyDto {
    hitMissRatio?: number;
    spritePercent?: number;
    pinpointPercent?: number;
    totalShotsHit?: number;
    totalShotsMissed?: number;
    totalShotsAttempted?: number;
    totalPelletsHit?: number;
    totalPelletsMissed?: number;
    totalPelletsAttempted?: number;
}

export class AdHocKillStatsDto implements IAdHocKillStatsDto {
    killsByWeapon?: AdHocKillByWeaponDto[] | undefined;
    killsByWeaponWithFlag?: AdHocKillByWeaponDto[] | undefined;
    carrierKillsByWeapon?: AdHocKillByWeaponDto[] | undefined;
    carrierKillsByWeaponWithFlag?: AdHocKillByWeaponDto[] | undefined;

    constructor(data?: IAdHocKillStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["killsByWeapon"])) {
                this.killsByWeapon = [] as any;
                for (let item of _data["killsByWeapon"])
                    this.killsByWeapon!.push(AdHocKillByWeaponDto.fromJS(item));
            }
            if (Array.isArray(_data["killsByWeaponWithFlag"])) {
                this.killsByWeaponWithFlag = [] as any;
                for (let item of _data["killsByWeaponWithFlag"])
                    this.killsByWeaponWithFlag!.push(AdHocKillByWeaponDto.fromJS(item));
            }
            if (Array.isArray(_data["carrierKillsByWeapon"])) {
                this.carrierKillsByWeapon = [] as any;
                for (let item of _data["carrierKillsByWeapon"])
                    this.carrierKillsByWeapon!.push(AdHocKillByWeaponDto.fromJS(item));
            }
            if (Array.isArray(_data["carrierKillsByWeaponWithFlag"])) {
                this.carrierKillsByWeaponWithFlag = [] as any;
                for (let item of _data["carrierKillsByWeaponWithFlag"])
                    this.carrierKillsByWeaponWithFlag!.push(AdHocKillByWeaponDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdHocKillStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdHocKillStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.killsByWeapon)) {
            data["killsByWeapon"] = [];
            for (let item of this.killsByWeapon)
                data["killsByWeapon"].push(item.toJSON());
        }
        if (Array.isArray(this.killsByWeaponWithFlag)) {
            data["killsByWeaponWithFlag"] = [];
            for (let item of this.killsByWeaponWithFlag)
                data["killsByWeaponWithFlag"].push(item.toJSON());
        }
        if (Array.isArray(this.carrierKillsByWeapon)) {
            data["carrierKillsByWeapon"] = [];
            for (let item of this.carrierKillsByWeapon)
                data["carrierKillsByWeapon"].push(item.toJSON());
        }
        if (Array.isArray(this.carrierKillsByWeaponWithFlag)) {
            data["carrierKillsByWeaponWithFlag"] = [];
            for (let item of this.carrierKillsByWeaponWithFlag)
                data["carrierKillsByWeaponWithFlag"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAdHocKillStatsDto {
    killsByWeapon?: AdHocKillByWeaponDto[] | undefined;
    killsByWeaponWithFlag?: AdHocKillByWeaponDto[] | undefined;
    carrierKillsByWeapon?: AdHocKillByWeaponDto[] | undefined;
    carrierKillsByWeaponWithFlag?: AdHocKillByWeaponDto[] | undefined;
}

export class AdHocKillByWeaponDto implements IAdHocKillByWeaponDto {
    weapon?: Mods;
    kills?: AdHocKillDto[] | undefined;

    constructor(data?: IAdHocKillByWeaponDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weapon = _data["weapon"];
            if (Array.isArray(_data["kills"])) {
                this.kills = [] as any;
                for (let item of _data["kills"])
                    this.kills!.push(AdHocKillDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdHocKillByWeaponDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdHocKillByWeaponDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weapon"] = this.weapon;
        if (Array.isArray(this.kills)) {
            data["kills"] = [];
            for (let item of this.kills)
                data["kills"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAdHocKillByWeaponDto {
    weapon?: Mods;
    kills?: AdHocKillDto[] | undefined;
}

export class AdHocKillDto implements IAdHocKillDto {
    targetId?: number;
    targetName?: string | undefined;
    kills?: number;

    constructor(data?: IAdHocKillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetId = _data["targetId"];
            this.targetName = _data["targetName"];
            this.kills = _data["kills"];
        }
    }

    static fromJS(data: any): AdHocKillDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdHocKillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetId"] = this.targetId;
        data["targetName"] = this.targetName;
        data["kills"] = this.kills;
        return data;
    }
}

export interface IAdHocKillDto {
    targetId?: number;
    targetName?: string | undefined;
    kills?: number;
}

export class AdHocDamageStatsDto implements IAdHocDamageStatsDto {
    damageByWeapon?: AdHocDamageByWeaponDto[] | undefined;
    damageByWeaponWithFlag?: AdHocDamageByWeaponDto[] | undefined;
    carrierDamageByWeapon?: AdHocDamageByWeaponDto[] | undefined;
    carrierDamageByWeaponWithFlag?: AdHocDamageByWeaponDto[] | undefined;

    constructor(data?: IAdHocDamageStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["damageByWeapon"])) {
                this.damageByWeapon = [] as any;
                for (let item of _data["damageByWeapon"])
                    this.damageByWeapon!.push(AdHocDamageByWeaponDto.fromJS(item));
            }
            if (Array.isArray(_data["damageByWeaponWithFlag"])) {
                this.damageByWeaponWithFlag = [] as any;
                for (let item of _data["damageByWeaponWithFlag"])
                    this.damageByWeaponWithFlag!.push(AdHocDamageByWeaponDto.fromJS(item));
            }
            if (Array.isArray(_data["carrierDamageByWeapon"])) {
                this.carrierDamageByWeapon = [] as any;
                for (let item of _data["carrierDamageByWeapon"])
                    this.carrierDamageByWeapon!.push(AdHocDamageByWeaponDto.fromJS(item));
            }
            if (Array.isArray(_data["carrierDamageByWeaponWithFlag"])) {
                this.carrierDamageByWeaponWithFlag = [] as any;
                for (let item of _data["carrierDamageByWeaponWithFlag"])
                    this.carrierDamageByWeaponWithFlag!.push(AdHocDamageByWeaponDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdHocDamageStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdHocDamageStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.damageByWeapon)) {
            data["damageByWeapon"] = [];
            for (let item of this.damageByWeapon)
                data["damageByWeapon"].push(item.toJSON());
        }
        if (Array.isArray(this.damageByWeaponWithFlag)) {
            data["damageByWeaponWithFlag"] = [];
            for (let item of this.damageByWeaponWithFlag)
                data["damageByWeaponWithFlag"].push(item.toJSON());
        }
        if (Array.isArray(this.carrierDamageByWeapon)) {
            data["carrierDamageByWeapon"] = [];
            for (let item of this.carrierDamageByWeapon)
                data["carrierDamageByWeapon"].push(item.toJSON());
        }
        if (Array.isArray(this.carrierDamageByWeaponWithFlag)) {
            data["carrierDamageByWeaponWithFlag"] = [];
            for (let item of this.carrierDamageByWeaponWithFlag)
                data["carrierDamageByWeaponWithFlag"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAdHocDamageStatsDto {
    damageByWeapon?: AdHocDamageByWeaponDto[] | undefined;
    damageByWeaponWithFlag?: AdHocDamageByWeaponDto[] | undefined;
    carrierDamageByWeapon?: AdHocDamageByWeaponDto[] | undefined;
    carrierDamageByWeaponWithFlag?: AdHocDamageByWeaponDto[] | undefined;
}

export class AdHocDamageByWeaponDto implements IAdHocDamageByWeaponDto {
    weapon?: Mods;
    damage?: AdHocDamageDto[] | undefined;

    constructor(data?: IAdHocDamageByWeaponDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weapon = _data["weapon"];
            if (Array.isArray(_data["damage"])) {
                this.damage = [] as any;
                for (let item of _data["damage"])
                    this.damage!.push(AdHocDamageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdHocDamageByWeaponDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdHocDamageByWeaponDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weapon"] = this.weapon;
        if (Array.isArray(this.damage)) {
            data["damage"] = [];
            for (let item of this.damage)
                data["damage"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAdHocDamageByWeaponDto {
    weapon?: Mods;
    damage?: AdHocDamageDto[] | undefined;
}

export class AdHocDamageDto implements IAdHocDamageDto {
    targetId?: number;
    targetName?: string | undefined;
    damage?: number;
    greenArmor?: number;
    blueArmor?: number;

    constructor(data?: IAdHocDamageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetId = _data["targetId"];
            this.targetName = _data["targetName"];
            this.damage = _data["damage"];
            this.greenArmor = _data["greenArmor"];
            this.blueArmor = _data["blueArmor"];
        }
    }

    static fromJS(data: any): AdHocDamageDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdHocDamageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetId"] = this.targetId;
        data["targetName"] = this.targetName;
        data["damage"] = this.damage;
        data["greenArmor"] = this.greenArmor;
        data["blueArmor"] = this.blueArmor;
        return data;
    }
}

export interface IAdHocDamageDto {
    targetId?: number;
    targetName?: string | undefined;
    damage?: number;
    greenArmor?: number;
    blueArmor?: number;
}

export class MyDemoVm implements IMyDemoVm {
    demoList?: MyDemoDto[] | undefined;

    constructor(data?: IMyDemoVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["demoList"])) {
                this.demoList = [] as any;
                for (let item of _data["demoList"])
                    this.demoList!.push(MyDemoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MyDemoVm {
        data = typeof data === 'object' ? data : {};
        let result = new MyDemoVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.demoList)) {
            data["demoList"] = [];
            for (let item of this.demoList)
                data["demoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMyDemoVm {
    demoList?: MyDemoDto[] | undefined;
}

export class MyDemoDto implements IMyDemoDto {
    id?: number;
    isUploaded?: boolean;
    playerLostDemo?: boolean;
    fileName?: string | undefined;
    gameName?: string | undefined;
    demoSeason?: string | undefined;

    constructor(data?: IMyDemoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isUploaded = _data["isUploaded"];
            this.playerLostDemo = _data["playerLostDemo"];
            this.fileName = _data["fileName"];
            this.gameName = _data["gameName"];
            this.demoSeason = _data["demoSeason"];
        }
    }

    static fromJS(data: any): MyDemoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyDemoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isUploaded"] = this.isUploaded;
        data["playerLostDemo"] = this.playerLostDemo;
        data["fileName"] = this.fileName;
        data["gameName"] = this.gameName;
        data["demoSeason"] = this.demoSeason;
        return data;
    }
}

export interface IMyDemoDto {
    id?: number;
    isUploaded?: boolean;
    playerLostDemo?: boolean;
    fileName?: string | undefined;
    gameName?: string | undefined;
    demoSeason?: string | undefined;
}

export class DemoVm implements IDemoVm {
    demoList?: DemoDto[] | undefined;

    constructor(data?: IDemoVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["demoList"])) {
                this.demoList = [] as any;
                for (let item of _data["demoList"])
                    this.demoList!.push(DemoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DemoVm {
        data = typeof data === 'object' ? data : {};
        let result = new DemoVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.demoList)) {
            data["demoList"] = [];
            for (let item of this.demoList)
                data["demoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDemoVm {
    demoList?: DemoDto[] | undefined;
}

export class DemoDto implements IDemoDto {
    id?: number;
    playerId?: number;
    playerName?: string | undefined;
    isUploaded?: boolean;
    playerLostDemo?: boolean;
    fileName?: string | undefined;
    demoLink?: string | undefined;
    gameName?: string | undefined;
    demoSeason?: string | undefined;
    enginePlayed?: string | undefined;
    engineLink?: string | undefined;
    wadLink?: string | undefined;
    wadPlayed?: string | undefined;

    constructor(data?: IDemoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.playerId = _data["playerId"];
            this.playerName = _data["playerName"];
            this.isUploaded = _data["isUploaded"];
            this.playerLostDemo = _data["playerLostDemo"];
            this.fileName = _data["fileName"];
            this.demoLink = _data["demoLink"];
            this.gameName = _data["gameName"];
            this.demoSeason = _data["demoSeason"];
            this.enginePlayed = _data["enginePlayed"];
            this.engineLink = _data["engineLink"];
            this.wadLink = _data["wadLink"];
            this.wadPlayed = _data["wadPlayed"];
        }
    }

    static fromJS(data: any): DemoDto {
        data = typeof data === 'object' ? data : {};
        let result = new DemoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["playerId"] = this.playerId;
        data["playerName"] = this.playerName;
        data["isUploaded"] = this.isUploaded;
        data["playerLostDemo"] = this.playerLostDemo;
        data["fileName"] = this.fileName;
        data["demoLink"] = this.demoLink;
        data["gameName"] = this.gameName;
        data["demoSeason"] = this.demoSeason;
        data["enginePlayed"] = this.enginePlayed;
        data["engineLink"] = this.engineLink;
        data["wadLink"] = this.wadLink;
        data["wadPlayed"] = this.wadPlayed;
        return data;
    }
}

export interface IDemoDto {
    id?: number;
    playerId?: number;
    playerName?: string | undefined;
    isUploaded?: boolean;
    playerLostDemo?: boolean;
    fileName?: string | undefined;
    demoLink?: string | undefined;
    gameName?: string | undefined;
    demoSeason?: string | undefined;
    enginePlayed?: string | undefined;
    engineLink?: string | undefined;
    wadLink?: string | undefined;
    wadPlayed?: string | undefined;
}

export enum GameType {
    All = "All Game Types",
    RegularSeason = "Regular Season",
    Playoffs = "Playoffs",
    Finals = "Finals",
}

export class UnapprovedDemoVm implements IUnapprovedDemoVm {
    demoList?: UnapprovedDemoDto[] | undefined;

    constructor(data?: IUnapprovedDemoVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["demoList"])) {
                this.demoList = [] as any;
                for (let item of _data["demoList"])
                    this.demoList!.push(UnapprovedDemoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UnapprovedDemoVm {
        data = typeof data === 'object' ? data : {};
        let result = new UnapprovedDemoVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.demoList)) {
            data["demoList"] = [];
            for (let item of this.demoList)
                data["demoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUnapprovedDemoVm {
    demoList?: UnapprovedDemoDto[] | undefined;
}

export class UnapprovedDemoDto implements IUnapprovedDemoDto {
    id?: number;
    isUploaded?: boolean;
    playerLostDemo?: boolean;
    fileName?: string | undefined;
    gameName?: string | undefined;
    demoSeason?: string | undefined;
    playerName?: string | undefined;
    playerId?: number;
    teamName?: string | undefined;
    teamId?: number;

    constructor(data?: IUnapprovedDemoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isUploaded = _data["isUploaded"];
            this.playerLostDemo = _data["playerLostDemo"];
            this.fileName = _data["fileName"];
            this.gameName = _data["gameName"];
            this.demoSeason = _data["demoSeason"];
            this.playerName = _data["playerName"];
            this.playerId = _data["playerId"];
            this.teamName = _data["teamName"];
            this.teamId = _data["teamId"];
        }
    }

    static fromJS(data: any): UnapprovedDemoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnapprovedDemoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isUploaded"] = this.isUploaded;
        data["playerLostDemo"] = this.playerLostDemo;
        data["fileName"] = this.fileName;
        data["gameName"] = this.gameName;
        data["demoSeason"] = this.demoSeason;
        data["playerName"] = this.playerName;
        data["playerId"] = this.playerId;
        data["teamName"] = this.teamName;
        data["teamId"] = this.teamId;
        return data;
    }
}

export interface IUnapprovedDemoDto {
    id?: number;
    isUploaded?: boolean;
    playerLostDemo?: boolean;
    fileName?: string | undefined;
    gameName?: string | undefined;
    demoSeason?: string | undefined;
    playerName?: string | undefined;
    playerId?: number;
    teamName?: string | undefined;
    teamId?: number;
}

export class OutstandingDemoVm implements IOutstandingDemoVm {
    demoList?: OutstandingWeekDemoDto[] | undefined;

    constructor(data?: IOutstandingDemoVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["demoList"])) {
                this.demoList = [] as any;
                for (let item of _data["demoList"])
                    this.demoList!.push(OutstandingWeekDemoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OutstandingDemoVm {
        data = typeof data === 'object' ? data : {};
        let result = new OutstandingDemoVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.demoList)) {
            data["demoList"] = [];
            for (let item of this.demoList)
                data["demoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOutstandingDemoVm {
    demoList?: OutstandingWeekDemoDto[] | undefined;
}

export class OutstandingWeekDemoDto implements IOutstandingWeekDemoDto {
    weekNumber?: number;
    weekType?: string | undefined;
    outstandingDemos?: OutstandingDemoDto[] | undefined;

    constructor(data?: IOutstandingWeekDemoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekNumber = _data["weekNumber"];
            this.weekType = _data["weekType"];
            if (Array.isArray(_data["outstandingDemos"])) {
                this.outstandingDemos = [] as any;
                for (let item of _data["outstandingDemos"])
                    this.outstandingDemos!.push(OutstandingDemoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OutstandingWeekDemoDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutstandingWeekDemoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weekNumber"] = this.weekNumber;
        data["weekType"] = this.weekType;
        if (Array.isArray(this.outstandingDemos)) {
            data["outstandingDemos"] = [];
            for (let item of this.outstandingDemos)
                data["outstandingDemos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOutstandingWeekDemoDto {
    weekNumber?: number;
    weekType?: string | undefined;
    outstandingDemos?: OutstandingDemoDto[] | undefined;
}

export class OutstandingDemoDto implements IOutstandingDemoDto {
    id?: number;
    playerId?: number;
    teamId?: number;
    playerName?: string | undefined;
    teamName?: string | undefined;
    isUploaded?: boolean;
    playerLostDemo?: boolean;
    demoAdminApproved?: boolean;
    demoLink?: string | undefined;
    gameName?: string | undefined;
    demoSeason?: string | undefined;
    enginePlayed?: string | undefined;
    engineLink?: string | undefined;
    wadLink?: string | undefined;
    wadPlayed?: string | undefined;
    weekNumber?: number;
    weekType?: string | undefined;

    constructor(data?: IOutstandingDemoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.playerId = _data["playerId"];
            this.teamId = _data["teamId"];
            this.playerName = _data["playerName"];
            this.teamName = _data["teamName"];
            this.isUploaded = _data["isUploaded"];
            this.playerLostDemo = _data["playerLostDemo"];
            this.demoAdminApproved = _data["demoAdminApproved"];
            this.demoLink = _data["demoLink"];
            this.gameName = _data["gameName"];
            this.demoSeason = _data["demoSeason"];
            this.enginePlayed = _data["enginePlayed"];
            this.engineLink = _data["engineLink"];
            this.wadLink = _data["wadLink"];
            this.wadPlayed = _data["wadPlayed"];
            this.weekNumber = _data["weekNumber"];
            this.weekType = _data["weekType"];
        }
    }

    static fromJS(data: any): OutstandingDemoDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutstandingDemoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["playerId"] = this.playerId;
        data["teamId"] = this.teamId;
        data["playerName"] = this.playerName;
        data["teamName"] = this.teamName;
        data["isUploaded"] = this.isUploaded;
        data["playerLostDemo"] = this.playerLostDemo;
        data["demoAdminApproved"] = this.demoAdminApproved;
        data["demoLink"] = this.demoLink;
        data["gameName"] = this.gameName;
        data["demoSeason"] = this.demoSeason;
        data["enginePlayed"] = this.enginePlayed;
        data["engineLink"] = this.engineLink;
        data["wadLink"] = this.wadLink;
        data["wadPlayed"] = this.wadPlayed;
        data["weekNumber"] = this.weekNumber;
        data["weekType"] = this.weekType;
        return data;
    }
}

export interface IOutstandingDemoDto {
    id?: number;
    playerId?: number;
    teamId?: number;
    playerName?: string | undefined;
    teamName?: string | undefined;
    isUploaded?: boolean;
    playerLostDemo?: boolean;
    demoAdminApproved?: boolean;
    demoLink?: string | undefined;
    gameName?: string | undefined;
    demoSeason?: string | undefined;
    enginePlayed?: string | undefined;
    engineLink?: string | undefined;
    wadLink?: string | undefined;
    wadPlayed?: string | undefined;
    weekNumber?: number;
    weekType?: string | undefined;
}

export class MarkDemoAsMissingCommand implements IMarkDemoAsMissingCommand {
    demoId?: number;

    constructor(data?: IMarkDemoAsMissingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.demoId = _data["demoId"];
        }
    }

    static fromJS(data: any): MarkDemoAsMissingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MarkDemoAsMissingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["demoId"] = this.demoId;
        return data;
    }
}

export interface IMarkDemoAsMissingCommand {
    demoId?: number;
}

export class ApproveDemoCommand implements IApproveDemoCommand {
    demoId?: number;

    constructor(data?: IApproveDemoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.demoId = _data["demoId"];
        }
    }

    static fromJS(data: any): ApproveDemoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveDemoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["demoId"] = this.demoId;
        return data;
    }
}

export interface IApproveDemoCommand {
    demoId?: number;
}

export class RejectDemoCommand implements IRejectDemoCommand {
    demoId?: number;

    constructor(data?: IRejectDemoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.demoId = _data["demoId"];
        }
    }

    static fromJS(data: any): RejectDemoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RejectDemoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["demoId"] = this.demoId;
        return data;
    }
}

export interface IRejectDemoCommand {
    demoId?: number;
}

export class CreateDraftCommand implements ICreateDraftCommand {
    season?: number;
    draftRequestList?: DraftRequest[] | undefined;

    constructor(data?: ICreateDraftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.season = _data["season"];
            if (Array.isArray(_data["draftRequestList"])) {
                this.draftRequestList = [] as any;
                for (let item of _data["draftRequestList"])
                    this.draftRequestList!.push(DraftRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateDraftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDraftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["season"] = this.season;
        if (Array.isArray(this.draftRequestList)) {
            data["draftRequestList"] = [];
            for (let item of this.draftRequestList)
                data["draftRequestList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateDraftCommand {
    season?: number;
    draftRequestList?: DraftRequest[] | undefined;
}

export class DraftRequest implements IDraftRequest {
    nominatingPlayer?: number;
    nominatedPlayer?: number;
    playerSoldTo?: number;
    sellPrice?: number;

    constructor(data?: IDraftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nominatingPlayer = _data["nominatingPlayer"];
            this.nominatedPlayer = _data["nominatedPlayer"];
            this.playerSoldTo = _data["playerSoldTo"];
            this.sellPrice = _data["sellPrice"];
        }
    }

    static fromJS(data: any): DraftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DraftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nominatingPlayer"] = this.nominatingPlayer;
        data["nominatedPlayer"] = this.nominatedPlayer;
        data["playerSoldTo"] = this.playerSoldTo;
        data["sellPrice"] = this.sellPrice;
        return data;
    }
}

export interface IDraftRequest {
    nominatingPlayer?: number;
    nominatedPlayer?: number;
    playerSoldTo?: number;
    sellPrice?: number;
}

export class EnginesVm implements IEnginesVm {
    engineList?: EnginesDto[] | undefined;

    constructor(data?: IEnginesVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["engineList"])) {
                this.engineList = [] as any;
                for (let item of _data["engineList"])
                    this.engineList!.push(EnginesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnginesVm {
        data = typeof data === 'object' ? data : {};
        let result = new EnginesVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.engineList)) {
            data["engineList"] = [];
            for (let item of this.engineList)
                data["engineList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEnginesVm {
    engineList?: EnginesDto[] | undefined;
}

export class EnginesDto implements IEnginesDto {
    id?: number;
    engineName?: string | undefined;
    engineUrl?: string | undefined;

    constructor(data?: IEnginesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.engineName = _data["engineName"];
            this.engineUrl = _data["engineUrl"];
        }
    }

    static fromJS(data: any): EnginesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnginesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["engineName"] = this.engineName;
        data["engineUrl"] = this.engineUrl;
        return data;
    }
}

export interface IEnginesDto {
    id?: number;
    engineName?: string | undefined;
    engineUrl?: string | undefined;
}

export class CreateEngineCommand implements ICreateEngineCommand {
    engineName?: string | undefined;
    engineUrl?: string | undefined;

    constructor(data?: ICreateEngineCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.engineName = _data["engineName"];
            this.engineUrl = _data["engineUrl"];
        }
    }

    static fromJS(data: any): CreateEngineCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEngineCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["engineName"] = this.engineName;
        data["engineUrl"] = this.engineUrl;
        return data;
    }
}

export interface ICreateEngineCommand {
    engineName?: string | undefined;
    engineUrl?: string | undefined;
}

export class UpdateEngineCommand implements IUpdateEngineCommand {
    engineId?: number;
    engineName?: string | undefined;
    engineUrl?: string | undefined;

    constructor(data?: IUpdateEngineCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.engineId = _data["engineId"];
            this.engineName = _data["engineName"];
            this.engineUrl = _data["engineUrl"];
        }
    }

    static fromJS(data: any): UpdateEngineCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEngineCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["engineId"] = this.engineId;
        data["engineName"] = this.engineName;
        data["engineUrl"] = this.engineUrl;
        return data;
    }
}

export interface IUpdateEngineCommand {
    engineId?: number;
    engineName?: string | undefined;
    engineUrl?: string | undefined;
}

export class ChangeMapImagesPriorityCommand implements IChangeMapImagesPriorityCommand {
    mapId?: number;
    imagePriority?: ImagePriorityObject[] | undefined;

    constructor(data?: IChangeMapImagesPriorityCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapId = _data["mapId"];
            if (Array.isArray(_data["imagePriority"])) {
                this.imagePriority = [] as any;
                for (let item of _data["imagePriority"])
                    this.imagePriority!.push(ImagePriorityObject.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChangeMapImagesPriorityCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeMapImagesPriorityCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapId"] = this.mapId;
        if (Array.isArray(this.imagePriority)) {
            data["imagePriority"] = [];
            for (let item of this.imagePriority)
                data["imagePriority"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChangeMapImagesPriorityCommand {
    mapId?: number;
    imagePriority?: ImagePriorityObject[] | undefined;
}

export class ImagePriorityObject implements IImagePriorityObject {
    id?: number;
    priority?: number;

    constructor(data?: IImagePriorityObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.priority = _data["priority"];
        }
    }

    static fromJS(data: any): ImagePriorityObject {
        data = typeof data === 'object' ? data : {};
        let result = new ImagePriorityObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["priority"] = this.priority;
        return data;
    }
}

export interface IImagePriorityObject {
    id?: number;
    priority?: number;
}

export class WadFilesVm implements IWadFilesVm {
    wadList?: WadFilesDto[] | undefined;

    constructor(data?: IWadFilesVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["wadList"])) {
                this.wadList = [] as any;
                for (let item of _data["wadList"])
                    this.wadList!.push(WadFilesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WadFilesVm {
        data = typeof data === 'object' ? data : {};
        let result = new WadFilesVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.wadList)) {
            data["wadList"] = [];
            for (let item of this.wadList)
                data["wadList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWadFilesVm {
    wadList?: WadFilesDto[] | undefined;
}

export class WadFilesDto implements IWadFilesDto {
    id?: number;
    fileName?: string | undefined;
    fileSize?: string | undefined;
    uploadDate?: Date;

    constructor(data?: IWadFilesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.uploadDate = _data["uploadDate"] ? new Date(_data["uploadDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WadFilesDto {
        data = typeof data === 'object' ? data : {};
        let result = new WadFilesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["uploadDate"] = this.uploadDate ? this.uploadDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWadFilesDto {
    id?: number;
    fileName?: string | undefined;
    fileSize?: string | undefined;
    uploadDate?: Date;
}

export class Round implements IRound {
    metaData?: RoundMetaData | undefined;
    wads?: Wad[] | undefined;
    itemSpawns?: ItemSpawns[] | undefined;
    playerSpawns?: PlayerSpawns[] | undefined;
    redTeamStats?: TeamStats | undefined;
    blueTeamStats?: TeamStats | undefined;
    greenTeamStats?: TeamStats | undefined;
    flagAssistTable?: FlagAssistTable | undefined;
    playerStats?: PlayerStats[] | undefined;
    playerKillDeath?: KillDeathEvent[] | undefined;
    playerFlagCarrierKillDeath?: KillDeathEvent[] | undefined;
    flagLocations?: FlagLocations[] | undefined;
    gameEvents?: GameEvents[] | undefined;

    constructor(data?: IRound) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metaData = _data["metaData"] ? RoundMetaData.fromJS(_data["metaData"]) : <any>undefined;
            if (Array.isArray(_data["wads"])) {
                this.wads = [] as any;
                for (let item of _data["wads"])
                    this.wads!.push(Wad.fromJS(item));
            }
            if (Array.isArray(_data["itemSpawns"])) {
                this.itemSpawns = [] as any;
                for (let item of _data["itemSpawns"])
                    this.itemSpawns!.push(ItemSpawns.fromJS(item));
            }
            if (Array.isArray(_data["playerSpawns"])) {
                this.playerSpawns = [] as any;
                for (let item of _data["playerSpawns"])
                    this.playerSpawns!.push(PlayerSpawns.fromJS(item));
            }
            this.redTeamStats = _data["redTeamStats"] ? TeamStats.fromJS(_data["redTeamStats"]) : <any>undefined;
            this.blueTeamStats = _data["blueTeamStats"] ? TeamStats.fromJS(_data["blueTeamStats"]) : <any>undefined;
            this.greenTeamStats = _data["greenTeamStats"] ? TeamStats.fromJS(_data["greenTeamStats"]) : <any>undefined;
            this.flagAssistTable = _data["flagAssistTable"] ? FlagAssistTable.fromJS(_data["flagAssistTable"]) : <any>undefined;
            if (Array.isArray(_data["playerStats"])) {
                this.playerStats = [] as any;
                for (let item of _data["playerStats"])
                    this.playerStats!.push(PlayerStats.fromJS(item));
            }
            if (Array.isArray(_data["playerKillDeath"])) {
                this.playerKillDeath = [] as any;
                for (let item of _data["playerKillDeath"])
                    this.playerKillDeath!.push(KillDeathEvent.fromJS(item));
            }
            if (Array.isArray(_data["playerFlagCarrierKillDeath"])) {
                this.playerFlagCarrierKillDeath = [] as any;
                for (let item of _data["playerFlagCarrierKillDeath"])
                    this.playerFlagCarrierKillDeath!.push(KillDeathEvent.fromJS(item));
            }
            if (Array.isArray(_data["flagLocations"])) {
                this.flagLocations = [] as any;
                for (let item of _data["flagLocations"])
                    this.flagLocations!.push(FlagLocations.fromJS(item));
            }
            if (Array.isArray(_data["gameEvents"])) {
                this.gameEvents = [] as any;
                for (let item of _data["gameEvents"])
                    this.gameEvents!.push(GameEvents.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Round {
        data = typeof data === 'object' ? data : {};
        let result = new Round();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metaData"] = this.metaData ? this.metaData.toJSON() : <any>undefined;
        if (Array.isArray(this.wads)) {
            data["wads"] = [];
            for (let item of this.wads)
                data["wads"].push(item.toJSON());
        }
        if (Array.isArray(this.itemSpawns)) {
            data["itemSpawns"] = [];
            for (let item of this.itemSpawns)
                data["itemSpawns"].push(item.toJSON());
        }
        if (Array.isArray(this.playerSpawns)) {
            data["playerSpawns"] = [];
            for (let item of this.playerSpawns)
                data["playerSpawns"].push(item.toJSON());
        }
        data["redTeamStats"] = this.redTeamStats ? this.redTeamStats.toJSON() : <any>undefined;
        data["blueTeamStats"] = this.blueTeamStats ? this.blueTeamStats.toJSON() : <any>undefined;
        data["greenTeamStats"] = this.greenTeamStats ? this.greenTeamStats.toJSON() : <any>undefined;
        data["flagAssistTable"] = this.flagAssistTable ? this.flagAssistTable.toJSON() : <any>undefined;
        if (Array.isArray(this.playerStats)) {
            data["playerStats"] = [];
            for (let item of this.playerStats)
                data["playerStats"].push(item.toJSON());
        }
        if (Array.isArray(this.playerKillDeath)) {
            data["playerKillDeath"] = [];
            for (let item of this.playerKillDeath)
                data["playerKillDeath"].push(item.toJSON());
        }
        if (Array.isArray(this.playerFlagCarrierKillDeath)) {
            data["playerFlagCarrierKillDeath"] = [];
            for (let item of this.playerFlagCarrierKillDeath)
                data["playerFlagCarrierKillDeath"].push(item.toJSON());
        }
        if (Array.isArray(this.flagLocations)) {
            data["flagLocations"] = [];
            for (let item of this.flagLocations)
                data["flagLocations"].push(item.toJSON());
        }
        if (Array.isArray(this.gameEvents)) {
            data["gameEvents"] = [];
            for (let item of this.gameEvents)
                data["gameEvents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRound {
    metaData?: RoundMetaData | undefined;
    wads?: Wad[] | undefined;
    itemSpawns?: ItemSpawns[] | undefined;
    playerSpawns?: PlayerSpawns[] | undefined;
    redTeamStats?: TeamStats | undefined;
    blueTeamStats?: TeamStats | undefined;
    greenTeamStats?: TeamStats | undefined;
    flagAssistTable?: FlagAssistTable | undefined;
    playerStats?: PlayerStats[] | undefined;
    playerKillDeath?: KillDeathEvent[] | undefined;
    playerFlagCarrierKillDeath?: KillDeathEvent[] | undefined;
    flagLocations?: FlagLocations[] | undefined;
    gameEvents?: GameEvents[] | undefined;
}

export class RoundMetaData implements IRoundMetaData {
    parserVersion?: number;
    date?: Date;
    mapNumber?: string | undefined;
    mapName?: string | undefined;
    lives?: number;
    gameType?: GameModeType;
    attackDefend?: number;
    originalLogFileName?: string | undefined;
    durationTics?: number;
    duration?: string;
    round?: number;
    winResult?: number;
    winId?: number;
    hostName?: string | undefined;

    constructor(data?: IRoundMetaData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parserVersion = _data["parserVersion"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.mapNumber = _data["mapNumber"];
            this.mapName = _data["mapName"];
            this.lives = _data["lives"];
            this.gameType = _data["gameType"];
            this.attackDefend = _data["attackDefend"];
            this.originalLogFileName = _data["originalLogFileName"];
            this.durationTics = _data["durationTics"];
            this.duration = _data["duration"];
            this.round = _data["round"];
            this.winResult = _data["winResult"];
            this.winId = _data["winId"];
            this.hostName = _data["hostName"];
        }
    }

    static fromJS(data: any): RoundMetaData {
        data = typeof data === 'object' ? data : {};
        let result = new RoundMetaData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parserVersion"] = this.parserVersion;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["mapNumber"] = this.mapNumber;
        data["mapName"] = this.mapName;
        data["lives"] = this.lives;
        data["gameType"] = this.gameType;
        data["attackDefend"] = this.attackDefend;
        data["originalLogFileName"] = this.originalLogFileName;
        data["durationTics"] = this.durationTics;
        data["duration"] = this.duration;
        data["round"] = this.round;
        data["winResult"] = this.winResult;
        data["winId"] = this.winId;
        data["hostName"] = this.hostName;
        return data;
    }
}

export interface IRoundMetaData {
    parserVersion?: number;
    date?: Date;
    mapNumber?: string | undefined;
    mapName?: string | undefined;
    lives?: number;
    gameType?: GameModeType;
    attackDefend?: number;
    originalLogFileName?: string | undefined;
    durationTics?: number;
    duration?: string;
    round?: number;
    winResult?: number;
    winId?: number;
    hostName?: string | undefined;
}

export class Wad implements IWad {
    filename?: string | undefined;
    hash?: string | undefined;

    constructor(data?: IWad) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filename = _data["filename"];
            this.hash = _data["hash"];
        }
    }

    static fromJS(data: any): Wad {
        data = typeof data === 'object' ? data : {};
        let result = new Wad();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filename"] = this.filename;
        data["hash"] = this.hash;
        return data;
    }
}

export interface IWad {
    filename?: string | undefined;
    hash?: string | undefined;
}

export class ItemSpawns implements IItemSpawns {
    id?: number;
    x?: number;
    y?: number;
    z?: number;
    pickup?: Pickups;

    constructor(data?: IItemSpawns) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.z = _data["z"];
            this.pickup = _data["pickup"];
        }
    }

    static fromJS(data: any): ItemSpawns {
        data = typeof data === 'object' ? data : {};
        let result = new ItemSpawns();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["x"] = this.x;
        data["y"] = this.y;
        data["z"] = this.z;
        data["pickup"] = this.pickup;
        return data;
    }
}

export interface IItemSpawns {
    id?: number;
    x?: number;
    y?: number;
    z?: number;
    pickup?: Pickups;
}

export enum Pickups {
    SoulSphere = 0,
    MegaSphere = 1,
    BlueArmor = 2,
    GreenArmor = 3,
    Berserk = 4,
    StimPack = 5,
    MedKit = 6,
    HealthBonus = 7,
    ArmorBonus = 8,
    YellowKey = 9,
    RedKey = 10,
    BlueKey = 11,
    YellowSkull = 12,
    RedSkull = 13,
    BlueSkull = 14,
    InvulnSphere = 15,
    InvisSphere = 16,
    RadSuit = 17,
    ComputerMap = 18,
    Goggles = 19,
    Clip = 20,
    AmmoBox = 21,
    Rocket = 22,
    RocketBox = 23,
    Cell = 24,
    CellPack = 25,
    Shells = 26,
    ShellBox = 27,
    BackPack = 28,
    BFG = 29,
    Chaingun = 30,
    Chainsaw = 31,
    RocketLauncher = 32,
    PlasmaGun = 33,
    Shotgun = 34,
    SuperShotgun = 35,
    CarePackage = 36,
    Unknown = 37,
}

export class PlayerSpawns implements IPlayerSpawns {
    id?: number;
    x?: number;
    y?: number;
    z?: number;
    team?: Teams;

    constructor(data?: IPlayerSpawns) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.z = _data["z"];
            this.team = _data["team"];
        }
    }

    static fromJS(data: any): PlayerSpawns {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerSpawns();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["x"] = this.x;
        data["y"] = this.y;
        data["z"] = this.z;
        data["team"] = this.team;
        return data;
    }
}

export interface IPlayerSpawns {
    id?: number;
    x?: number;
    y?: number;
    z?: number;
    team?: Teams;
}

export enum Teams {
    Blue = 0,
    Red = 1,
    Green = 2,
    None = -1,
}

export class TeamStats implements ITeamStats {
    points?: number;
    captures?: number;
    pickupCaptures?: number;
    assists?: number;
    flagTouches?: number;
    pickupFlagTouches?: number;
    totalCapturePercentage?: number;
    pickupCapturePercentage?: number;
    capturePercentage?: number;
    frags?: number;
    deaths?: number;
    killDeathRatio?: number;
    damage?: number;
    flagDefenses?: number;
    powerPickups?: number;
    teamPlayers?: string[] | undefined;

    constructor(data?: ITeamStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.points = _data["points"];
            this.captures = _data["captures"];
            this.pickupCaptures = _data["pickupCaptures"];
            this.assists = _data["assists"];
            this.flagTouches = _data["flagTouches"];
            this.pickupFlagTouches = _data["pickupFlagTouches"];
            this.totalCapturePercentage = _data["totalCapturePercentage"];
            this.pickupCapturePercentage = _data["pickupCapturePercentage"];
            this.capturePercentage = _data["capturePercentage"];
            this.frags = _data["frags"];
            this.deaths = _data["deaths"];
            this.killDeathRatio = _data["killDeathRatio"];
            this.damage = _data["damage"];
            this.flagDefenses = _data["flagDefenses"];
            this.powerPickups = _data["powerPickups"];
            if (Array.isArray(_data["teamPlayers"])) {
                this.teamPlayers = [] as any;
                for (let item of _data["teamPlayers"])
                    this.teamPlayers!.push(item);
            }
        }
    }

    static fromJS(data: any): TeamStats {
        data = typeof data === 'object' ? data : {};
        let result = new TeamStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["points"] = this.points;
        data["captures"] = this.captures;
        data["pickupCaptures"] = this.pickupCaptures;
        data["assists"] = this.assists;
        data["flagTouches"] = this.flagTouches;
        data["pickupFlagTouches"] = this.pickupFlagTouches;
        data["totalCapturePercentage"] = this.totalCapturePercentage;
        data["pickupCapturePercentage"] = this.pickupCapturePercentage;
        data["capturePercentage"] = this.capturePercentage;
        data["frags"] = this.frags;
        data["deaths"] = this.deaths;
        data["killDeathRatio"] = this.killDeathRatio;
        data["damage"] = this.damage;
        data["flagDefenses"] = this.flagDefenses;
        data["powerPickups"] = this.powerPickups;
        if (Array.isArray(this.teamPlayers)) {
            data["teamPlayers"] = [];
            for (let item of this.teamPlayers)
                data["teamPlayers"].push(item);
        }
        return data;
    }
}

export interface ITeamStats {
    points?: number;
    captures?: number;
    pickupCaptures?: number;
    assists?: number;
    flagTouches?: number;
    pickupFlagTouches?: number;
    totalCapturePercentage?: number;
    pickupCapturePercentage?: number;
    capturePercentage?: number;
    frags?: number;
    deaths?: number;
    killDeathRatio?: number;
    damage?: number;
    flagDefenses?: number;
    powerPickups?: number;
    teamPlayers?: string[] | undefined;
}

export class FlagAssistTable implements IFlagAssistTable {
    flagTouchCaptures?: FlagTouchCaptures[] | undefined;

    constructor(data?: IFlagAssistTable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["flagTouchCaptures"])) {
                this.flagTouchCaptures = [] as any;
                for (let item of _data["flagTouchCaptures"])
                    this.flagTouchCaptures!.push(FlagTouchCaptures.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FlagAssistTable {
        data = typeof data === 'object' ? data : {};
        let result = new FlagAssistTable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.flagTouchCaptures)) {
            data["flagTouchCaptures"] = [];
            for (let item of this.flagTouchCaptures)
                data["flagTouchCaptures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFlagAssistTable {
    flagTouchCaptures?: FlagTouchCaptures[] | undefined;
}

export class FlagTouchCaptures implements IFlagTouchCaptures {
    timeCapturedTics?: number;
    team?: Teams;
    flagAssists?: FlagAssistData[] | undefined;

    constructor(data?: IFlagTouchCaptures) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeCapturedTics = _data["timeCapturedTics"];
            this.team = _data["team"];
            if (Array.isArray(_data["flagAssists"])) {
                this.flagAssists = [] as any;
                for (let item of _data["flagAssists"])
                    this.flagAssists!.push(FlagAssistData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FlagTouchCaptures {
        data = typeof data === 'object' ? data : {};
        let result = new FlagTouchCaptures();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeCapturedTics"] = this.timeCapturedTics;
        data["team"] = this.team;
        if (Array.isArray(this.flagAssists)) {
            data["flagAssists"] = [];
            for (let item of this.flagAssists)
                data["flagAssists"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFlagTouchCaptures {
    timeCapturedTics?: number;
    team?: Teams;
    flagAssists?: FlagAssistData[] | undefined;
}

export class FlagAssistData implements IFlagAssistData {
    flagTouchTimeTics?: number;
    playerId?: number;
    playerName?: string | undefined;

    constructor(data?: IFlagAssistData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flagTouchTimeTics = _data["flagTouchTimeTics"];
            this.playerId = _data["playerId"];
            this.playerName = _data["playerName"];
        }
    }

    static fromJS(data: any): FlagAssistData {
        data = typeof data === 'object' ? data : {};
        let result = new FlagAssistData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flagTouchTimeTics"] = this.flagTouchTimeTics;
        data["playerId"] = this.playerId;
        data["playerName"] = this.playerName;
        return data;
    }
}

export interface IFlagAssistData {
    flagTouchTimeTics?: number;
    playerId?: number;
    playerName?: string | undefined;
}

export class PlayerStats implements IPlayerStats {
    id?: number;
    netId?: number;
    name?: string | undefined;
    team?: Teams;
    assists?: number;
    captures?: number;
    pickupCaptures?: number;
    capturesWithSuperPickup?: number;
    flagTouches?: number;
    pickupFlagTouches?: number;
    damageOutputBetweenTouchAndCaptureMin?: number;
    damageOutputBetweenTouchAndCaptureMax?: number;
    damageOutputBetweenTouchAndCaptureAvg?: number;
    captureTimeMinTics?: number;
    captureTimeMaxTics?: number;
    captureTimeAvgTics?: number;
    captureHealthMin?: number;
    captureHealthMax?: number;
    captureHealthAvg?: number;
    captureGreenArmorMin?: number;
    captureGreenArmorMax?: number;
    captureGreenArmorAvg?: number;
    captureBlueArmorMin?: number;
    captureBlueArmorMax?: number;
    captureBlueArmorAvg?: number;
    flagCarriersKilledWhileHoldingFlag?: number;
    highestKillsBeforeCapturing?: number;
    pickupCaptureTimeMinTics?: number;
    pickupCaptureTimeMaxTics?: number;
    pickupCaptureTimeAvgTics?: number;
    totalDamage?: number;
    totalTeamDamage?: number;
    selfDamage?: number;
    selfDamageWithFlag?: number;
    totalGreenArmorDamage?: number;
    totalBlueArmorDamage?: number;
    totalDamageToFlagCarriers?: number;
    totalDamageAsFlagCarrier?: number;
    totalDamageToFlagCarriersWhileHoldingFlag?: number;
    totalDamageTakenFromEnvironment?: number;
    totalDamageTakenFromEnvironmentAsFlagCarrier?: number;
    totalFlagReturns?: number;
    totalKills?: number;
    killsWithFlag?: number;
    killDeathRatio?: number;
    capturePercentage?: number;
    pickupCapturePercentage?: number;
    overallCapturePercentage?: number;
    flagDefenses?: number;
    totalDeaths?: number;
    deaths?: number;
    flagCarrierDeaths?: number;
    suicides?: number;
    suicidesWithFlag?: number;
    environmentalDeaths?: number;
    environmentalDeathsAsFlagCarrier?: number;
    teamKills?: number;
    longestSpree?: number;
    highestMultiKill?: number;
    totalPowerPickups?: number;
    totalHealthFromPickups?: number;
    healthFromNonPowerPickups?: number;
    healthFromPowerPickups?: number;
    touchHealthMin?: number;
    touchHealthMax?: number;
    touchHealthAvg?: number;
    touchGreenArmorMin?: number;
    touchGreenArmorMax?: number;
    touchGreenArmorAvg?: number;
    touchBlueArmorMin?: number;
    touchBlueArmorMax?: number;
    touchBlueArmorAvg?: number;
    touchHealthResultCaptureMin?: number;
    touchHealthResultCaptureMax?: number;
    touchHealthResultCaptureAvg?: number;
    touchesOverOneHundredHealth?: number;
    damageList?: DamageAggregate[] | undefined;
    damageWithFlagList?: DamageAggregate[] | undefined;
    damageToFlagCarriersList?: DamageAggregate[] | undefined;
    damageToFlagCarriersWithFlagList?: DamageAggregate[] | undefined;
    killsList?: KillAggregate[] | undefined;
    killsWithFlagList?: KillAggregate[] | undefined;
    carrierKillList?: KillAggregate[] | undefined;
    carrierKillsWhileHoldingFlagList?: KillAggregate[] | undefined;
    accuracyList?: AccuracyAggregate[] | undefined;
    accuracyWithFlagList?: AccuracyAggregate[] | undefined;
    accuracyWithoutFlagList?: AccuracyAggregate[] | undefined;
    totalNonTeammateAccuracyList?: AccuracyAggregate[] | undefined;
    pickupList?: PickupAggregate[] | undefined;

    constructor(data?: IPlayerStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.netId = _data["netId"];
            this.name = _data["name"];
            this.team = _data["team"];
            this.assists = _data["assists"];
            this.captures = _data["captures"];
            this.pickupCaptures = _data["pickupCaptures"];
            this.capturesWithSuperPickup = _data["capturesWithSuperPickup"];
            this.flagTouches = _data["flagTouches"];
            this.pickupFlagTouches = _data["pickupFlagTouches"];
            this.damageOutputBetweenTouchAndCaptureMin = _data["damageOutputBetweenTouchAndCaptureMin"];
            this.damageOutputBetweenTouchAndCaptureMax = _data["damageOutputBetweenTouchAndCaptureMax"];
            this.damageOutputBetweenTouchAndCaptureAvg = _data["damageOutputBetweenTouchAndCaptureAvg"];
            this.captureTimeMinTics = _data["captureTimeMinTics"];
            this.captureTimeMaxTics = _data["captureTimeMaxTics"];
            this.captureTimeAvgTics = _data["captureTimeAvgTics"];
            this.captureHealthMin = _data["captureHealthMin"];
            this.captureHealthMax = _data["captureHealthMax"];
            this.captureHealthAvg = _data["captureHealthAvg"];
            this.captureGreenArmorMin = _data["captureGreenArmorMin"];
            this.captureGreenArmorMax = _data["captureGreenArmorMax"];
            this.captureGreenArmorAvg = _data["captureGreenArmorAvg"];
            this.captureBlueArmorMin = _data["captureBlueArmorMin"];
            this.captureBlueArmorMax = _data["captureBlueArmorMax"];
            this.captureBlueArmorAvg = _data["captureBlueArmorAvg"];
            this.flagCarriersKilledWhileHoldingFlag = _data["flagCarriersKilledWhileHoldingFlag"];
            this.highestKillsBeforeCapturing = _data["highestKillsBeforeCapturing"];
            this.pickupCaptureTimeMinTics = _data["pickupCaptureTimeMinTics"];
            this.pickupCaptureTimeMaxTics = _data["pickupCaptureTimeMaxTics"];
            this.pickupCaptureTimeAvgTics = _data["pickupCaptureTimeAvgTics"];
            this.totalDamage = _data["totalDamage"];
            this.totalTeamDamage = _data["totalTeamDamage"];
            this.selfDamage = _data["selfDamage"];
            this.selfDamageWithFlag = _data["selfDamageWithFlag"];
            this.totalGreenArmorDamage = _data["totalGreenArmorDamage"];
            this.totalBlueArmorDamage = _data["totalBlueArmorDamage"];
            this.totalDamageToFlagCarriers = _data["totalDamageToFlagCarriers"];
            this.totalDamageAsFlagCarrier = _data["totalDamageAsFlagCarrier"];
            this.totalDamageToFlagCarriersWhileHoldingFlag = _data["totalDamageToFlagCarriersWhileHoldingFlag"];
            this.totalDamageTakenFromEnvironment = _data["totalDamageTakenFromEnvironment"];
            this.totalDamageTakenFromEnvironmentAsFlagCarrier = _data["totalDamageTakenFromEnvironmentAsFlagCarrier"];
            this.totalFlagReturns = _data["totalFlagReturns"];
            this.totalKills = _data["totalKills"];
            this.killsWithFlag = _data["killsWithFlag"];
            this.killDeathRatio = _data["killDeathRatio"];
            this.capturePercentage = _data["capturePercentage"];
            this.pickupCapturePercentage = _data["pickupCapturePercentage"];
            this.overallCapturePercentage = _data["overallCapturePercentage"];
            this.flagDefenses = _data["flagDefenses"];
            this.totalDeaths = _data["totalDeaths"];
            this.deaths = _data["deaths"];
            this.flagCarrierDeaths = _data["flagCarrierDeaths"];
            this.suicides = _data["suicides"];
            this.suicidesWithFlag = _data["suicidesWithFlag"];
            this.environmentalDeaths = _data["environmentalDeaths"];
            this.environmentalDeathsAsFlagCarrier = _data["environmentalDeathsAsFlagCarrier"];
            this.teamKills = _data["teamKills"];
            this.longestSpree = _data["longestSpree"];
            this.highestMultiKill = _data["highestMultiKill"];
            this.totalPowerPickups = _data["totalPowerPickups"];
            this.totalHealthFromPickups = _data["totalHealthFromPickups"];
            this.healthFromNonPowerPickups = _data["healthFromNonPowerPickups"];
            this.healthFromPowerPickups = _data["healthFromPowerPickups"];
            this.touchHealthMin = _data["touchHealthMin"];
            this.touchHealthMax = _data["touchHealthMax"];
            this.touchHealthAvg = _data["touchHealthAvg"];
            this.touchGreenArmorMin = _data["touchGreenArmorMin"];
            this.touchGreenArmorMax = _data["touchGreenArmorMax"];
            this.touchGreenArmorAvg = _data["touchGreenArmorAvg"];
            this.touchBlueArmorMin = _data["touchBlueArmorMin"];
            this.touchBlueArmorMax = _data["touchBlueArmorMax"];
            this.touchBlueArmorAvg = _data["touchBlueArmorAvg"];
            this.touchHealthResultCaptureMin = _data["touchHealthResultCaptureMin"];
            this.touchHealthResultCaptureMax = _data["touchHealthResultCaptureMax"];
            this.touchHealthResultCaptureAvg = _data["touchHealthResultCaptureAvg"];
            this.touchesOverOneHundredHealth = _data["touchesOverOneHundredHealth"];
            if (Array.isArray(_data["damageList"])) {
                this.damageList = [] as any;
                for (let item of _data["damageList"])
                    this.damageList!.push(DamageAggregate.fromJS(item));
            }
            if (Array.isArray(_data["damageWithFlagList"])) {
                this.damageWithFlagList = [] as any;
                for (let item of _data["damageWithFlagList"])
                    this.damageWithFlagList!.push(DamageAggregate.fromJS(item));
            }
            if (Array.isArray(_data["damageToFlagCarriersList"])) {
                this.damageToFlagCarriersList = [] as any;
                for (let item of _data["damageToFlagCarriersList"])
                    this.damageToFlagCarriersList!.push(DamageAggregate.fromJS(item));
            }
            if (Array.isArray(_data["damageToFlagCarriersWithFlagList"])) {
                this.damageToFlagCarriersWithFlagList = [] as any;
                for (let item of _data["damageToFlagCarriersWithFlagList"])
                    this.damageToFlagCarriersWithFlagList!.push(DamageAggregate.fromJS(item));
            }
            if (Array.isArray(_data["killsList"])) {
                this.killsList = [] as any;
                for (let item of _data["killsList"])
                    this.killsList!.push(KillAggregate.fromJS(item));
            }
            if (Array.isArray(_data["killsWithFlagList"])) {
                this.killsWithFlagList = [] as any;
                for (let item of _data["killsWithFlagList"])
                    this.killsWithFlagList!.push(KillAggregate.fromJS(item));
            }
            if (Array.isArray(_data["carrierKillList"])) {
                this.carrierKillList = [] as any;
                for (let item of _data["carrierKillList"])
                    this.carrierKillList!.push(KillAggregate.fromJS(item));
            }
            if (Array.isArray(_data["carrierKillsWhileHoldingFlagList"])) {
                this.carrierKillsWhileHoldingFlagList = [] as any;
                for (let item of _data["carrierKillsWhileHoldingFlagList"])
                    this.carrierKillsWhileHoldingFlagList!.push(KillAggregate.fromJS(item));
            }
            if (Array.isArray(_data["accuracyList"])) {
                this.accuracyList = [] as any;
                for (let item of _data["accuracyList"])
                    this.accuracyList!.push(AccuracyAggregate.fromJS(item));
            }
            if (Array.isArray(_data["accuracyWithFlagList"])) {
                this.accuracyWithFlagList = [] as any;
                for (let item of _data["accuracyWithFlagList"])
                    this.accuracyWithFlagList!.push(AccuracyAggregate.fromJS(item));
            }
            if (Array.isArray(_data["accuracyWithoutFlagList"])) {
                this.accuracyWithoutFlagList = [] as any;
                for (let item of _data["accuracyWithoutFlagList"])
                    this.accuracyWithoutFlagList!.push(AccuracyAggregate.fromJS(item));
            }
            if (Array.isArray(_data["totalNonTeammateAccuracyList"])) {
                this.totalNonTeammateAccuracyList = [] as any;
                for (let item of _data["totalNonTeammateAccuracyList"])
                    this.totalNonTeammateAccuracyList!.push(AccuracyAggregate.fromJS(item));
            }
            if (Array.isArray(_data["pickupList"])) {
                this.pickupList = [] as any;
                for (let item of _data["pickupList"])
                    this.pickupList!.push(PickupAggregate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayerStats {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["netId"] = this.netId;
        data["name"] = this.name;
        data["team"] = this.team;
        data["assists"] = this.assists;
        data["captures"] = this.captures;
        data["pickupCaptures"] = this.pickupCaptures;
        data["capturesWithSuperPickup"] = this.capturesWithSuperPickup;
        data["flagTouches"] = this.flagTouches;
        data["pickupFlagTouches"] = this.pickupFlagTouches;
        data["damageOutputBetweenTouchAndCaptureMin"] = this.damageOutputBetweenTouchAndCaptureMin;
        data["damageOutputBetweenTouchAndCaptureMax"] = this.damageOutputBetweenTouchAndCaptureMax;
        data["damageOutputBetweenTouchAndCaptureAvg"] = this.damageOutputBetweenTouchAndCaptureAvg;
        data["captureTimeMinTics"] = this.captureTimeMinTics;
        data["captureTimeMaxTics"] = this.captureTimeMaxTics;
        data["captureTimeAvgTics"] = this.captureTimeAvgTics;
        data["captureHealthMin"] = this.captureHealthMin;
        data["captureHealthMax"] = this.captureHealthMax;
        data["captureHealthAvg"] = this.captureHealthAvg;
        data["captureGreenArmorMin"] = this.captureGreenArmorMin;
        data["captureGreenArmorMax"] = this.captureGreenArmorMax;
        data["captureGreenArmorAvg"] = this.captureGreenArmorAvg;
        data["captureBlueArmorMin"] = this.captureBlueArmorMin;
        data["captureBlueArmorMax"] = this.captureBlueArmorMax;
        data["captureBlueArmorAvg"] = this.captureBlueArmorAvg;
        data["flagCarriersKilledWhileHoldingFlag"] = this.flagCarriersKilledWhileHoldingFlag;
        data["highestKillsBeforeCapturing"] = this.highestKillsBeforeCapturing;
        data["pickupCaptureTimeMinTics"] = this.pickupCaptureTimeMinTics;
        data["pickupCaptureTimeMaxTics"] = this.pickupCaptureTimeMaxTics;
        data["pickupCaptureTimeAvgTics"] = this.pickupCaptureTimeAvgTics;
        data["totalDamage"] = this.totalDamage;
        data["totalTeamDamage"] = this.totalTeamDamage;
        data["selfDamage"] = this.selfDamage;
        data["selfDamageWithFlag"] = this.selfDamageWithFlag;
        data["totalGreenArmorDamage"] = this.totalGreenArmorDamage;
        data["totalBlueArmorDamage"] = this.totalBlueArmorDamage;
        data["totalDamageToFlagCarriers"] = this.totalDamageToFlagCarriers;
        data["totalDamageAsFlagCarrier"] = this.totalDamageAsFlagCarrier;
        data["totalDamageToFlagCarriersWhileHoldingFlag"] = this.totalDamageToFlagCarriersWhileHoldingFlag;
        data["totalDamageTakenFromEnvironment"] = this.totalDamageTakenFromEnvironment;
        data["totalDamageTakenFromEnvironmentAsFlagCarrier"] = this.totalDamageTakenFromEnvironmentAsFlagCarrier;
        data["totalFlagReturns"] = this.totalFlagReturns;
        data["totalKills"] = this.totalKills;
        data["killsWithFlag"] = this.killsWithFlag;
        data["killDeathRatio"] = this.killDeathRatio;
        data["capturePercentage"] = this.capturePercentage;
        data["pickupCapturePercentage"] = this.pickupCapturePercentage;
        data["overallCapturePercentage"] = this.overallCapturePercentage;
        data["flagDefenses"] = this.flagDefenses;
        data["totalDeaths"] = this.totalDeaths;
        data["deaths"] = this.deaths;
        data["flagCarrierDeaths"] = this.flagCarrierDeaths;
        data["suicides"] = this.suicides;
        data["suicidesWithFlag"] = this.suicidesWithFlag;
        data["environmentalDeaths"] = this.environmentalDeaths;
        data["environmentalDeathsAsFlagCarrier"] = this.environmentalDeathsAsFlagCarrier;
        data["teamKills"] = this.teamKills;
        data["longestSpree"] = this.longestSpree;
        data["highestMultiKill"] = this.highestMultiKill;
        data["totalPowerPickups"] = this.totalPowerPickups;
        data["totalHealthFromPickups"] = this.totalHealthFromPickups;
        data["healthFromNonPowerPickups"] = this.healthFromNonPowerPickups;
        data["healthFromPowerPickups"] = this.healthFromPowerPickups;
        data["touchHealthMin"] = this.touchHealthMin;
        data["touchHealthMax"] = this.touchHealthMax;
        data["touchHealthAvg"] = this.touchHealthAvg;
        data["touchGreenArmorMin"] = this.touchGreenArmorMin;
        data["touchGreenArmorMax"] = this.touchGreenArmorMax;
        data["touchGreenArmorAvg"] = this.touchGreenArmorAvg;
        data["touchBlueArmorMin"] = this.touchBlueArmorMin;
        data["touchBlueArmorMax"] = this.touchBlueArmorMax;
        data["touchBlueArmorAvg"] = this.touchBlueArmorAvg;
        data["touchHealthResultCaptureMin"] = this.touchHealthResultCaptureMin;
        data["touchHealthResultCaptureMax"] = this.touchHealthResultCaptureMax;
        data["touchHealthResultCaptureAvg"] = this.touchHealthResultCaptureAvg;
        data["touchesOverOneHundredHealth"] = this.touchesOverOneHundredHealth;
        if (Array.isArray(this.damageList)) {
            data["damageList"] = [];
            for (let item of this.damageList)
                data["damageList"].push(item.toJSON());
        }
        if (Array.isArray(this.damageWithFlagList)) {
            data["damageWithFlagList"] = [];
            for (let item of this.damageWithFlagList)
                data["damageWithFlagList"].push(item.toJSON());
        }
        if (Array.isArray(this.damageToFlagCarriersList)) {
            data["damageToFlagCarriersList"] = [];
            for (let item of this.damageToFlagCarriersList)
                data["damageToFlagCarriersList"].push(item.toJSON());
        }
        if (Array.isArray(this.damageToFlagCarriersWithFlagList)) {
            data["damageToFlagCarriersWithFlagList"] = [];
            for (let item of this.damageToFlagCarriersWithFlagList)
                data["damageToFlagCarriersWithFlagList"].push(item.toJSON());
        }
        if (Array.isArray(this.killsList)) {
            data["killsList"] = [];
            for (let item of this.killsList)
                data["killsList"].push(item.toJSON());
        }
        if (Array.isArray(this.killsWithFlagList)) {
            data["killsWithFlagList"] = [];
            for (let item of this.killsWithFlagList)
                data["killsWithFlagList"].push(item.toJSON());
        }
        if (Array.isArray(this.carrierKillList)) {
            data["carrierKillList"] = [];
            for (let item of this.carrierKillList)
                data["carrierKillList"].push(item.toJSON());
        }
        if (Array.isArray(this.carrierKillsWhileHoldingFlagList)) {
            data["carrierKillsWhileHoldingFlagList"] = [];
            for (let item of this.carrierKillsWhileHoldingFlagList)
                data["carrierKillsWhileHoldingFlagList"].push(item.toJSON());
        }
        if (Array.isArray(this.accuracyList)) {
            data["accuracyList"] = [];
            for (let item of this.accuracyList)
                data["accuracyList"].push(item.toJSON());
        }
        if (Array.isArray(this.accuracyWithFlagList)) {
            data["accuracyWithFlagList"] = [];
            for (let item of this.accuracyWithFlagList)
                data["accuracyWithFlagList"].push(item.toJSON());
        }
        if (Array.isArray(this.accuracyWithoutFlagList)) {
            data["accuracyWithoutFlagList"] = [];
            for (let item of this.accuracyWithoutFlagList)
                data["accuracyWithoutFlagList"].push(item.toJSON());
        }
        if (Array.isArray(this.totalNonTeammateAccuracyList)) {
            data["totalNonTeammateAccuracyList"] = [];
            for (let item of this.totalNonTeammateAccuracyList)
                data["totalNonTeammateAccuracyList"].push(item.toJSON());
        }
        if (Array.isArray(this.pickupList)) {
            data["pickupList"] = [];
            for (let item of this.pickupList)
                data["pickupList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlayerStats {
    id?: number;
    netId?: number;
    name?: string | undefined;
    team?: Teams;
    assists?: number;
    captures?: number;
    pickupCaptures?: number;
    capturesWithSuperPickup?: number;
    flagTouches?: number;
    pickupFlagTouches?: number;
    damageOutputBetweenTouchAndCaptureMin?: number;
    damageOutputBetweenTouchAndCaptureMax?: number;
    damageOutputBetweenTouchAndCaptureAvg?: number;
    captureTimeMinTics?: number;
    captureTimeMaxTics?: number;
    captureTimeAvgTics?: number;
    captureHealthMin?: number;
    captureHealthMax?: number;
    captureHealthAvg?: number;
    captureGreenArmorMin?: number;
    captureGreenArmorMax?: number;
    captureGreenArmorAvg?: number;
    captureBlueArmorMin?: number;
    captureBlueArmorMax?: number;
    captureBlueArmorAvg?: number;
    flagCarriersKilledWhileHoldingFlag?: number;
    highestKillsBeforeCapturing?: number;
    pickupCaptureTimeMinTics?: number;
    pickupCaptureTimeMaxTics?: number;
    pickupCaptureTimeAvgTics?: number;
    totalDamage?: number;
    totalTeamDamage?: number;
    selfDamage?: number;
    selfDamageWithFlag?: number;
    totalGreenArmorDamage?: number;
    totalBlueArmorDamage?: number;
    totalDamageToFlagCarriers?: number;
    totalDamageAsFlagCarrier?: number;
    totalDamageToFlagCarriersWhileHoldingFlag?: number;
    totalDamageTakenFromEnvironment?: number;
    totalDamageTakenFromEnvironmentAsFlagCarrier?: number;
    totalFlagReturns?: number;
    totalKills?: number;
    killsWithFlag?: number;
    killDeathRatio?: number;
    capturePercentage?: number;
    pickupCapturePercentage?: number;
    overallCapturePercentage?: number;
    flagDefenses?: number;
    totalDeaths?: number;
    deaths?: number;
    flagCarrierDeaths?: number;
    suicides?: number;
    suicidesWithFlag?: number;
    environmentalDeaths?: number;
    environmentalDeathsAsFlagCarrier?: number;
    teamKills?: number;
    longestSpree?: number;
    highestMultiKill?: number;
    totalPowerPickups?: number;
    totalHealthFromPickups?: number;
    healthFromNonPowerPickups?: number;
    healthFromPowerPickups?: number;
    touchHealthMin?: number;
    touchHealthMax?: number;
    touchHealthAvg?: number;
    touchGreenArmorMin?: number;
    touchGreenArmorMax?: number;
    touchGreenArmorAvg?: number;
    touchBlueArmorMin?: number;
    touchBlueArmorMax?: number;
    touchBlueArmorAvg?: number;
    touchHealthResultCaptureMin?: number;
    touchHealthResultCaptureMax?: number;
    touchHealthResultCaptureAvg?: number;
    touchesOverOneHundredHealth?: number;
    damageList?: DamageAggregate[] | undefined;
    damageWithFlagList?: DamageAggregate[] | undefined;
    damageToFlagCarriersList?: DamageAggregate[] | undefined;
    damageToFlagCarriersWithFlagList?: DamageAggregate[] | undefined;
    killsList?: KillAggregate[] | undefined;
    killsWithFlagList?: KillAggregate[] | undefined;
    carrierKillList?: KillAggregate[] | undefined;
    carrierKillsWhileHoldingFlagList?: KillAggregate[] | undefined;
    accuracyList?: AccuracyAggregate[] | undefined;
    accuracyWithFlagList?: AccuracyAggregate[] | undefined;
    accuracyWithoutFlagList?: AccuracyAggregate[] | undefined;
    totalNonTeammateAccuracyList?: AccuracyAggregate[] | undefined;
    pickupList?: PickupAggregate[] | undefined;
}

export class DamageAggregate implements IDamageAggregate {
    totalDamage?: number;
    totalDamageGreenArmor?: number;
    totalDamageBlueArmor?: number;
    targetName?: string | undefined;
    targetId?: number;
    weapon?: Mods2;

    constructor(data?: IDamageAggregate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalDamage = _data["totalDamage"];
            this.totalDamageGreenArmor = _data["totalDamageGreenArmor"];
            this.totalDamageBlueArmor = _data["totalDamageBlueArmor"];
            this.targetName = _data["targetName"];
            this.targetId = _data["targetId"];
            this.weapon = _data["weapon"];
        }
    }

    static fromJS(data: any): DamageAggregate {
        data = typeof data === 'object' ? data : {};
        let result = new DamageAggregate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalDamage"] = this.totalDamage;
        data["totalDamageGreenArmor"] = this.totalDamageGreenArmor;
        data["totalDamageBlueArmor"] = this.totalDamageBlueArmor;
        data["targetName"] = this.targetName;
        data["targetId"] = this.targetId;
        data["weapon"] = this.weapon;
        return data;
    }
}

export interface IDamageAggregate {
    totalDamage?: number;
    totalDamageGreenArmor?: number;
    totalDamageBlueArmor?: number;
    targetName?: string | undefined;
    targetId?: number;
    weapon?: Mods2;
}

export enum Mods2 {
    Unknown = 0,
    Fist = 1,
    Pistol = 2,
    Shotgun = 3,
    Chaingun = 4,
    Rocket = 5,
    RocketSplash = 6,
    PlasmaRifle = 7,
    BfgBall = 8,
    BfgSplash = 9,
    Chainsaw = 10,
    SuperShotgun = 11,
    Water = 12,
    Slime = 13,
    Lava = 14,
    Crusher = 15,
    Telefrag = 16,
    Falling = 17,
    Suicide = 18,
    Barrel = 19,
    Exit = 20,
    Splash = 21,
    Hit = 22,
    Railgun = 23,
}

export class KillAggregate implements IKillAggregate {
    totalKills?: number;
    targetName?: string | undefined;
    targetId?: number;
    weapon?: Mods2;

    constructor(data?: IKillAggregate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalKills = _data["totalKills"];
            this.targetName = _data["targetName"];
            this.targetId = _data["targetId"];
            this.weapon = _data["weapon"];
        }
    }

    static fromJS(data: any): KillAggregate {
        data = typeof data === 'object' ? data : {};
        let result = new KillAggregate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalKills"] = this.totalKills;
        data["targetName"] = this.targetName;
        data["targetId"] = this.targetId;
        data["weapon"] = this.weapon;
        return data;
    }
}

export interface IKillAggregate {
    totalKills?: number;
    targetName?: string | undefined;
    targetId?: number;
    weapon?: Mods2;
}

export class AccuracyAggregate implements IAccuracyAggregate {
    pinpointPercentage?: number;
    spritePercentage?: number;
    totalShotsHit?: number;
    totalShotsMissed?: number;
    totalShotsAttempted?: number;
    totalPelletsHit?: number;
    totalPelletsMissed?: number;
    totalPelletsAttempted?: number;
    hitMissRatio?: number;
    weapon?: Mods2;

    constructor(data?: IAccuracyAggregate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pinpointPercentage = _data["pinpointPercentage"];
            this.spritePercentage = _data["spritePercentage"];
            this.totalShotsHit = _data["totalShotsHit"];
            this.totalShotsMissed = _data["totalShotsMissed"];
            this.totalShotsAttempted = _data["totalShotsAttempted"];
            this.totalPelletsHit = _data["totalPelletsHit"];
            this.totalPelletsMissed = _data["totalPelletsMissed"];
            this.totalPelletsAttempted = _data["totalPelletsAttempted"];
            this.hitMissRatio = _data["hitMissRatio"];
            this.weapon = _data["weapon"];
        }
    }

    static fromJS(data: any): AccuracyAggregate {
        data = typeof data === 'object' ? data : {};
        let result = new AccuracyAggregate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pinpointPercentage"] = this.pinpointPercentage;
        data["spritePercentage"] = this.spritePercentage;
        data["totalShotsHit"] = this.totalShotsHit;
        data["totalShotsMissed"] = this.totalShotsMissed;
        data["totalShotsAttempted"] = this.totalShotsAttempted;
        data["totalPelletsHit"] = this.totalPelletsHit;
        data["totalPelletsMissed"] = this.totalPelletsMissed;
        data["totalPelletsAttempted"] = this.totalPelletsAttempted;
        data["hitMissRatio"] = this.hitMissRatio;
        data["weapon"] = this.weapon;
        return data;
    }
}

export interface IAccuracyAggregate {
    pinpointPercentage?: number;
    spritePercentage?: number;
    totalShotsHit?: number;
    totalShotsMissed?: number;
    totalShotsAttempted?: number;
    totalPelletsHit?: number;
    totalPelletsMissed?: number;
    totalPelletsAttempted?: number;
    hitMissRatio?: number;
    weapon?: Mods2;
}

export class PickupAggregate implements IPickupAggregate {
    pickupType?: Pickups;
    totalPickups?: number;

    constructor(data?: IPickupAggregate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pickupType = _data["pickupType"];
            this.totalPickups = _data["totalPickups"];
        }
    }

    static fromJS(data: any): PickupAggregate {
        data = typeof data === 'object' ? data : {};
        let result = new PickupAggregate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pickupType"] = this.pickupType;
        data["totalPickups"] = this.totalPickups;
        return data;
    }
}

export interface IPickupAggregate {
    pickupType?: Pickups;
    totalPickups?: number;
}

export class KillDeathEvent implements IKillDeathEvent {
    killerName?: string | undefined;
    killerId?: number;
    killerX?: number;
    killerY?: number;
    killerZ?: number;
    targetName?: string | undefined;
    targetId?: number;
    targetX?: number;
    targetY?: number;
    targetZ?: number;
    weapon?: Mods2;

    constructor(data?: IKillDeathEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.killerName = _data["killerName"];
            this.killerId = _data["killerId"];
            this.killerX = _data["killerX"];
            this.killerY = _data["killerY"];
            this.killerZ = _data["killerZ"];
            this.targetName = _data["targetName"];
            this.targetId = _data["targetId"];
            this.targetX = _data["targetX"];
            this.targetY = _data["targetY"];
            this.targetZ = _data["targetZ"];
            this.weapon = _data["weapon"];
        }
    }

    static fromJS(data: any): KillDeathEvent {
        data = typeof data === 'object' ? data : {};
        let result = new KillDeathEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["killerName"] = this.killerName;
        data["killerId"] = this.killerId;
        data["killerX"] = this.killerX;
        data["killerY"] = this.killerY;
        data["killerZ"] = this.killerZ;
        data["targetName"] = this.targetName;
        data["targetId"] = this.targetId;
        data["targetX"] = this.targetX;
        data["targetY"] = this.targetY;
        data["targetZ"] = this.targetZ;
        data["weapon"] = this.weapon;
        return data;
    }
}

export interface IKillDeathEvent {
    killerName?: string | undefined;
    killerId?: number;
    killerX?: number;
    killerY?: number;
    killerZ?: number;
    targetName?: string | undefined;
    targetId?: number;
    targetX?: number;
    targetY?: number;
    targetZ?: number;
    weapon?: Mods2;
}

export class FlagLocations implements IFlagLocations {
    team?: Teams;
    x?: number;
    y?: number;
    z?: number;

    constructor(data?: IFlagLocations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.team = _data["team"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.z = _data["z"];
        }
    }

    static fromJS(data: any): FlagLocations {
        data = typeof data === 'object' ? data : {};
        let result = new FlagLocations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["team"] = this.team;
        data["x"] = this.x;
        data["y"] = this.y;
        data["z"] = this.z;
        return data;
    }
}

export interface IFlagLocations {
    team?: Teams;
    x?: number;
    y?: number;
    z?: number;
}

export class GameEvents implements IGameEvents {
    gameTic?: number;
    accuracyEvents?: AccuracyEvent[] | undefined;
    kills?: KillEvent[] | undefined;
    carrierKills?: KillEvent[] | undefined;
    suicides?: KillEvent[] | undefined;
    suicidesWithFlag?: KillEvent[] | undefined;
    environmentalDeaths?: KillEvent[] | undefined;
    environmentalDeathsWithFlag?: KillEvent[] | undefined;
    damage?: DamageEvent[] | undefined;
    selfDamage?: DamageEvent[] | undefined;
    selfDamageWithFlag?: DamageEvent[] | undefined;
    environmentalDamage?: DamageEvent[] | undefined;
    environmentalDamageWithFlag?: DamageEvent[] | undefined;
    pickups?: PickupEvent[] | undefined;
    pickupFlagTouches?: FlagTouchEvent[] | undefined;
    flagTouches?: FlagTouchEvent[] | undefined;
    flagCaptures?: FlagCaptureEvent[] | undefined;
    flagReturns?: FlagReturnEvent[] | undefined;

    constructor(data?: IGameEvents) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameTic = _data["gameTic"];
            if (Array.isArray(_data["accuracyEvents"])) {
                this.accuracyEvents = [] as any;
                for (let item of _data["accuracyEvents"])
                    this.accuracyEvents!.push(AccuracyEvent.fromJS(item));
            }
            if (Array.isArray(_data["kills"])) {
                this.kills = [] as any;
                for (let item of _data["kills"])
                    this.kills!.push(KillEvent.fromJS(item));
            }
            if (Array.isArray(_data["carrierKills"])) {
                this.carrierKills = [] as any;
                for (let item of _data["carrierKills"])
                    this.carrierKills!.push(KillEvent.fromJS(item));
            }
            if (Array.isArray(_data["suicides"])) {
                this.suicides = [] as any;
                for (let item of _data["suicides"])
                    this.suicides!.push(KillEvent.fromJS(item));
            }
            if (Array.isArray(_data["suicidesWithFlag"])) {
                this.suicidesWithFlag = [] as any;
                for (let item of _data["suicidesWithFlag"])
                    this.suicidesWithFlag!.push(KillEvent.fromJS(item));
            }
            if (Array.isArray(_data["environmentalDeaths"])) {
                this.environmentalDeaths = [] as any;
                for (let item of _data["environmentalDeaths"])
                    this.environmentalDeaths!.push(KillEvent.fromJS(item));
            }
            if (Array.isArray(_data["environmentalDeathsWithFlag"])) {
                this.environmentalDeathsWithFlag = [] as any;
                for (let item of _data["environmentalDeathsWithFlag"])
                    this.environmentalDeathsWithFlag!.push(KillEvent.fromJS(item));
            }
            if (Array.isArray(_data["damage"])) {
                this.damage = [] as any;
                for (let item of _data["damage"])
                    this.damage!.push(DamageEvent.fromJS(item));
            }
            if (Array.isArray(_data["selfDamage"])) {
                this.selfDamage = [] as any;
                for (let item of _data["selfDamage"])
                    this.selfDamage!.push(DamageEvent.fromJS(item));
            }
            if (Array.isArray(_data["selfDamageWithFlag"])) {
                this.selfDamageWithFlag = [] as any;
                for (let item of _data["selfDamageWithFlag"])
                    this.selfDamageWithFlag!.push(DamageEvent.fromJS(item));
            }
            if (Array.isArray(_data["environmentalDamage"])) {
                this.environmentalDamage = [] as any;
                for (let item of _data["environmentalDamage"])
                    this.environmentalDamage!.push(DamageEvent.fromJS(item));
            }
            if (Array.isArray(_data["environmentalDamageWithFlag"])) {
                this.environmentalDamageWithFlag = [] as any;
                for (let item of _data["environmentalDamageWithFlag"])
                    this.environmentalDamageWithFlag!.push(DamageEvent.fromJS(item));
            }
            if (Array.isArray(_data["pickups"])) {
                this.pickups = [] as any;
                for (let item of _data["pickups"])
                    this.pickups!.push(PickupEvent.fromJS(item));
            }
            if (Array.isArray(_data["pickupFlagTouches"])) {
                this.pickupFlagTouches = [] as any;
                for (let item of _data["pickupFlagTouches"])
                    this.pickupFlagTouches!.push(FlagTouchEvent.fromJS(item));
            }
            if (Array.isArray(_data["flagTouches"])) {
                this.flagTouches = [] as any;
                for (let item of _data["flagTouches"])
                    this.flagTouches!.push(FlagTouchEvent.fromJS(item));
            }
            if (Array.isArray(_data["flagCaptures"])) {
                this.flagCaptures = [] as any;
                for (let item of _data["flagCaptures"])
                    this.flagCaptures!.push(FlagCaptureEvent.fromJS(item));
            }
            if (Array.isArray(_data["flagReturns"])) {
                this.flagReturns = [] as any;
                for (let item of _data["flagReturns"])
                    this.flagReturns!.push(FlagReturnEvent.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GameEvents {
        data = typeof data === 'object' ? data : {};
        let result = new GameEvents();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameTic"] = this.gameTic;
        if (Array.isArray(this.accuracyEvents)) {
            data["accuracyEvents"] = [];
            for (let item of this.accuracyEvents)
                data["accuracyEvents"].push(item.toJSON());
        }
        if (Array.isArray(this.kills)) {
            data["kills"] = [];
            for (let item of this.kills)
                data["kills"].push(item.toJSON());
        }
        if (Array.isArray(this.carrierKills)) {
            data["carrierKills"] = [];
            for (let item of this.carrierKills)
                data["carrierKills"].push(item.toJSON());
        }
        if (Array.isArray(this.suicides)) {
            data["suicides"] = [];
            for (let item of this.suicides)
                data["suicides"].push(item.toJSON());
        }
        if (Array.isArray(this.suicidesWithFlag)) {
            data["suicidesWithFlag"] = [];
            for (let item of this.suicidesWithFlag)
                data["suicidesWithFlag"].push(item.toJSON());
        }
        if (Array.isArray(this.environmentalDeaths)) {
            data["environmentalDeaths"] = [];
            for (let item of this.environmentalDeaths)
                data["environmentalDeaths"].push(item.toJSON());
        }
        if (Array.isArray(this.environmentalDeathsWithFlag)) {
            data["environmentalDeathsWithFlag"] = [];
            for (let item of this.environmentalDeathsWithFlag)
                data["environmentalDeathsWithFlag"].push(item.toJSON());
        }
        if (Array.isArray(this.damage)) {
            data["damage"] = [];
            for (let item of this.damage)
                data["damage"].push(item.toJSON());
        }
        if (Array.isArray(this.selfDamage)) {
            data["selfDamage"] = [];
            for (let item of this.selfDamage)
                data["selfDamage"].push(item.toJSON());
        }
        if (Array.isArray(this.selfDamageWithFlag)) {
            data["selfDamageWithFlag"] = [];
            for (let item of this.selfDamageWithFlag)
                data["selfDamageWithFlag"].push(item.toJSON());
        }
        if (Array.isArray(this.environmentalDamage)) {
            data["environmentalDamage"] = [];
            for (let item of this.environmentalDamage)
                data["environmentalDamage"].push(item.toJSON());
        }
        if (Array.isArray(this.environmentalDamageWithFlag)) {
            data["environmentalDamageWithFlag"] = [];
            for (let item of this.environmentalDamageWithFlag)
                data["environmentalDamageWithFlag"].push(item.toJSON());
        }
        if (Array.isArray(this.pickups)) {
            data["pickups"] = [];
            for (let item of this.pickups)
                data["pickups"].push(item.toJSON());
        }
        if (Array.isArray(this.pickupFlagTouches)) {
            data["pickupFlagTouches"] = [];
            for (let item of this.pickupFlagTouches)
                data["pickupFlagTouches"].push(item.toJSON());
        }
        if (Array.isArray(this.flagTouches)) {
            data["flagTouches"] = [];
            for (let item of this.flagTouches)
                data["flagTouches"].push(item.toJSON());
        }
        if (Array.isArray(this.flagCaptures)) {
            data["flagCaptures"] = [];
            for (let item of this.flagCaptures)
                data["flagCaptures"].push(item.toJSON());
        }
        if (Array.isArray(this.flagReturns)) {
            data["flagReturns"] = [];
            for (let item of this.flagReturns)
                data["flagReturns"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGameEvents {
    gameTic?: number;
    accuracyEvents?: AccuracyEvent[] | undefined;
    kills?: KillEvent[] | undefined;
    carrierKills?: KillEvent[] | undefined;
    suicides?: KillEvent[] | undefined;
    suicidesWithFlag?: KillEvent[] | undefined;
    environmentalDeaths?: KillEvent[] | undefined;
    environmentalDeathsWithFlag?: KillEvent[] | undefined;
    damage?: DamageEvent[] | undefined;
    selfDamage?: DamageEvent[] | undefined;
    selfDamageWithFlag?: DamageEvent[] | undefined;
    environmentalDamage?: DamageEvent[] | undefined;
    environmentalDamageWithFlag?: DamageEvent[] | undefined;
    pickups?: PickupEvent[] | undefined;
    pickupFlagTouches?: FlagTouchEvent[] | undefined;
    flagTouches?: FlagTouchEvent[] | undefined;
    flagCaptures?: FlagCaptureEvent[] | undefined;
    flagReturns?: FlagReturnEvent[] | undefined;
}

export class AccuracyEvent implements IAccuracyEvent {
    shooterName?: string | undefined;
    targetName?: string | undefined;
    weapon?: Weapons;
    hitMiss?: boolean;
    spritePercent?: number;
    pinpointPercent?: number;
    angleBits?: number;
    activatorX?: number;
    activatorY?: number;
    activatorZ?: number;
    targetX?: number;
    targetY?: number;
    targetZ?: number;

    constructor(data?: IAccuracyEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shooterName = _data["shooterName"];
            this.targetName = _data["targetName"];
            this.weapon = _data["weapon"];
            this.hitMiss = _data["hitMiss"];
            this.spritePercent = _data["spritePercent"];
            this.pinpointPercent = _data["pinpointPercent"];
            this.angleBits = _data["angleBits"];
            this.activatorX = _data["activatorX"];
            this.activatorY = _data["activatorY"];
            this.activatorZ = _data["activatorZ"];
            this.targetX = _data["targetX"];
            this.targetY = _data["targetY"];
            this.targetZ = _data["targetZ"];
        }
    }

    static fromJS(data: any): AccuracyEvent {
        data = typeof data === 'object' ? data : {};
        let result = new AccuracyEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shooterName"] = this.shooterName;
        data["targetName"] = this.targetName;
        data["weapon"] = this.weapon;
        data["hitMiss"] = this.hitMiss;
        data["spritePercent"] = this.spritePercent;
        data["pinpointPercent"] = this.pinpointPercent;
        data["angleBits"] = this.angleBits;
        data["activatorX"] = this.activatorX;
        data["activatorY"] = this.activatorY;
        data["activatorZ"] = this.activatorZ;
        data["targetX"] = this.targetX;
        data["targetY"] = this.targetY;
        data["targetZ"] = this.targetZ;
        return data;
    }
}

export interface IAccuracyEvent {
    shooterName?: string | undefined;
    targetName?: string | undefined;
    weapon?: Weapons;
    hitMiss?: boolean;
    spritePercent?: number;
    pinpointPercent?: number;
    angleBits?: number;
    activatorX?: number;
    activatorY?: number;
    activatorZ?: number;
    targetX?: number;
    targetY?: number;
    targetZ?: number;
}

export enum Weapons {
    Unknown = 0,
    Fist = 1,
    Pistol = 2,
    Shotgun = 3,
    Chaingun = 4,
    Rocket = 5,
    RocketSplash = 6,
    PlasmaRifle = 7,
    BfgBall = 8,
    BfgSplash = 9,
    Chainsaw = 10,
    SuperShotgun = 11,
    Water = 12,
    Slime = 13,
    Lava = 14,
    Crusher = 15,
    Telefrag = 16,
    Falling = 17,
    Suicide = 18,
    Barrel = 19,
    Exit = 20,
    Splash = 21,
    Hit = 22,
    Railgun = 23,
}

export class KillEvent implements IKillEvent {
    shooterName?: string | undefined;
    targetName?: string | undefined;
    weapon?: Mods2;
    activatorX?: number;
    activatorY?: number;
    activatorZ?: number;
    targetX?: number;
    targetY?: number;
    targetZ?: number;

    constructor(data?: IKillEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shooterName = _data["shooterName"];
            this.targetName = _data["targetName"];
            this.weapon = _data["weapon"];
            this.activatorX = _data["activatorX"];
            this.activatorY = _data["activatorY"];
            this.activatorZ = _data["activatorZ"];
            this.targetX = _data["targetX"];
            this.targetY = _data["targetY"];
            this.targetZ = _data["targetZ"];
        }
    }

    static fromJS(data: any): KillEvent {
        data = typeof data === 'object' ? data : {};
        let result = new KillEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shooterName"] = this.shooterName;
        data["targetName"] = this.targetName;
        data["weapon"] = this.weapon;
        data["activatorX"] = this.activatorX;
        data["activatorY"] = this.activatorY;
        data["activatorZ"] = this.activatorZ;
        data["targetX"] = this.targetX;
        data["targetY"] = this.targetY;
        data["targetZ"] = this.targetZ;
        return data;
    }
}

export interface IKillEvent {
    shooterName?: string | undefined;
    targetName?: string | undefined;
    weapon?: Mods2;
    activatorX?: number;
    activatorY?: number;
    activatorZ?: number;
    targetX?: number;
    targetY?: number;
    targetZ?: number;
}

export class DamageEvent implements IDamageEvent {
    shooterName?: string | undefined;
    targetName?: string | undefined;
    damageType?: Mods2;
    activatorX?: number;
    activatorY?: number;
    activatorZ?: number;
    targetX?: number;
    targetY?: number;
    targetZ?: number;
    hp?: number;
    blueArmor?: number;
    greenArmor?: number;

    constructor(data?: IDamageEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shooterName = _data["shooterName"];
            this.targetName = _data["targetName"];
            this.damageType = _data["damageType"];
            this.activatorX = _data["activatorX"];
            this.activatorY = _data["activatorY"];
            this.activatorZ = _data["activatorZ"];
            this.targetX = _data["targetX"];
            this.targetY = _data["targetY"];
            this.targetZ = _data["targetZ"];
            this.hp = _data["hp"];
            this.blueArmor = _data["blueArmor"];
            this.greenArmor = _data["greenArmor"];
        }
    }

    static fromJS(data: any): DamageEvent {
        data = typeof data === 'object' ? data : {};
        let result = new DamageEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shooterName"] = this.shooterName;
        data["targetName"] = this.targetName;
        data["damageType"] = this.damageType;
        data["activatorX"] = this.activatorX;
        data["activatorY"] = this.activatorY;
        data["activatorZ"] = this.activatorZ;
        data["targetX"] = this.targetX;
        data["targetY"] = this.targetY;
        data["targetZ"] = this.targetZ;
        data["hp"] = this.hp;
        data["blueArmor"] = this.blueArmor;
        data["greenArmor"] = this.greenArmor;
        return data;
    }
}

export interface IDamageEvent {
    shooterName?: string | undefined;
    targetName?: string | undefined;
    damageType?: Mods2;
    activatorX?: number;
    activatorY?: number;
    activatorZ?: number;
    targetX?: number;
    targetY?: number;
    targetZ?: number;
    hp?: number;
    blueArmor?: number;
    greenArmor?: number;
}

export class PickupEvent implements IPickupEvent {
    playerName?: string | undefined;
    type?: Pickups;
    activatorX?: number;
    activatorY?: number;
    activatorZ?: number;

    constructor(data?: IPickupEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerName = _data["playerName"];
            this.type = _data["type"];
            this.activatorX = _data["activatorX"];
            this.activatorY = _data["activatorY"];
            this.activatorZ = _data["activatorZ"];
        }
    }

    static fromJS(data: any): PickupEvent {
        data = typeof data === 'object' ? data : {};
        let result = new PickupEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerName"] = this.playerName;
        data["type"] = this.type;
        data["activatorX"] = this.activatorX;
        data["activatorY"] = this.activatorY;
        data["activatorZ"] = this.activatorZ;
        return data;
    }
}

export interface IPickupEvent {
    playerName?: string | undefined;
    type?: Pickups;
    activatorX?: number;
    activatorY?: number;
    activatorZ?: number;
}

export class FlagTouchEvent implements IFlagTouchEvent {
    playerName?: string | undefined;
    activatorX?: number;
    activatorY?: number;
    activatorZ?: number;

    constructor(data?: IFlagTouchEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerName = _data["playerName"];
            this.activatorX = _data["activatorX"];
            this.activatorY = _data["activatorY"];
            this.activatorZ = _data["activatorZ"];
        }
    }

    static fromJS(data: any): FlagTouchEvent {
        data = typeof data === 'object' ? data : {};
        let result = new FlagTouchEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerName"] = this.playerName;
        data["activatorX"] = this.activatorX;
        data["activatorY"] = this.activatorY;
        data["activatorZ"] = this.activatorZ;
        return data;
    }
}

export interface IFlagTouchEvent {
    playerName?: string | undefined;
    activatorX?: number;
    activatorY?: number;
    activatorZ?: number;
}

export class FlagCaptureEvent implements IFlagCaptureEvent {
    playerName?: string | undefined;
    activatorX?: number;
    activatorY?: number;
    activatorZ?: number;

    constructor(data?: IFlagCaptureEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerName = _data["playerName"];
            this.activatorX = _data["activatorX"];
            this.activatorY = _data["activatorY"];
            this.activatorZ = _data["activatorZ"];
        }
    }

    static fromJS(data: any): FlagCaptureEvent {
        data = typeof data === 'object' ? data : {};
        let result = new FlagCaptureEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerName"] = this.playerName;
        data["activatorX"] = this.activatorX;
        data["activatorY"] = this.activatorY;
        data["activatorZ"] = this.activatorZ;
        return data;
    }
}

export interface IFlagCaptureEvent {
    playerName?: string | undefined;
    activatorX?: number;
    activatorY?: number;
    activatorZ?: number;
}

export class FlagReturnEvent implements IFlagReturnEvent {
    playerName?: string | undefined;
    activatorX?: number;
    activatorY?: number;
    activatorZ?: number;

    constructor(data?: IFlagReturnEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerName = _data["playerName"];
            this.activatorX = _data["activatorX"];
            this.activatorY = _data["activatorY"];
            this.activatorZ = _data["activatorZ"];
        }
    }

    static fromJS(data: any): FlagReturnEvent {
        data = typeof data === 'object' ? data : {};
        let result = new FlagReturnEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerName"] = this.playerName;
        data["activatorX"] = this.activatorX;
        data["activatorY"] = this.activatorY;
        data["activatorZ"] = this.activatorZ;
        return data;
    }
}

export interface IFlagReturnEvent {
    playerName?: string | undefined;
    activatorX?: number;
    activatorY?: number;
    activatorZ?: number;
}

export class DeleteMapImageFileCommand implements IDeleteMapImageFileCommand {
    mapImageId?: number;

    constructor(data?: IDeleteMapImageFileCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapImageId = _data["mapImageId"];
        }
    }

    static fromJS(data: any): DeleteMapImageFileCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMapImageFileCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapImageId"] = this.mapImageId;
        return data;
    }
}

export interface IDeleteMapImageFileCommand {
    mapImageId?: number;
}

export class PlayerLeaderboardSeasonStatsVm implements IPlayerLeaderboardSeasonStatsVm {
    seasonId?: number | undefined;
    seasonName?: string | undefined;
    playerLeaderboardStats?: LeaderboardStatsDto[] | undefined;

    constructor(data?: IPlayerLeaderboardSeasonStatsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seasonId = _data["seasonId"];
            this.seasonName = _data["seasonName"];
            if (Array.isArray(_data["playerLeaderboardStats"])) {
                this.playerLeaderboardStats = [] as any;
                for (let item of _data["playerLeaderboardStats"])
                    this.playerLeaderboardStats!.push(LeaderboardStatsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayerLeaderboardSeasonStatsVm {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerLeaderboardSeasonStatsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seasonId"] = this.seasonId;
        data["seasonName"] = this.seasonName;
        if (Array.isArray(this.playerLeaderboardStats)) {
            data["playerLeaderboardStats"] = [];
            for (let item of this.playerLeaderboardStats)
                data["playerLeaderboardStats"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlayerLeaderboardSeasonStatsVm {
    seasonId?: number | undefined;
    seasonName?: string | undefined;
    playerLeaderboardStats?: LeaderboardStatsDto[] | undefined;
}

export class LeaderboardStatsDto implements ILeaderboardStatsDto {
    id?: number;
    playerName?: string | undefined;
    gamesPlayed?: number;
    roundsPlayed?: number;
    minutesPlayed?: number;
    damage?: number;
    points?: number;
    captures?: number;
    pickupCaptures?: number;
    assists?: number;
    touches?: number;
    pickupTouches?: number;
    flagDefenses?: number;
    frags?: number;
    kdr?: number;
    overallCapRate?: number;
    capRate?: number;
    pCapRate?: number;
    assistRate?: number;
    wdlrat?: number;

    constructor(data?: ILeaderboardStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.playerName = _data["playerName"];
            this.gamesPlayed = _data["gamesPlayed"];
            this.roundsPlayed = _data["roundsPlayed"];
            this.minutesPlayed = _data["minutesPlayed"];
            this.damage = _data["damage"];
            this.points = _data["points"];
            this.captures = _data["captures"];
            this.pickupCaptures = _data["pickupCaptures"];
            this.assists = _data["assists"];
            this.touches = _data["touches"];
            this.pickupTouches = _data["pickupTouches"];
            this.flagDefenses = _data["flagDefenses"];
            this.frags = _data["frags"];
            this.kdr = _data["kdr"];
            this.overallCapRate = _data["overallCapRate"];
            this.capRate = _data["capRate"];
            this.pCapRate = _data["pCapRate"];
            this.assistRate = _data["assistRate"];
            this.wdlrat = _data["wdlrat"];
        }
    }

    static fromJS(data: any): LeaderboardStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaderboardStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["playerName"] = this.playerName;
        data["gamesPlayed"] = this.gamesPlayed;
        data["roundsPlayed"] = this.roundsPlayed;
        data["minutesPlayed"] = this.minutesPlayed;
        data["damage"] = this.damage;
        data["points"] = this.points;
        data["captures"] = this.captures;
        data["pickupCaptures"] = this.pickupCaptures;
        data["assists"] = this.assists;
        data["touches"] = this.touches;
        data["pickupTouches"] = this.pickupTouches;
        data["flagDefenses"] = this.flagDefenses;
        data["frags"] = this.frags;
        data["kdr"] = this.kdr;
        data["overallCapRate"] = this.overallCapRate;
        data["capRate"] = this.capRate;
        data["pCapRate"] = this.pCapRate;
        data["assistRate"] = this.assistRate;
        data["wdlrat"] = this.wdlrat;
        return data;
    }
}

export interface ILeaderboardStatsDto {
    id?: number;
    playerName?: string | undefined;
    gamesPlayed?: number;
    roundsPlayed?: number;
    minutesPlayed?: number;
    damage?: number;
    points?: number;
    captures?: number;
    pickupCaptures?: number;
    assists?: number;
    touches?: number;
    pickupTouches?: number;
    flagDefenses?: number;
    frags?: number;
    kdr?: number;
    overallCapRate?: number;
    capRate?: number;
    pCapRate?: number;
    assistRate?: number;
    wdlrat?: number;
}

export enum LeaderboardStatsMode {
    PerRound = "Per Round",
    Total = "Total",
    Per1Min = "Per Minute",
    Per8Min = "Per 8 Minutes",
}

export enum LeaderboardStatsType {
    Points = "PTS",
    Captures = "CAPS",
    PickupCaptures = "PCAPS",
    Assists = "ASTS",
    Touches = "T",
    PickupTouches = "PT",
    FlagDefenses = "DEFS",
    Frags = "KILLS",
    KDR = "KDR",
    Damage = "DMG",
    OverallCapRate = "OVR CAP %",
    CapRate = "CAP %",
    PickCapRate = "PCAP %",
    AssistRate = "AST %",
    Rating = "RAT",
}

export class LeaguesVm implements ILeaguesVm {
    leagueList?: LeaguesDto[] | undefined;

    constructor(data?: ILeaguesVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["leagueList"])) {
                this.leagueList = [] as any;
                for (let item of _data["leagueList"])
                    this.leagueList!.push(LeaguesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LeaguesVm {
        data = typeof data === 'object' ? data : {};
        let result = new LeaguesVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.leagueList)) {
            data["leagueList"] = [];
            for (let item of this.leagueList)
                data["leagueList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILeaguesVm {
    leagueList?: LeaguesDto[] | undefined;
}

export class LeaguesDto implements ILeaguesDto {
    id?: number;
    leagueName?: string | undefined;
    leagueShortName?: string | undefined;
    leagueFounded?: Date;
    leagueFounder?: string | undefined;
    leagueImageFileName?: string | undefined;

    constructor(data?: ILeaguesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.leagueName = _data["leagueName"];
            this.leagueShortName = _data["leagueShortName"];
            this.leagueFounded = _data["leagueFounded"] ? new Date(_data["leagueFounded"].toString()) : <any>undefined;
            this.leagueFounder = _data["leagueFounder"];
            this.leagueImageFileName = _data["leagueImageFileName"];
        }
    }

    static fromJS(data: any): LeaguesDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaguesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["leagueName"] = this.leagueName;
        data["leagueShortName"] = this.leagueShortName;
        data["leagueFounded"] = this.leagueFounded ? this.leagueFounded.toISOString() : <any>undefined;
        data["leagueFounder"] = this.leagueFounder;
        data["leagueImageFileName"] = this.leagueImageFileName;
        return data;
    }
}

export interface ILeaguesDto {
    id?: number;
    leagueName?: string | undefined;
    leagueShortName?: string | undefined;
    leagueFounded?: Date;
    leagueFounder?: string | undefined;
    leagueImageFileName?: string | undefined;
}

export class CreateLeagueCommand implements ICreateLeagueCommand {
    leagueName?: string | undefined;
    leagueShortName?: string | undefined;
    leagueFounded?: Date;
    leagueFounder?: string | undefined;
    leaguePicFilename?: string | undefined;

    constructor(data?: ICreateLeagueCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leagueName = _data["leagueName"];
            this.leagueShortName = _data["leagueShortName"];
            this.leagueFounded = _data["leagueFounded"] ? new Date(_data["leagueFounded"].toString()) : <any>undefined;
            this.leagueFounder = _data["leagueFounder"];
            this.leaguePicFilename = _data["leaguePicFilename"];
        }
    }

    static fromJS(data: any): CreateLeagueCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLeagueCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leagueName"] = this.leagueName;
        data["leagueShortName"] = this.leagueShortName;
        data["leagueFounded"] = this.leagueFounded ? this.leagueFounded.toISOString() : <any>undefined;
        data["leagueFounder"] = this.leagueFounder;
        data["leaguePicFilename"] = this.leaguePicFilename;
        return data;
    }
}

export interface ICreateLeagueCommand {
    leagueName?: string | undefined;
    leagueShortName?: string | undefined;
    leagueFounded?: Date;
    leagueFounder?: string | undefined;
    leaguePicFilename?: string | undefined;
}

export class UpdateLeagueCommand implements IUpdateLeagueCommand {
    leagueId?: number;
    leagueName?: string | undefined;
    leagueShortName?: string | undefined;
    leagueFounded?: Date;
    leagueFounder?: string | undefined;
    leaguePicFilename?: string | undefined;

    constructor(data?: IUpdateLeagueCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leagueId = _data["leagueId"];
            this.leagueName = _data["leagueName"];
            this.leagueShortName = _data["leagueShortName"];
            this.leagueFounded = _data["leagueFounded"] ? new Date(_data["leagueFounded"].toString()) : <any>undefined;
            this.leagueFounder = _data["leagueFounder"];
            this.leaguePicFilename = _data["leaguePicFilename"];
        }
    }

    static fromJS(data: any): UpdateLeagueCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLeagueCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leagueId"] = this.leagueId;
        data["leagueName"] = this.leagueName;
        data["leagueShortName"] = this.leagueShortName;
        data["leagueFounded"] = this.leagueFounded ? this.leagueFounded.toISOString() : <any>undefined;
        data["leagueFounder"] = this.leagueFounder;
        data["leaguePicFilename"] = this.leaguePicFilename;
        return data;
    }
}

export interface IUpdateLeagueCommand {
    leagueId?: number;
    leagueName?: string | undefined;
    leagueShortName?: string | undefined;
    leagueFounded?: Date;
    leagueFounder?: string | undefined;
    leaguePicFilename?: string | undefined;
}

export class MapsVm implements IMapsVm {
    mapList?: MapsDto[] | undefined;

    constructor(data?: IMapsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mapList"])) {
                this.mapList = [] as any;
                for (let item of _data["mapList"])
                    this.mapList!.push(MapsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MapsVm {
        data = typeof data === 'object' ? data : {};
        let result = new MapsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mapList)) {
            data["mapList"] = [];
            for (let item of this.mapList)
                data["mapList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMapsVm {
    mapList?: MapsDto[] | undefined;
}

export class MapsDto implements IMapsDto {
    id?: number;
    mapName?: string | undefined;
    mapPack?: string | undefined;
    mapNumber?: number;

    constructor(data?: IMapsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mapName = _data["mapName"];
            this.mapPack = _data["mapPack"];
            this.mapNumber = _data["mapNumber"];
        }
    }

    static fromJS(data: any): MapsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MapsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mapName"] = this.mapName;
        data["mapPack"] = this.mapPack;
        data["mapNumber"] = this.mapNumber;
        return data;
    }
}

export interface IMapsDto {
    id?: number;
    mapName?: string | undefined;
    mapPack?: string | undefined;
    mapNumber?: number;
}

export class MapImagesVm implements IMapImagesVm {
    mapImages?: MapImagesDto[] | undefined;

    constructor(data?: IMapImagesVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mapImages"])) {
                this.mapImages = [] as any;
                for (let item of _data["mapImages"])
                    this.mapImages!.push(MapImagesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MapImagesVm {
        data = typeof data === 'object' ? data : {};
        let result = new MapImagesVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mapImages)) {
            data["mapImages"] = [];
            for (let item of this.mapImages)
                data["mapImages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMapImagesVm {
    mapImages?: MapImagesDto[] | undefined;
}

export class MapImagesDto implements IMapImagesDto {
    id?: number;
    imagePath?: string | undefined;
    imageCaption?: string | undefined;
    priority?: number;

    constructor(data?: IMapImagesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imagePath = _data["imagePath"];
            this.imageCaption = _data["imageCaption"];
            this.priority = _data["priority"];
        }
    }

    static fromJS(data: any): MapImagesDto {
        data = typeof data === 'object' ? data : {};
        let result = new MapImagesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imagePath"] = this.imagePath;
        data["imageCaption"] = this.imageCaption;
        data["priority"] = this.priority;
        return data;
    }
}

export interface IMapImagesDto {
    id?: number;
    imagePath?: string | undefined;
    imageCaption?: string | undefined;
    priority?: number;
}

export class MapSummaryVm implements IMapSummaryVm {
    mapId?: number;
    mapName?: string | undefined;
    mapPack?: string | undefined;
    mapNumber?: string | undefined;
    mapImages?: MapSummaryImagesDto[] | undefined;
    seasonsFeaturingMap?: MapSeasonsDto[] | undefined;
    teamHomefields?: MapTeamHomefieldsDto[] | undefined;
    regularSeasonGamesPlayed?: number;
    playoffsGamesPlayed?: number;
    finalsGamesPlayed?: number;
    mapStats?: MapStatsDto | undefined;

    constructor(data?: IMapSummaryVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapId = _data["mapId"];
            this.mapName = _data["mapName"];
            this.mapPack = _data["mapPack"];
            this.mapNumber = _data["mapNumber"];
            if (Array.isArray(_data["mapImages"])) {
                this.mapImages = [] as any;
                for (let item of _data["mapImages"])
                    this.mapImages!.push(MapSummaryImagesDto.fromJS(item));
            }
            if (Array.isArray(_data["seasonsFeaturingMap"])) {
                this.seasonsFeaturingMap = [] as any;
                for (let item of _data["seasonsFeaturingMap"])
                    this.seasonsFeaturingMap!.push(MapSeasonsDto.fromJS(item));
            }
            if (Array.isArray(_data["teamHomefields"])) {
                this.teamHomefields = [] as any;
                for (let item of _data["teamHomefields"])
                    this.teamHomefields!.push(MapTeamHomefieldsDto.fromJS(item));
            }
            this.regularSeasonGamesPlayed = _data["regularSeasonGamesPlayed"];
            this.playoffsGamesPlayed = _data["playoffsGamesPlayed"];
            this.finalsGamesPlayed = _data["finalsGamesPlayed"];
            this.mapStats = _data["mapStats"] ? MapStatsDto.fromJS(_data["mapStats"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MapSummaryVm {
        data = typeof data === 'object' ? data : {};
        let result = new MapSummaryVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapId"] = this.mapId;
        data["mapName"] = this.mapName;
        data["mapPack"] = this.mapPack;
        data["mapNumber"] = this.mapNumber;
        if (Array.isArray(this.mapImages)) {
            data["mapImages"] = [];
            for (let item of this.mapImages)
                data["mapImages"].push(item.toJSON());
        }
        if (Array.isArray(this.seasonsFeaturingMap)) {
            data["seasonsFeaturingMap"] = [];
            for (let item of this.seasonsFeaturingMap)
                data["seasonsFeaturingMap"].push(item.toJSON());
        }
        if (Array.isArray(this.teamHomefields)) {
            data["teamHomefields"] = [];
            for (let item of this.teamHomefields)
                data["teamHomefields"].push(item.toJSON());
        }
        data["regularSeasonGamesPlayed"] = this.regularSeasonGamesPlayed;
        data["playoffsGamesPlayed"] = this.playoffsGamesPlayed;
        data["finalsGamesPlayed"] = this.finalsGamesPlayed;
        data["mapStats"] = this.mapStats ? this.mapStats.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMapSummaryVm {
    mapId?: number;
    mapName?: string | undefined;
    mapPack?: string | undefined;
    mapNumber?: string | undefined;
    mapImages?: MapSummaryImagesDto[] | undefined;
    seasonsFeaturingMap?: MapSeasonsDto[] | undefined;
    teamHomefields?: MapTeamHomefieldsDto[] | undefined;
    regularSeasonGamesPlayed?: number;
    playoffsGamesPlayed?: number;
    finalsGamesPlayed?: number;
    mapStats?: MapStatsDto | undefined;
}

export class MapSummaryImagesDto implements IMapSummaryImagesDto {
    id?: number;
    imagePath?: string | undefined;
    imageCaption?: string | undefined;
    priority?: number;

    constructor(data?: IMapSummaryImagesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imagePath = _data["imagePath"];
            this.imageCaption = _data["imageCaption"];
            this.priority = _data["priority"];
        }
    }

    static fromJS(data: any): MapSummaryImagesDto {
        data = typeof data === 'object' ? data : {};
        let result = new MapSummaryImagesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imagePath"] = this.imagePath;
        data["imageCaption"] = this.imageCaption;
        data["priority"] = this.priority;
        return data;
    }
}

export interface IMapSummaryImagesDto {
    id?: number;
    imagePath?: string | undefined;
    imageCaption?: string | undefined;
    priority?: number;
}

export class MapSeasonsDto implements IMapSeasonsDto {
    seasonId?: number;
    seasonName?: string | undefined;
    regularSeasonAppearance?: boolean;
    playoffAppearance?: boolean;
    finalsAppearance?: boolean;

    constructor(data?: IMapSeasonsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seasonId = _data["seasonId"];
            this.seasonName = _data["seasonName"];
            this.regularSeasonAppearance = _data["regularSeasonAppearance"];
            this.playoffAppearance = _data["playoffAppearance"];
            this.finalsAppearance = _data["finalsAppearance"];
        }
    }

    static fromJS(data: any): MapSeasonsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MapSeasonsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seasonId"] = this.seasonId;
        data["seasonName"] = this.seasonName;
        data["regularSeasonAppearance"] = this.regularSeasonAppearance;
        data["playoffAppearance"] = this.playoffAppearance;
        data["finalsAppearance"] = this.finalsAppearance;
        return data;
    }
}

export interface IMapSeasonsDto {
    seasonId?: number;
    seasonName?: string | undefined;
    regularSeasonAppearance?: boolean;
    playoffAppearance?: boolean;
    finalsAppearance?: boolean;
}

export class MapTeamHomefieldsDto implements IMapTeamHomefieldsDto {
    teamId?: number;
    teamName?: string | undefined;
    teamAbv?: string | undefined;
    seasonId?: number;
    seasonName?: string | undefined;

    constructor(data?: IMapTeamHomefieldsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.teamName = _data["teamName"];
            this.teamAbv = _data["teamAbv"];
            this.seasonId = _data["seasonId"];
            this.seasonName = _data["seasonName"];
        }
    }

    static fromJS(data: any): MapTeamHomefieldsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MapTeamHomefieldsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["teamName"] = this.teamName;
        data["teamAbv"] = this.teamAbv;
        data["seasonId"] = this.seasonId;
        data["seasonName"] = this.seasonName;
        return data;
    }
}

export interface IMapTeamHomefieldsDto {
    teamId?: number;
    teamName?: string | undefined;
    teamAbv?: string | undefined;
    seasonId?: number;
    seasonName?: string | undefined;
}

export class MapStatsDto implements IMapStatsDto {
    gamesPlayed?: number;
    roundsPlayed?: number;
    timePlayed?: string;
    points?: number;
    captures?: number;
    pickupCaptures?: number;
    assists?: number;
    damageBetweenTouchAndCaptureMin?: number | undefined;
    damageBetweenTouchAndCaptureMax?: number | undefined;
    damageBetweenTouchAndCaptureAverage?: number | undefined;
    captureTimeMin?: string;
    captureTimeMax?: string;
    captureTimeAverage?: string;
    captureHealthMin?: number | undefined;
    captureHealthMax?: number | undefined;
    captureHealthAverage?: number | undefined;
    captureGreenArmorMin?: number | undefined;
    captureGreenArmorMax?: number | undefined;
    captureGreenArmorAverage?: number | undefined;
    captureBlueArmorMin?: number | undefined;
    captureBlueArmorMax?: number | undefined;
    captureBlueArmorAverage?: number | undefined;
    capturesWithSuperPickups?: number;
    flagCarriersKilledWhileHoldingFlag?: number;
    highestKillsBeforeCapturing?: number;
    pickupCaptureTimeMin?: string;
    pickupCaptureTimeMax?: string;
    pickupCaptureTimeAverage?: string;
    flagTouches?: number;
    pickupFlagTouches?: number;
    flagDefenses?: number;
    flagReturns?: number;
    frags?: number;
    deaths?: number;
    environmentalDeaths?: number;
    environmentalFlagCarrierDeaths?: number;
    teamKills?: number;
    killingSprees?: number;
    rampages?: number;
    dominatings?: number;
    unstoppables?: number;
    godLikes?: number;
    wickedSicks?: number;
    longestSpree?: number;
    doubleKills?: number;
    multiKills?: number;
    ultraKills?: number;
    monsterKills?: number;
    highestMultiKill?: number;
    pickupHealthGained?: number;
    healthFromNonPowerups?: number;
    healthWhenTouchingFlagMin?: number | undefined;
    healthWhenTouchingFlagMax?: number | undefined;
    healthWhenTouchingFlagAverage?: number | undefined;
    greenArmorWhenTouchingFlagMin?: number | undefined;
    greenArmorWhenTouchingFlagMax?: number | undefined;
    greenArmorWhenTouchingFlagAverage?: number | undefined;
    blueArmorWhenTouchingFlagMin?: number | undefined;
    blueArmorWhenTouchingFlagMax?: number | undefined;
    blueArmorWhenTouchingFlagAverage?: number | undefined;
    healthWhenTouchingFlagThatResultsInCaptureMin?: number | undefined;
    healthWhenTouchingFlagThatResultsInCaptureMax?: number | undefined;
    healthWhenTouchingFlagThatResultsInCaptureAverage?: number | undefined;
    damage?: number;
    damageTakenFromEnvironment?: number;
    damageTakenFromEnvironmentAsFlagCarrier?: number;
    damageToFlagCarriers?: number;
    damageDoneWithFlag?: number;
    damageToGreenArmor?: number;
    damageToBlueArmor?: number;
    powerups?: number;

    constructor(data?: IMapStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gamesPlayed = _data["gamesPlayed"];
            this.roundsPlayed = _data["roundsPlayed"];
            this.timePlayed = _data["timePlayed"];
            this.points = _data["points"];
            this.captures = _data["captures"];
            this.pickupCaptures = _data["pickupCaptures"];
            this.assists = _data["assists"];
            this.damageBetweenTouchAndCaptureMin = _data["damageBetweenTouchAndCaptureMin"];
            this.damageBetweenTouchAndCaptureMax = _data["damageBetweenTouchAndCaptureMax"];
            this.damageBetweenTouchAndCaptureAverage = _data["damageBetweenTouchAndCaptureAverage"];
            this.captureTimeMin = _data["captureTimeMin"];
            this.captureTimeMax = _data["captureTimeMax"];
            this.captureTimeAverage = _data["captureTimeAverage"];
            this.captureHealthMin = _data["captureHealthMin"];
            this.captureHealthMax = _data["captureHealthMax"];
            this.captureHealthAverage = _data["captureHealthAverage"];
            this.captureGreenArmorMin = _data["captureGreenArmorMin"];
            this.captureGreenArmorMax = _data["captureGreenArmorMax"];
            this.captureGreenArmorAverage = _data["captureGreenArmorAverage"];
            this.captureBlueArmorMin = _data["captureBlueArmorMin"];
            this.captureBlueArmorMax = _data["captureBlueArmorMax"];
            this.captureBlueArmorAverage = _data["captureBlueArmorAverage"];
            this.capturesWithSuperPickups = _data["capturesWithSuperPickups"];
            this.flagCarriersKilledWhileHoldingFlag = _data["flagCarriersKilledWhileHoldingFlag"];
            this.highestKillsBeforeCapturing = _data["highestKillsBeforeCapturing"];
            this.pickupCaptureTimeMin = _data["pickupCaptureTimeMin"];
            this.pickupCaptureTimeMax = _data["pickupCaptureTimeMax"];
            this.pickupCaptureTimeAverage = _data["pickupCaptureTimeAverage"];
            this.flagTouches = _data["flagTouches"];
            this.pickupFlagTouches = _data["pickupFlagTouches"];
            this.flagDefenses = _data["flagDefenses"];
            this.flagReturns = _data["flagReturns"];
            this.frags = _data["frags"];
            this.deaths = _data["deaths"];
            this.environmentalDeaths = _data["environmentalDeaths"];
            this.environmentalFlagCarrierDeaths = _data["environmentalFlagCarrierDeaths"];
            this.teamKills = _data["teamKills"];
            this.killingSprees = _data["killingSprees"];
            this.rampages = _data["rampages"];
            this.dominatings = _data["dominatings"];
            this.unstoppables = _data["unstoppables"];
            this.godLikes = _data["godLikes"];
            this.wickedSicks = _data["wickedSicks"];
            this.longestSpree = _data["longestSpree"];
            this.doubleKills = _data["doubleKills"];
            this.multiKills = _data["multiKills"];
            this.ultraKills = _data["ultraKills"];
            this.monsterKills = _data["monsterKills"];
            this.highestMultiKill = _data["highestMultiKill"];
            this.pickupHealthGained = _data["pickupHealthGained"];
            this.healthFromNonPowerups = _data["healthFromNonPowerups"];
            this.healthWhenTouchingFlagMin = _data["healthWhenTouchingFlagMin"];
            this.healthWhenTouchingFlagMax = _data["healthWhenTouchingFlagMax"];
            this.healthWhenTouchingFlagAverage = _data["healthWhenTouchingFlagAverage"];
            this.greenArmorWhenTouchingFlagMin = _data["greenArmorWhenTouchingFlagMin"];
            this.greenArmorWhenTouchingFlagMax = _data["greenArmorWhenTouchingFlagMax"];
            this.greenArmorWhenTouchingFlagAverage = _data["greenArmorWhenTouchingFlagAverage"];
            this.blueArmorWhenTouchingFlagMin = _data["blueArmorWhenTouchingFlagMin"];
            this.blueArmorWhenTouchingFlagMax = _data["blueArmorWhenTouchingFlagMax"];
            this.blueArmorWhenTouchingFlagAverage = _data["blueArmorWhenTouchingFlagAverage"];
            this.healthWhenTouchingFlagThatResultsInCaptureMin = _data["healthWhenTouchingFlagThatResultsInCaptureMin"];
            this.healthWhenTouchingFlagThatResultsInCaptureMax = _data["healthWhenTouchingFlagThatResultsInCaptureMax"];
            this.healthWhenTouchingFlagThatResultsInCaptureAverage = _data["healthWhenTouchingFlagThatResultsInCaptureAverage"];
            this.damage = _data["damage"];
            this.damageTakenFromEnvironment = _data["damageTakenFromEnvironment"];
            this.damageTakenFromEnvironmentAsFlagCarrier = _data["damageTakenFromEnvironmentAsFlagCarrier"];
            this.damageToFlagCarriers = _data["damageToFlagCarriers"];
            this.damageDoneWithFlag = _data["damageDoneWithFlag"];
            this.damageToGreenArmor = _data["damageToGreenArmor"];
            this.damageToBlueArmor = _data["damageToBlueArmor"];
            this.powerups = _data["powerups"];
        }
    }

    static fromJS(data: any): MapStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MapStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gamesPlayed"] = this.gamesPlayed;
        data["roundsPlayed"] = this.roundsPlayed;
        data["timePlayed"] = this.timePlayed;
        data["points"] = this.points;
        data["captures"] = this.captures;
        data["pickupCaptures"] = this.pickupCaptures;
        data["assists"] = this.assists;
        data["damageBetweenTouchAndCaptureMin"] = this.damageBetweenTouchAndCaptureMin;
        data["damageBetweenTouchAndCaptureMax"] = this.damageBetweenTouchAndCaptureMax;
        data["damageBetweenTouchAndCaptureAverage"] = this.damageBetweenTouchAndCaptureAverage;
        data["captureTimeMin"] = this.captureTimeMin;
        data["captureTimeMax"] = this.captureTimeMax;
        data["captureTimeAverage"] = this.captureTimeAverage;
        data["captureHealthMin"] = this.captureHealthMin;
        data["captureHealthMax"] = this.captureHealthMax;
        data["captureHealthAverage"] = this.captureHealthAverage;
        data["captureGreenArmorMin"] = this.captureGreenArmorMin;
        data["captureGreenArmorMax"] = this.captureGreenArmorMax;
        data["captureGreenArmorAverage"] = this.captureGreenArmorAverage;
        data["captureBlueArmorMin"] = this.captureBlueArmorMin;
        data["captureBlueArmorMax"] = this.captureBlueArmorMax;
        data["captureBlueArmorAverage"] = this.captureBlueArmorAverage;
        data["capturesWithSuperPickups"] = this.capturesWithSuperPickups;
        data["flagCarriersKilledWhileHoldingFlag"] = this.flagCarriersKilledWhileHoldingFlag;
        data["highestKillsBeforeCapturing"] = this.highestKillsBeforeCapturing;
        data["pickupCaptureTimeMin"] = this.pickupCaptureTimeMin;
        data["pickupCaptureTimeMax"] = this.pickupCaptureTimeMax;
        data["pickupCaptureTimeAverage"] = this.pickupCaptureTimeAverage;
        data["flagTouches"] = this.flagTouches;
        data["pickupFlagTouches"] = this.pickupFlagTouches;
        data["flagDefenses"] = this.flagDefenses;
        data["flagReturns"] = this.flagReturns;
        data["frags"] = this.frags;
        data["deaths"] = this.deaths;
        data["environmentalDeaths"] = this.environmentalDeaths;
        data["environmentalFlagCarrierDeaths"] = this.environmentalFlagCarrierDeaths;
        data["teamKills"] = this.teamKills;
        data["killingSprees"] = this.killingSprees;
        data["rampages"] = this.rampages;
        data["dominatings"] = this.dominatings;
        data["unstoppables"] = this.unstoppables;
        data["godLikes"] = this.godLikes;
        data["wickedSicks"] = this.wickedSicks;
        data["longestSpree"] = this.longestSpree;
        data["doubleKills"] = this.doubleKills;
        data["multiKills"] = this.multiKills;
        data["ultraKills"] = this.ultraKills;
        data["monsterKills"] = this.monsterKills;
        data["highestMultiKill"] = this.highestMultiKill;
        data["pickupHealthGained"] = this.pickupHealthGained;
        data["healthFromNonPowerups"] = this.healthFromNonPowerups;
        data["healthWhenTouchingFlagMin"] = this.healthWhenTouchingFlagMin;
        data["healthWhenTouchingFlagMax"] = this.healthWhenTouchingFlagMax;
        data["healthWhenTouchingFlagAverage"] = this.healthWhenTouchingFlagAverage;
        data["greenArmorWhenTouchingFlagMin"] = this.greenArmorWhenTouchingFlagMin;
        data["greenArmorWhenTouchingFlagMax"] = this.greenArmorWhenTouchingFlagMax;
        data["greenArmorWhenTouchingFlagAverage"] = this.greenArmorWhenTouchingFlagAverage;
        data["blueArmorWhenTouchingFlagMin"] = this.blueArmorWhenTouchingFlagMin;
        data["blueArmorWhenTouchingFlagMax"] = this.blueArmorWhenTouchingFlagMax;
        data["blueArmorWhenTouchingFlagAverage"] = this.blueArmorWhenTouchingFlagAverage;
        data["healthWhenTouchingFlagThatResultsInCaptureMin"] = this.healthWhenTouchingFlagThatResultsInCaptureMin;
        data["healthWhenTouchingFlagThatResultsInCaptureMax"] = this.healthWhenTouchingFlagThatResultsInCaptureMax;
        data["healthWhenTouchingFlagThatResultsInCaptureAverage"] = this.healthWhenTouchingFlagThatResultsInCaptureAverage;
        data["damage"] = this.damage;
        data["damageTakenFromEnvironment"] = this.damageTakenFromEnvironment;
        data["damageTakenFromEnvironmentAsFlagCarrier"] = this.damageTakenFromEnvironmentAsFlagCarrier;
        data["damageToFlagCarriers"] = this.damageToFlagCarriers;
        data["damageDoneWithFlag"] = this.damageDoneWithFlag;
        data["damageToGreenArmor"] = this.damageToGreenArmor;
        data["damageToBlueArmor"] = this.damageToBlueArmor;
        data["powerups"] = this.powerups;
        return data;
    }
}

export interface IMapStatsDto {
    gamesPlayed?: number;
    roundsPlayed?: number;
    timePlayed?: string;
    points?: number;
    captures?: number;
    pickupCaptures?: number;
    assists?: number;
    damageBetweenTouchAndCaptureMin?: number | undefined;
    damageBetweenTouchAndCaptureMax?: number | undefined;
    damageBetweenTouchAndCaptureAverage?: number | undefined;
    captureTimeMin?: string;
    captureTimeMax?: string;
    captureTimeAverage?: string;
    captureHealthMin?: number | undefined;
    captureHealthMax?: number | undefined;
    captureHealthAverage?: number | undefined;
    captureGreenArmorMin?: number | undefined;
    captureGreenArmorMax?: number | undefined;
    captureGreenArmorAverage?: number | undefined;
    captureBlueArmorMin?: number | undefined;
    captureBlueArmorMax?: number | undefined;
    captureBlueArmorAverage?: number | undefined;
    capturesWithSuperPickups?: number;
    flagCarriersKilledWhileHoldingFlag?: number;
    highestKillsBeforeCapturing?: number;
    pickupCaptureTimeMin?: string;
    pickupCaptureTimeMax?: string;
    pickupCaptureTimeAverage?: string;
    flagTouches?: number;
    pickupFlagTouches?: number;
    flagDefenses?: number;
    flagReturns?: number;
    frags?: number;
    deaths?: number;
    environmentalDeaths?: number;
    environmentalFlagCarrierDeaths?: number;
    teamKills?: number;
    killingSprees?: number;
    rampages?: number;
    dominatings?: number;
    unstoppables?: number;
    godLikes?: number;
    wickedSicks?: number;
    longestSpree?: number;
    doubleKills?: number;
    multiKills?: number;
    ultraKills?: number;
    monsterKills?: number;
    highestMultiKill?: number;
    pickupHealthGained?: number;
    healthFromNonPowerups?: number;
    healthWhenTouchingFlagMin?: number | undefined;
    healthWhenTouchingFlagMax?: number | undefined;
    healthWhenTouchingFlagAverage?: number | undefined;
    greenArmorWhenTouchingFlagMin?: number | undefined;
    greenArmorWhenTouchingFlagMax?: number | undefined;
    greenArmorWhenTouchingFlagAverage?: number | undefined;
    blueArmorWhenTouchingFlagMin?: number | undefined;
    blueArmorWhenTouchingFlagMax?: number | undefined;
    blueArmorWhenTouchingFlagAverage?: number | undefined;
    healthWhenTouchingFlagThatResultsInCaptureMin?: number | undefined;
    healthWhenTouchingFlagThatResultsInCaptureMax?: number | undefined;
    healthWhenTouchingFlagThatResultsInCaptureAverage?: number | undefined;
    damage?: number;
    damageTakenFromEnvironment?: number;
    damageTakenFromEnvironmentAsFlagCarrier?: number;
    damageToFlagCarriers?: number;
    damageDoneWithFlag?: number;
    damageToGreenArmor?: number;
    damageToBlueArmor?: number;
    powerups?: number;
}

export class UnplayedMapsVm implements IUnplayedMapsVm {
    mapList?: UnplayedMapsDto[] | undefined;

    constructor(data?: IUnplayedMapsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mapList"])) {
                this.mapList = [] as any;
                for (let item of _data["mapList"])
                    this.mapList!.push(UnplayedMapsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UnplayedMapsVm {
        data = typeof data === 'object' ? data : {};
        let result = new UnplayedMapsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mapList)) {
            data["mapList"] = [];
            for (let item of this.mapList)
                data["mapList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUnplayedMapsVm {
    mapList?: UnplayedMapsDto[] | undefined;
}

export class UnplayedMapsDto implements IUnplayedMapsDto {
    id?: number;
    mapName?: string | undefined;
    mapPack?: string | undefined;
    mapNumber?: number;

    constructor(data?: IUnplayedMapsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mapName = _data["mapName"];
            this.mapPack = _data["mapPack"];
            this.mapNumber = _data["mapNumber"];
        }
    }

    static fromJS(data: any): UnplayedMapsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnplayedMapsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mapName"] = this.mapName;
        data["mapPack"] = this.mapPack;
        data["mapNumber"] = this.mapNumber;
        return data;
    }
}

export interface IUnplayedMapsDto {
    id?: number;
    mapName?: string | undefined;
    mapPack?: string | undefined;
    mapNumber?: number;
}

export class PlayedSeasonGameTypeMapsVm implements IPlayedSeasonGameTypeMapsVm {
    mapList?: PlayedSeasonGameTypeMapsDto[] | undefined;

    constructor(data?: IPlayedSeasonGameTypeMapsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mapList"])) {
                this.mapList = [] as any;
                for (let item of _data["mapList"])
                    this.mapList!.push(PlayedSeasonGameTypeMapsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayedSeasonGameTypeMapsVm {
        data = typeof data === 'object' ? data : {};
        let result = new PlayedSeasonGameTypeMapsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mapList)) {
            data["mapList"] = [];
            for (let item of this.mapList)
                data["mapList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlayedSeasonGameTypeMapsVm {
    mapList?: PlayedSeasonGameTypeMapsDto[] | undefined;
}

export class PlayedSeasonGameTypeMapsDto implements IPlayedSeasonGameTypeMapsDto {
    mapId?: number;
    mapName?: string | undefined;
    mapPack?: string | undefined;
    mapNumber?: string | undefined;

    constructor(data?: IPlayedSeasonGameTypeMapsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapId = _data["mapId"];
            this.mapName = _data["mapName"];
            this.mapPack = _data["mapPack"];
            this.mapNumber = _data["mapNumber"];
        }
    }

    static fromJS(data: any): PlayedSeasonGameTypeMapsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayedSeasonGameTypeMapsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapId"] = this.mapId;
        data["mapName"] = this.mapName;
        data["mapPack"] = this.mapPack;
        data["mapNumber"] = this.mapNumber;
        return data;
    }
}

export interface IPlayedSeasonGameTypeMapsDto {
    mapId?: number;
    mapName?: string | undefined;
    mapPack?: string | undefined;
    mapNumber?: string | undefined;
}

export class CreateMapCommand implements ICreateMapCommand {
    mapName?: string | undefined;
    mapPack?: string | undefined;
    mapNumber?: number;

    constructor(data?: ICreateMapCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapName = _data["mapName"];
            this.mapPack = _data["mapPack"];
            this.mapNumber = _data["mapNumber"];
        }
    }

    static fromJS(data: any): CreateMapCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMapCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapName"] = this.mapName;
        data["mapPack"] = this.mapPack;
        data["mapNumber"] = this.mapNumber;
        return data;
    }
}

export interface ICreateMapCommand {
    mapName?: string | undefined;
    mapPack?: string | undefined;
    mapNumber?: number;
}

export class EditMapCommand implements IEditMapCommand {
    mapId?: number;
    mapName?: string | undefined;
    mapPack?: string | undefined;
    mapNumber?: number;

    constructor(data?: IEditMapCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapId = _data["mapId"];
            this.mapName = _data["mapName"];
            this.mapPack = _data["mapPack"];
            this.mapNumber = _data["mapNumber"];
        }
    }

    static fromJS(data: any): EditMapCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditMapCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapId"] = this.mapId;
        data["mapName"] = this.mapName;
        data["mapPack"] = this.mapPack;
        data["mapNumber"] = this.mapNumber;
        return data;
    }
}

export interface IEditMapCommand {
    mapId?: number;
    mapName?: string | undefined;
    mapPack?: string | undefined;
    mapNumber?: number;
}

export class DeleteMapCommand implements IDeleteMapCommand {
    mapId?: number;

    constructor(data?: IDeleteMapCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapId = _data["mapId"];
        }
    }

    static fromJS(data: any): DeleteMapCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMapCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapId"] = this.mapId;
        return data;
    }
}

export interface IDeleteMapCommand {
    mapId?: number;
}

export class MatchSummaryVm implements IMatchSummaryVm {
    matchId?: number;
    seasonId?: number;
    gamePlayed?: boolean;
    gameForfeit?: boolean;
    doubleForfeit?: boolean;
    gameWinningColor?: string | undefined;
    gamePlayedTime?: Date | undefined;
    roundsPlayed?: number;
    gameTimeTotal?: string;
    seasonName?: string | undefined;
    teamInfo?: MatchTeamInfoDto | undefined;
    winningTeamInfo?: MatchWinningTeamInfoDto | undefined;
    mapsPlayed?: MatchMapsPlayedDto[] | undefined;
    lineScore?: MatchLineScoreDto | undefined;
    finalBoxScore?: MatchFinalBoxScoreDto | undefined;
    perRoundBoxScore?: RoundBoxScoreDto[] | undefined;
    demoList?: MatchSummaryDemoDto[] | undefined;

    constructor(data?: IMatchSummaryVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchId = _data["matchId"];
            this.seasonId = _data["seasonId"];
            this.gamePlayed = _data["gamePlayed"];
            this.gameForfeit = _data["gameForfeit"];
            this.doubleForfeit = _data["doubleForfeit"];
            this.gameWinningColor = _data["gameWinningColor"];
            this.gamePlayedTime = _data["gamePlayedTime"] ? new Date(_data["gamePlayedTime"].toString()) : <any>undefined;
            this.roundsPlayed = _data["roundsPlayed"];
            this.gameTimeTotal = _data["gameTimeTotal"];
            this.seasonName = _data["seasonName"];
            this.teamInfo = _data["teamInfo"] ? MatchTeamInfoDto.fromJS(_data["teamInfo"]) : <any>undefined;
            this.winningTeamInfo = _data["winningTeamInfo"] ? MatchWinningTeamInfoDto.fromJS(_data["winningTeamInfo"]) : <any>undefined;
            if (Array.isArray(_data["mapsPlayed"])) {
                this.mapsPlayed = [] as any;
                for (let item of _data["mapsPlayed"])
                    this.mapsPlayed!.push(MatchMapsPlayedDto.fromJS(item));
            }
            this.lineScore = _data["lineScore"] ? MatchLineScoreDto.fromJS(_data["lineScore"]) : <any>undefined;
            this.finalBoxScore = _data["finalBoxScore"] ? MatchFinalBoxScoreDto.fromJS(_data["finalBoxScore"]) : <any>undefined;
            if (Array.isArray(_data["perRoundBoxScore"])) {
                this.perRoundBoxScore = [] as any;
                for (let item of _data["perRoundBoxScore"])
                    this.perRoundBoxScore!.push(RoundBoxScoreDto.fromJS(item));
            }
            if (Array.isArray(_data["demoList"])) {
                this.demoList = [] as any;
                for (let item of _data["demoList"])
                    this.demoList!.push(MatchSummaryDemoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MatchSummaryVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchSummaryVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchId"] = this.matchId;
        data["seasonId"] = this.seasonId;
        data["gamePlayed"] = this.gamePlayed;
        data["gameForfeit"] = this.gameForfeit;
        data["doubleForfeit"] = this.doubleForfeit;
        data["gameWinningColor"] = this.gameWinningColor;
        data["gamePlayedTime"] = this.gamePlayedTime ? this.gamePlayedTime.toISOString() : <any>undefined;
        data["roundsPlayed"] = this.roundsPlayed;
        data["gameTimeTotal"] = this.gameTimeTotal;
        data["seasonName"] = this.seasonName;
        data["teamInfo"] = this.teamInfo ? this.teamInfo.toJSON() : <any>undefined;
        data["winningTeamInfo"] = this.winningTeamInfo ? this.winningTeamInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.mapsPlayed)) {
            data["mapsPlayed"] = [];
            for (let item of this.mapsPlayed)
                data["mapsPlayed"].push(item.toJSON());
        }
        data["lineScore"] = this.lineScore ? this.lineScore.toJSON() : <any>undefined;
        data["finalBoxScore"] = this.finalBoxScore ? this.finalBoxScore.toJSON() : <any>undefined;
        if (Array.isArray(this.perRoundBoxScore)) {
            data["perRoundBoxScore"] = [];
            for (let item of this.perRoundBoxScore)
                data["perRoundBoxScore"].push(item.toJSON());
        }
        if (Array.isArray(this.demoList)) {
            data["demoList"] = [];
            for (let item of this.demoList)
                data["demoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMatchSummaryVm {
    matchId?: number;
    seasonId?: number;
    gamePlayed?: boolean;
    gameForfeit?: boolean;
    doubleForfeit?: boolean;
    gameWinningColor?: string | undefined;
    gamePlayedTime?: Date | undefined;
    roundsPlayed?: number;
    gameTimeTotal?: string;
    seasonName?: string | undefined;
    teamInfo?: MatchTeamInfoDto | undefined;
    winningTeamInfo?: MatchWinningTeamInfoDto | undefined;
    mapsPlayed?: MatchMapsPlayedDto[] | undefined;
    lineScore?: MatchLineScoreDto | undefined;
    finalBoxScore?: MatchFinalBoxScoreDto | undefined;
    perRoundBoxScore?: RoundBoxScoreDto[] | undefined;
    demoList?: MatchSummaryDemoDto[] | undefined;
}

export class MatchTeamInfoDto implements IMatchTeamInfoDto {
    redTeamId?: number;
    blueTeamId?: number;
    redTeamName?: string | undefined;
    blueTeamName?: string | undefined;
    redTeamAbv?: string | undefined;
    blueTeamAbv?: string | undefined;
    redCaptain?: string | undefined;
    redCaptainId?: number;
    redPlayerOne?: string | undefined;
    redPlayerOneId?: number;
    redPlayerTwo?: string | undefined;
    redPlayerTwoId?: number;
    redPlayerThree?: string | undefined;
    redPlayerThreeId?: number;
    blueCaptain?: string | undefined;
    blueCaptainId?: number;
    bluePlayerOne?: string | undefined;
    bluePlayerOneId?: number;
    bluePlayerTwo?: string | undefined;
    bluePlayerTwoId?: number;
    bluePlayerThree?: string | undefined;
    bluePlayerThreeId?: number;

    constructor(data?: IMatchTeamInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.redTeamId = _data["redTeamId"];
            this.blueTeamId = _data["blueTeamId"];
            this.redTeamName = _data["redTeamName"];
            this.blueTeamName = _data["blueTeamName"];
            this.redTeamAbv = _data["redTeamAbv"];
            this.blueTeamAbv = _data["blueTeamAbv"];
            this.redCaptain = _data["redCaptain"];
            this.redCaptainId = _data["redCaptainId"];
            this.redPlayerOne = _data["redPlayerOne"];
            this.redPlayerOneId = _data["redPlayerOneId"];
            this.redPlayerTwo = _data["redPlayerTwo"];
            this.redPlayerTwoId = _data["redPlayerTwoId"];
            this.redPlayerThree = _data["redPlayerThree"];
            this.redPlayerThreeId = _data["redPlayerThreeId"];
            this.blueCaptain = _data["blueCaptain"];
            this.blueCaptainId = _data["blueCaptainId"];
            this.bluePlayerOne = _data["bluePlayerOne"];
            this.bluePlayerOneId = _data["bluePlayerOneId"];
            this.bluePlayerTwo = _data["bluePlayerTwo"];
            this.bluePlayerTwoId = _data["bluePlayerTwoId"];
            this.bluePlayerThree = _data["bluePlayerThree"];
            this.bluePlayerThreeId = _data["bluePlayerThreeId"];
        }
    }

    static fromJS(data: any): MatchTeamInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MatchTeamInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["redTeamId"] = this.redTeamId;
        data["blueTeamId"] = this.blueTeamId;
        data["redTeamName"] = this.redTeamName;
        data["blueTeamName"] = this.blueTeamName;
        data["redTeamAbv"] = this.redTeamAbv;
        data["blueTeamAbv"] = this.blueTeamAbv;
        data["redCaptain"] = this.redCaptain;
        data["redCaptainId"] = this.redCaptainId;
        data["redPlayerOne"] = this.redPlayerOne;
        data["redPlayerOneId"] = this.redPlayerOneId;
        data["redPlayerTwo"] = this.redPlayerTwo;
        data["redPlayerTwoId"] = this.redPlayerTwoId;
        data["redPlayerThree"] = this.redPlayerThree;
        data["redPlayerThreeId"] = this.redPlayerThreeId;
        data["blueCaptain"] = this.blueCaptain;
        data["blueCaptainId"] = this.blueCaptainId;
        data["bluePlayerOne"] = this.bluePlayerOne;
        data["bluePlayerOneId"] = this.bluePlayerOneId;
        data["bluePlayerTwo"] = this.bluePlayerTwo;
        data["bluePlayerTwoId"] = this.bluePlayerTwoId;
        data["bluePlayerThree"] = this.bluePlayerThree;
        data["bluePlayerThreeId"] = this.bluePlayerThreeId;
        return data;
    }
}

export interface IMatchTeamInfoDto {
    redTeamId?: number;
    blueTeamId?: number;
    redTeamName?: string | undefined;
    blueTeamName?: string | undefined;
    redTeamAbv?: string | undefined;
    blueTeamAbv?: string | undefined;
    redCaptain?: string | undefined;
    redCaptainId?: number;
    redPlayerOne?: string | undefined;
    redPlayerOneId?: number;
    redPlayerTwo?: string | undefined;
    redPlayerTwoId?: number;
    redPlayerThree?: string | undefined;
    redPlayerThreeId?: number;
    blueCaptain?: string | undefined;
    blueCaptainId?: number;
    bluePlayerOne?: string | undefined;
    bluePlayerOneId?: number;
    bluePlayerTwo?: string | undefined;
    bluePlayerTwoId?: number;
    bluePlayerThree?: string | undefined;
    bluePlayerThreeId?: number;
}

export class MatchWinningTeamInfoDto implements IMatchWinningTeamInfoDto {
    winningTeamId?: number;
    winningTeamName?: string | undefined;
    winningTeamAbv?: string | undefined;
    winningTeamColor?: string | undefined;

    constructor(data?: IMatchWinningTeamInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.winningTeamId = _data["winningTeamId"];
            this.winningTeamName = _data["winningTeamName"];
            this.winningTeamAbv = _data["winningTeamAbv"];
            this.winningTeamColor = _data["winningTeamColor"];
        }
    }

    static fromJS(data: any): MatchWinningTeamInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MatchWinningTeamInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["winningTeamId"] = this.winningTeamId;
        data["winningTeamName"] = this.winningTeamName;
        data["winningTeamAbv"] = this.winningTeamAbv;
        data["winningTeamColor"] = this.winningTeamColor;
        return data;
    }
}

export interface IMatchWinningTeamInfoDto {
    winningTeamId?: number;
    winningTeamName?: string | undefined;
    winningTeamAbv?: string | undefined;
    winningTeamColor?: string | undefined;
}

export class MatchMapsPlayedDto implements IMatchMapsPlayedDto {
    mapId?: number;
    mapNumber?: string | undefined;
    mapName?: string | undefined;
    mapPack?: string | undefined;
    imageFilePath?: string | undefined;

    constructor(data?: IMatchMapsPlayedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapId = _data["mapId"];
            this.mapNumber = _data["mapNumber"];
            this.mapName = _data["mapName"];
            this.mapPack = _data["mapPack"];
            this.imageFilePath = _data["imageFilePath"];
        }
    }

    static fromJS(data: any): MatchMapsPlayedDto {
        data = typeof data === 'object' ? data : {};
        let result = new MatchMapsPlayedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapId"] = this.mapId;
        data["mapNumber"] = this.mapNumber;
        data["mapName"] = this.mapName;
        data["mapPack"] = this.mapPack;
        data["imageFilePath"] = this.imageFilePath;
        return data;
    }
}

export interface IMatchMapsPlayedDto {
    mapId?: number;
    mapNumber?: string | undefined;
    mapName?: string | undefined;
    mapPack?: string | undefined;
    imageFilePath?: string | undefined;
}

export class MatchLineScoreDto implements IMatchLineScoreDto {
    roundScore?: ScoreDto[] | undefined;
    matchResult?: MatchResultDto | undefined;

    constructor(data?: IMatchLineScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roundScore"])) {
                this.roundScore = [] as any;
                for (let item of _data["roundScore"])
                    this.roundScore!.push(ScoreDto.fromJS(item));
            }
            this.matchResult = _data["matchResult"] ? MatchResultDto.fromJS(_data["matchResult"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MatchLineScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new MatchLineScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roundScore)) {
            data["roundScore"] = [];
            for (let item of this.roundScore)
                data["roundScore"].push(item.toJSON());
        }
        data["matchResult"] = this.matchResult ? this.matchResult.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMatchLineScoreDto {
    roundScore?: ScoreDto[] | undefined;
    matchResult?: MatchResultDto | undefined;
}

export class ScoreDto implements IScoreDto {
    round?: string | undefined;
    redScore?: number;
    blueScore?: number;
    mapPlayedName?: string | undefined;
    roundWinner?: string | undefined;
    roundDuration?: string;

    constructor(data?: IScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.round = _data["round"];
            this.redScore = _data["redScore"];
            this.blueScore = _data["blueScore"];
            this.mapPlayedName = _data["mapPlayedName"];
            this.roundWinner = _data["roundWinner"];
            this.roundDuration = _data["roundDuration"];
        }
    }

    static fromJS(data: any): ScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["round"] = this.round;
        data["redScore"] = this.redScore;
        data["blueScore"] = this.blueScore;
        data["mapPlayedName"] = this.mapPlayedName;
        data["roundWinner"] = this.roundWinner;
        data["roundDuration"] = this.roundDuration;
        return data;
    }
}

export interface IScoreDto {
    round?: string | undefined;
    redScore?: number;
    blueScore?: number;
    mapPlayedName?: string | undefined;
    roundWinner?: string | undefined;
    roundDuration?: string;
}

export class MatchResultDto implements IMatchResultDto {
    redRoundScore?: number;
    blueRoundScore?: number;
    gameWinner?: string | undefined;

    constructor(data?: IMatchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.redRoundScore = _data["redRoundScore"];
            this.blueRoundScore = _data["blueRoundScore"];
            this.gameWinner = _data["gameWinner"];
        }
    }

    static fromJS(data: any): MatchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MatchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["redRoundScore"] = this.redRoundScore;
        data["blueRoundScore"] = this.blueRoundScore;
        data["gameWinner"] = this.gameWinner;
        return data;
    }
}

export interface IMatchResultDto {
    redRoundScore?: number;
    blueRoundScore?: number;
    gameWinner?: string | undefined;
}

export class MatchFinalBoxScoreDto implements IMatchFinalBoxScoreDto {
    redTeamFinalBoxScore?: MatchStatsDto | undefined;
    blueTeamFinalBoxScore?: MatchStatsDto | undefined;
    redTeamPlayerFinalBoxScore?: GamePlayersDto[] | undefined;
    blueTeamPlayerFinalBoxScore?: GamePlayersDto[] | undefined;

    constructor(data?: IMatchFinalBoxScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.redTeamFinalBoxScore = _data["redTeamFinalBoxScore"] ? MatchStatsDto.fromJS(_data["redTeamFinalBoxScore"]) : <any>undefined;
            this.blueTeamFinalBoxScore = _data["blueTeamFinalBoxScore"] ? MatchStatsDto.fromJS(_data["blueTeamFinalBoxScore"]) : <any>undefined;
            if (Array.isArray(_data["redTeamPlayerFinalBoxScore"])) {
                this.redTeamPlayerFinalBoxScore = [] as any;
                for (let item of _data["redTeamPlayerFinalBoxScore"])
                    this.redTeamPlayerFinalBoxScore!.push(GamePlayersDto.fromJS(item));
            }
            if (Array.isArray(_data["blueTeamPlayerFinalBoxScore"])) {
                this.blueTeamPlayerFinalBoxScore = [] as any;
                for (let item of _data["blueTeamPlayerFinalBoxScore"])
                    this.blueTeamPlayerFinalBoxScore!.push(GamePlayersDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MatchFinalBoxScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new MatchFinalBoxScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["redTeamFinalBoxScore"] = this.redTeamFinalBoxScore ? this.redTeamFinalBoxScore.toJSON() : <any>undefined;
        data["blueTeamFinalBoxScore"] = this.blueTeamFinalBoxScore ? this.blueTeamFinalBoxScore.toJSON() : <any>undefined;
        if (Array.isArray(this.redTeamPlayerFinalBoxScore)) {
            data["redTeamPlayerFinalBoxScore"] = [];
            for (let item of this.redTeamPlayerFinalBoxScore)
                data["redTeamPlayerFinalBoxScore"].push(item.toJSON());
        }
        if (Array.isArray(this.blueTeamPlayerFinalBoxScore)) {
            data["blueTeamPlayerFinalBoxScore"] = [];
            for (let item of this.blueTeamPlayerFinalBoxScore)
                data["blueTeamPlayerFinalBoxScore"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMatchFinalBoxScoreDto {
    redTeamFinalBoxScore?: MatchStatsDto | undefined;
    blueTeamFinalBoxScore?: MatchStatsDto | undefined;
    redTeamPlayerFinalBoxScore?: GamePlayersDto[] | undefined;
    blueTeamPlayerFinalBoxScore?: GamePlayersDto[] | undefined;
}

export class MatchStatsDto implements IMatchStatsDto {
    timePlayed?: string;
    points?: number;
    captures?: number;
    pickupCaptures?: number;
    assists?: number;
    damageBetweenTouchAndCaptureMin?: number | undefined;
    damageBetweenTouchAndCaptureMax?: number | undefined;
    damageBetweenTouchAndCaptureAverage?: number | undefined;
    captureTimeMin?: string;
    captureTimeMax?: string;
    captureTimeAverage?: string;
    captureHealthMin?: number | undefined;
    captureHealthMax?: number | undefined;
    captureHealthAverage?: number | undefined;
    captureGreenArmorMin?: number | undefined;
    captureGreenArmorMax?: number | undefined;
    captureGreenArmorAverage?: number | undefined;
    captureBlueArmorMin?: number | undefined;
    captureBlueArmorMax?: number | undefined;
    captureBlueArmorAverage?: number | undefined;
    capturesWithSuperPickups?: number;
    flagCarriersKilledWhileHoldingFlag?: number;
    highestKillsBeforeCapturing?: number;
    pickupCaptureTimeMin?: string;
    pickupCaptureTimeMax?: string;
    pickupCaptureTimeAverage?: string;
    flagTouches?: number;
    pickupFlagTouches?: number;
    flagTouchesWithOverHundredHp?: number;
    flagDefenses?: number;
    flagReturns?: number;
    frags?: number;
    fragsWithFlag?: number;
    deaths?: number;
    environmentalDeaths?: number;
    environmentalFlagCarrierDeaths?: number;
    teamKills?: number;
    suicides?: number;
    suicidesWithFlag?: number;
    longestSpree?: number;
    highestMultiKill?: number;
    pickupHealthGained?: number;
    healthFromNonPowerPickups?: number;
    healthFromPowerPickups?: number;
    healthWhenTouchingFlagMin?: number | undefined;
    healthWhenTouchingFlagMax?: number | undefined;
    healthWhenTouchingFlagAverage?: number | undefined;
    greenArmorWhenTouchingFlagMin?: number | undefined;
    greenArmorWhenTouchingFlagMax?: number | undefined;
    greenArmorWhenTouchingFlagAverage?: number | undefined;
    blueArmorWhenTouchingFlagMin?: number | undefined;
    blueArmorWhenTouchingFlagMax?: number | undefined;
    blueArmorWhenTouchingFlagAverage?: number | undefined;
    healthWhenTouchingFlagThatResultsInCaptureMin?: number | undefined;
    healthWhenTouchingFlagThatResultsInCaptureMax?: number | undefined;
    healthWhenTouchingFlagThatResultsInCaptureAverage?: number | undefined;
    damage?: number;
    selfDamage?: number;
    selfDamageWithFlag?: number;
    damageTakenFromEnvironment?: number;
    damageTakenFromEnvironmentAsFlagCarrier?: number;
    damageToFlagCarriers?: number;
    damageAsFlagCarrier?: number;
    damageAsFlagCarrierWhileHoldingFlag?: number;
    damageToGreenArmor?: number;
    damageToBlueArmor?: number;
    powerups?: number;
    kdr?: number;
    wdlrat?: number;

    constructor(data?: IMatchStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timePlayed = _data["timePlayed"];
            this.points = _data["points"];
            this.captures = _data["captures"];
            this.pickupCaptures = _data["pickupCaptures"];
            this.assists = _data["assists"];
            this.damageBetweenTouchAndCaptureMin = _data["damageBetweenTouchAndCaptureMin"];
            this.damageBetweenTouchAndCaptureMax = _data["damageBetweenTouchAndCaptureMax"];
            this.damageBetweenTouchAndCaptureAverage = _data["damageBetweenTouchAndCaptureAverage"];
            this.captureTimeMin = _data["captureTimeMin"];
            this.captureTimeMax = _data["captureTimeMax"];
            this.captureTimeAverage = _data["captureTimeAverage"];
            this.captureHealthMin = _data["captureHealthMin"];
            this.captureHealthMax = _data["captureHealthMax"];
            this.captureHealthAverage = _data["captureHealthAverage"];
            this.captureGreenArmorMin = _data["captureGreenArmorMin"];
            this.captureGreenArmorMax = _data["captureGreenArmorMax"];
            this.captureGreenArmorAverage = _data["captureGreenArmorAverage"];
            this.captureBlueArmorMin = _data["captureBlueArmorMin"];
            this.captureBlueArmorMax = _data["captureBlueArmorMax"];
            this.captureBlueArmorAverage = _data["captureBlueArmorAverage"];
            this.capturesWithSuperPickups = _data["capturesWithSuperPickups"];
            this.flagCarriersKilledWhileHoldingFlag = _data["flagCarriersKilledWhileHoldingFlag"];
            this.highestKillsBeforeCapturing = _data["highestKillsBeforeCapturing"];
            this.pickupCaptureTimeMin = _data["pickupCaptureTimeMin"];
            this.pickupCaptureTimeMax = _data["pickupCaptureTimeMax"];
            this.pickupCaptureTimeAverage = _data["pickupCaptureTimeAverage"];
            this.flagTouches = _data["flagTouches"];
            this.pickupFlagTouches = _data["pickupFlagTouches"];
            this.flagTouchesWithOverHundredHp = _data["flagTouchesWithOverHundredHp"];
            this.flagDefenses = _data["flagDefenses"];
            this.flagReturns = _data["flagReturns"];
            this.frags = _data["frags"];
            this.fragsWithFlag = _data["fragsWithFlag"];
            this.deaths = _data["deaths"];
            this.environmentalDeaths = _data["environmentalDeaths"];
            this.environmentalFlagCarrierDeaths = _data["environmentalFlagCarrierDeaths"];
            this.teamKills = _data["teamKills"];
            this.suicides = _data["suicides"];
            this.suicidesWithFlag = _data["suicidesWithFlag"];
            this.longestSpree = _data["longestSpree"];
            this.highestMultiKill = _data["highestMultiKill"];
            this.pickupHealthGained = _data["pickupHealthGained"];
            this.healthFromNonPowerPickups = _data["healthFromNonPowerPickups"];
            this.healthFromPowerPickups = _data["healthFromPowerPickups"];
            this.healthWhenTouchingFlagMin = _data["healthWhenTouchingFlagMin"];
            this.healthWhenTouchingFlagMax = _data["healthWhenTouchingFlagMax"];
            this.healthWhenTouchingFlagAverage = _data["healthWhenTouchingFlagAverage"];
            this.greenArmorWhenTouchingFlagMin = _data["greenArmorWhenTouchingFlagMin"];
            this.greenArmorWhenTouchingFlagMax = _data["greenArmorWhenTouchingFlagMax"];
            this.greenArmorWhenTouchingFlagAverage = _data["greenArmorWhenTouchingFlagAverage"];
            this.blueArmorWhenTouchingFlagMin = _data["blueArmorWhenTouchingFlagMin"];
            this.blueArmorWhenTouchingFlagMax = _data["blueArmorWhenTouchingFlagMax"];
            this.blueArmorWhenTouchingFlagAverage = _data["blueArmorWhenTouchingFlagAverage"];
            this.healthWhenTouchingFlagThatResultsInCaptureMin = _data["healthWhenTouchingFlagThatResultsInCaptureMin"];
            this.healthWhenTouchingFlagThatResultsInCaptureMax = _data["healthWhenTouchingFlagThatResultsInCaptureMax"];
            this.healthWhenTouchingFlagThatResultsInCaptureAverage = _data["healthWhenTouchingFlagThatResultsInCaptureAverage"];
            this.damage = _data["damage"];
            this.selfDamage = _data["selfDamage"];
            this.selfDamageWithFlag = _data["selfDamageWithFlag"];
            this.damageTakenFromEnvironment = _data["damageTakenFromEnvironment"];
            this.damageTakenFromEnvironmentAsFlagCarrier = _data["damageTakenFromEnvironmentAsFlagCarrier"];
            this.damageToFlagCarriers = _data["damageToFlagCarriers"];
            this.damageAsFlagCarrier = _data["damageAsFlagCarrier"];
            this.damageAsFlagCarrierWhileHoldingFlag = _data["damageAsFlagCarrierWhileHoldingFlag"];
            this.damageToGreenArmor = _data["damageToGreenArmor"];
            this.damageToBlueArmor = _data["damageToBlueArmor"];
            this.powerups = _data["powerups"];
            this.kdr = _data["kdr"];
            this.wdlrat = _data["wdlrat"];
        }
    }

    static fromJS(data: any): MatchStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MatchStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timePlayed"] = this.timePlayed;
        data["points"] = this.points;
        data["captures"] = this.captures;
        data["pickupCaptures"] = this.pickupCaptures;
        data["assists"] = this.assists;
        data["damageBetweenTouchAndCaptureMin"] = this.damageBetweenTouchAndCaptureMin;
        data["damageBetweenTouchAndCaptureMax"] = this.damageBetweenTouchAndCaptureMax;
        data["damageBetweenTouchAndCaptureAverage"] = this.damageBetweenTouchAndCaptureAverage;
        data["captureTimeMin"] = this.captureTimeMin;
        data["captureTimeMax"] = this.captureTimeMax;
        data["captureTimeAverage"] = this.captureTimeAverage;
        data["captureHealthMin"] = this.captureHealthMin;
        data["captureHealthMax"] = this.captureHealthMax;
        data["captureHealthAverage"] = this.captureHealthAverage;
        data["captureGreenArmorMin"] = this.captureGreenArmorMin;
        data["captureGreenArmorMax"] = this.captureGreenArmorMax;
        data["captureGreenArmorAverage"] = this.captureGreenArmorAverage;
        data["captureBlueArmorMin"] = this.captureBlueArmorMin;
        data["captureBlueArmorMax"] = this.captureBlueArmorMax;
        data["captureBlueArmorAverage"] = this.captureBlueArmorAverage;
        data["capturesWithSuperPickups"] = this.capturesWithSuperPickups;
        data["flagCarriersKilledWhileHoldingFlag"] = this.flagCarriersKilledWhileHoldingFlag;
        data["highestKillsBeforeCapturing"] = this.highestKillsBeforeCapturing;
        data["pickupCaptureTimeMin"] = this.pickupCaptureTimeMin;
        data["pickupCaptureTimeMax"] = this.pickupCaptureTimeMax;
        data["pickupCaptureTimeAverage"] = this.pickupCaptureTimeAverage;
        data["flagTouches"] = this.flagTouches;
        data["pickupFlagTouches"] = this.pickupFlagTouches;
        data["flagTouchesWithOverHundredHp"] = this.flagTouchesWithOverHundredHp;
        data["flagDefenses"] = this.flagDefenses;
        data["flagReturns"] = this.flagReturns;
        data["frags"] = this.frags;
        data["fragsWithFlag"] = this.fragsWithFlag;
        data["deaths"] = this.deaths;
        data["environmentalDeaths"] = this.environmentalDeaths;
        data["environmentalFlagCarrierDeaths"] = this.environmentalFlagCarrierDeaths;
        data["teamKills"] = this.teamKills;
        data["suicides"] = this.suicides;
        data["suicidesWithFlag"] = this.suicidesWithFlag;
        data["longestSpree"] = this.longestSpree;
        data["highestMultiKill"] = this.highestMultiKill;
        data["pickupHealthGained"] = this.pickupHealthGained;
        data["healthFromNonPowerPickups"] = this.healthFromNonPowerPickups;
        data["healthFromPowerPickups"] = this.healthFromPowerPickups;
        data["healthWhenTouchingFlagMin"] = this.healthWhenTouchingFlagMin;
        data["healthWhenTouchingFlagMax"] = this.healthWhenTouchingFlagMax;
        data["healthWhenTouchingFlagAverage"] = this.healthWhenTouchingFlagAverage;
        data["greenArmorWhenTouchingFlagMin"] = this.greenArmorWhenTouchingFlagMin;
        data["greenArmorWhenTouchingFlagMax"] = this.greenArmorWhenTouchingFlagMax;
        data["greenArmorWhenTouchingFlagAverage"] = this.greenArmorWhenTouchingFlagAverage;
        data["blueArmorWhenTouchingFlagMin"] = this.blueArmorWhenTouchingFlagMin;
        data["blueArmorWhenTouchingFlagMax"] = this.blueArmorWhenTouchingFlagMax;
        data["blueArmorWhenTouchingFlagAverage"] = this.blueArmorWhenTouchingFlagAverage;
        data["healthWhenTouchingFlagThatResultsInCaptureMin"] = this.healthWhenTouchingFlagThatResultsInCaptureMin;
        data["healthWhenTouchingFlagThatResultsInCaptureMax"] = this.healthWhenTouchingFlagThatResultsInCaptureMax;
        data["healthWhenTouchingFlagThatResultsInCaptureAverage"] = this.healthWhenTouchingFlagThatResultsInCaptureAverage;
        data["damage"] = this.damage;
        data["selfDamage"] = this.selfDamage;
        data["selfDamageWithFlag"] = this.selfDamageWithFlag;
        data["damageTakenFromEnvironment"] = this.damageTakenFromEnvironment;
        data["damageTakenFromEnvironmentAsFlagCarrier"] = this.damageTakenFromEnvironmentAsFlagCarrier;
        data["damageToFlagCarriers"] = this.damageToFlagCarriers;
        data["damageAsFlagCarrier"] = this.damageAsFlagCarrier;
        data["damageAsFlagCarrierWhileHoldingFlag"] = this.damageAsFlagCarrierWhileHoldingFlag;
        data["damageToGreenArmor"] = this.damageToGreenArmor;
        data["damageToBlueArmor"] = this.damageToBlueArmor;
        data["powerups"] = this.powerups;
        data["kdr"] = this.kdr;
        data["wdlrat"] = this.wdlrat;
        return data;
    }
}

export interface IMatchStatsDto {
    timePlayed?: string;
    points?: number;
    captures?: number;
    pickupCaptures?: number;
    assists?: number;
    damageBetweenTouchAndCaptureMin?: number | undefined;
    damageBetweenTouchAndCaptureMax?: number | undefined;
    damageBetweenTouchAndCaptureAverage?: number | undefined;
    captureTimeMin?: string;
    captureTimeMax?: string;
    captureTimeAverage?: string;
    captureHealthMin?: number | undefined;
    captureHealthMax?: number | undefined;
    captureHealthAverage?: number | undefined;
    captureGreenArmorMin?: number | undefined;
    captureGreenArmorMax?: number | undefined;
    captureGreenArmorAverage?: number | undefined;
    captureBlueArmorMin?: number | undefined;
    captureBlueArmorMax?: number | undefined;
    captureBlueArmorAverage?: number | undefined;
    capturesWithSuperPickups?: number;
    flagCarriersKilledWhileHoldingFlag?: number;
    highestKillsBeforeCapturing?: number;
    pickupCaptureTimeMin?: string;
    pickupCaptureTimeMax?: string;
    pickupCaptureTimeAverage?: string;
    flagTouches?: number;
    pickupFlagTouches?: number;
    flagTouchesWithOverHundredHp?: number;
    flagDefenses?: number;
    flagReturns?: number;
    frags?: number;
    fragsWithFlag?: number;
    deaths?: number;
    environmentalDeaths?: number;
    environmentalFlagCarrierDeaths?: number;
    teamKills?: number;
    suicides?: number;
    suicidesWithFlag?: number;
    longestSpree?: number;
    highestMultiKill?: number;
    pickupHealthGained?: number;
    healthFromNonPowerPickups?: number;
    healthFromPowerPickups?: number;
    healthWhenTouchingFlagMin?: number | undefined;
    healthWhenTouchingFlagMax?: number | undefined;
    healthWhenTouchingFlagAverage?: number | undefined;
    greenArmorWhenTouchingFlagMin?: number | undefined;
    greenArmorWhenTouchingFlagMax?: number | undefined;
    greenArmorWhenTouchingFlagAverage?: number | undefined;
    blueArmorWhenTouchingFlagMin?: number | undefined;
    blueArmorWhenTouchingFlagMax?: number | undefined;
    blueArmorWhenTouchingFlagAverage?: number | undefined;
    healthWhenTouchingFlagThatResultsInCaptureMin?: number | undefined;
    healthWhenTouchingFlagThatResultsInCaptureMax?: number | undefined;
    healthWhenTouchingFlagThatResultsInCaptureAverage?: number | undefined;
    damage?: number;
    selfDamage?: number;
    selfDamageWithFlag?: number;
    damageTakenFromEnvironment?: number;
    damageTakenFromEnvironmentAsFlagCarrier?: number;
    damageToFlagCarriers?: number;
    damageAsFlagCarrier?: number;
    damageAsFlagCarrierWhileHoldingFlag?: number;
    damageToGreenArmor?: number;
    damageToBlueArmor?: number;
    powerups?: number;
    kdr?: number;
    wdlrat?: number;
}

export class GamePlayersDto implements IGamePlayersDto {
    playerId?: number;
    playerName?: string | undefined;
    killStats?: KillStatsDto | undefined;
    damageStats?: DamageStatsDto | undefined;
    matchStats?: MatchStatsDto | undefined;

    constructor(data?: IGamePlayersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.playerName = _data["playerName"];
            this.killStats = _data["killStats"] ? KillStatsDto.fromJS(_data["killStats"]) : <any>undefined;
            this.damageStats = _data["damageStats"] ? DamageStatsDto.fromJS(_data["damageStats"]) : <any>undefined;
            this.matchStats = _data["matchStats"] ? MatchStatsDto.fromJS(_data["matchStats"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GamePlayersDto {
        data = typeof data === 'object' ? data : {};
        let result = new GamePlayersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["playerName"] = this.playerName;
        data["killStats"] = this.killStats ? this.killStats.toJSON() : <any>undefined;
        data["damageStats"] = this.damageStats ? this.damageStats.toJSON() : <any>undefined;
        data["matchStats"] = this.matchStats ? this.matchStats.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGamePlayersDto {
    playerId?: number;
    playerName?: string | undefined;
    killStats?: KillStatsDto | undefined;
    damageStats?: DamageStatsDto | undefined;
    matchStats?: MatchStatsDto | undefined;
}

export class KillStatsDto implements IKillStatsDto {
    killsByWeapon?: KillByWeaponDto[] | undefined;
    killsByWeaponWithFlag?: KillByWeaponDto[] | undefined;
    carrierKillsByWeapon?: KillByWeaponDto[] | undefined;
    carrierKillsByWeaponWithFlag?: KillByWeaponDto[] | undefined;

    constructor(data?: IKillStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["killsByWeapon"])) {
                this.killsByWeapon = [] as any;
                for (let item of _data["killsByWeapon"])
                    this.killsByWeapon!.push(KillByWeaponDto.fromJS(item));
            }
            if (Array.isArray(_data["killsByWeaponWithFlag"])) {
                this.killsByWeaponWithFlag = [] as any;
                for (let item of _data["killsByWeaponWithFlag"])
                    this.killsByWeaponWithFlag!.push(KillByWeaponDto.fromJS(item));
            }
            if (Array.isArray(_data["carrierKillsByWeapon"])) {
                this.carrierKillsByWeapon = [] as any;
                for (let item of _data["carrierKillsByWeapon"])
                    this.carrierKillsByWeapon!.push(KillByWeaponDto.fromJS(item));
            }
            if (Array.isArray(_data["carrierKillsByWeaponWithFlag"])) {
                this.carrierKillsByWeaponWithFlag = [] as any;
                for (let item of _data["carrierKillsByWeaponWithFlag"])
                    this.carrierKillsByWeaponWithFlag!.push(KillByWeaponDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KillStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new KillStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.killsByWeapon)) {
            data["killsByWeapon"] = [];
            for (let item of this.killsByWeapon)
                data["killsByWeapon"].push(item.toJSON());
        }
        if (Array.isArray(this.killsByWeaponWithFlag)) {
            data["killsByWeaponWithFlag"] = [];
            for (let item of this.killsByWeaponWithFlag)
                data["killsByWeaponWithFlag"].push(item.toJSON());
        }
        if (Array.isArray(this.carrierKillsByWeapon)) {
            data["carrierKillsByWeapon"] = [];
            for (let item of this.carrierKillsByWeapon)
                data["carrierKillsByWeapon"].push(item.toJSON());
        }
        if (Array.isArray(this.carrierKillsByWeaponWithFlag)) {
            data["carrierKillsByWeaponWithFlag"] = [];
            for (let item of this.carrierKillsByWeaponWithFlag)
                data["carrierKillsByWeaponWithFlag"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKillStatsDto {
    killsByWeapon?: KillByWeaponDto[] | undefined;
    killsByWeaponWithFlag?: KillByWeaponDto[] | undefined;
    carrierKillsByWeapon?: KillByWeaponDto[] | undefined;
    carrierKillsByWeaponWithFlag?: KillByWeaponDto[] | undefined;
}

export class KillByWeaponDto implements IKillByWeaponDto {
    weapon?: Mods;
    kills?: KillDto[] | undefined;

    constructor(data?: IKillByWeaponDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weapon = _data["weapon"];
            if (Array.isArray(_data["kills"])) {
                this.kills = [] as any;
                for (let item of _data["kills"])
                    this.kills!.push(KillDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KillByWeaponDto {
        data = typeof data === 'object' ? data : {};
        let result = new KillByWeaponDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weapon"] = this.weapon;
        if (Array.isArray(this.kills)) {
            data["kills"] = [];
            for (let item of this.kills)
                data["kills"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKillByWeaponDto {
    weapon?: Mods;
    kills?: KillDto[] | undefined;
}

export class KillDto implements IKillDto {
    targetId?: number;
    targetName?: string | undefined;
    kills?: number;

    constructor(data?: IKillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetId = _data["targetId"];
            this.targetName = _data["targetName"];
            this.kills = _data["kills"];
        }
    }

    static fromJS(data: any): KillDto {
        data = typeof data === 'object' ? data : {};
        let result = new KillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetId"] = this.targetId;
        data["targetName"] = this.targetName;
        data["kills"] = this.kills;
        return data;
    }
}

export interface IKillDto {
    targetId?: number;
    targetName?: string | undefined;
    kills?: number;
}

export class DamageStatsDto implements IDamageStatsDto {
    damageByWeapon?: DamageByWeaponDto[] | undefined;
    damageByWeaponWithFlag?: DamageByWeaponDto[] | undefined;
    carrierDamageByWeapon?: DamageByWeaponDto[] | undefined;
    carrierDamageByWeaponWithFlag?: DamageByWeaponDto[] | undefined;

    constructor(data?: IDamageStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["damageByWeapon"])) {
                this.damageByWeapon = [] as any;
                for (let item of _data["damageByWeapon"])
                    this.damageByWeapon!.push(DamageByWeaponDto.fromJS(item));
            }
            if (Array.isArray(_data["damageByWeaponWithFlag"])) {
                this.damageByWeaponWithFlag = [] as any;
                for (let item of _data["damageByWeaponWithFlag"])
                    this.damageByWeaponWithFlag!.push(DamageByWeaponDto.fromJS(item));
            }
            if (Array.isArray(_data["carrierDamageByWeapon"])) {
                this.carrierDamageByWeapon = [] as any;
                for (let item of _data["carrierDamageByWeapon"])
                    this.carrierDamageByWeapon!.push(DamageByWeaponDto.fromJS(item));
            }
            if (Array.isArray(_data["carrierDamageByWeaponWithFlag"])) {
                this.carrierDamageByWeaponWithFlag = [] as any;
                for (let item of _data["carrierDamageByWeaponWithFlag"])
                    this.carrierDamageByWeaponWithFlag!.push(DamageByWeaponDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DamageStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DamageStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.damageByWeapon)) {
            data["damageByWeapon"] = [];
            for (let item of this.damageByWeapon)
                data["damageByWeapon"].push(item.toJSON());
        }
        if (Array.isArray(this.damageByWeaponWithFlag)) {
            data["damageByWeaponWithFlag"] = [];
            for (let item of this.damageByWeaponWithFlag)
                data["damageByWeaponWithFlag"].push(item.toJSON());
        }
        if (Array.isArray(this.carrierDamageByWeapon)) {
            data["carrierDamageByWeapon"] = [];
            for (let item of this.carrierDamageByWeapon)
                data["carrierDamageByWeapon"].push(item.toJSON());
        }
        if (Array.isArray(this.carrierDamageByWeaponWithFlag)) {
            data["carrierDamageByWeaponWithFlag"] = [];
            for (let item of this.carrierDamageByWeaponWithFlag)
                data["carrierDamageByWeaponWithFlag"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDamageStatsDto {
    damageByWeapon?: DamageByWeaponDto[] | undefined;
    damageByWeaponWithFlag?: DamageByWeaponDto[] | undefined;
    carrierDamageByWeapon?: DamageByWeaponDto[] | undefined;
    carrierDamageByWeaponWithFlag?: DamageByWeaponDto[] | undefined;
}

export class DamageByWeaponDto implements IDamageByWeaponDto {
    weapon?: Mods;
    damage?: DamageDto[] | undefined;

    constructor(data?: IDamageByWeaponDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weapon = _data["weapon"];
            if (Array.isArray(_data["damage"])) {
                this.damage = [] as any;
                for (let item of _data["damage"])
                    this.damage!.push(DamageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DamageByWeaponDto {
        data = typeof data === 'object' ? data : {};
        let result = new DamageByWeaponDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weapon"] = this.weapon;
        if (Array.isArray(this.damage)) {
            data["damage"] = [];
            for (let item of this.damage)
                data["damage"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDamageByWeaponDto {
    weapon?: Mods;
    damage?: DamageDto[] | undefined;
}

export class DamageDto implements IDamageDto {
    targetId?: number;
    targetName?: string | undefined;
    damage?: number;
    greenArmor?: number;
    blueArmor?: number;

    constructor(data?: IDamageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetId = _data["targetId"];
            this.targetName = _data["targetName"];
            this.damage = _data["damage"];
            this.greenArmor = _data["greenArmor"];
            this.blueArmor = _data["blueArmor"];
        }
    }

    static fromJS(data: any): DamageDto {
        data = typeof data === 'object' ? data : {};
        let result = new DamageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetId"] = this.targetId;
        data["targetName"] = this.targetName;
        data["damage"] = this.damage;
        data["greenArmor"] = this.greenArmor;
        data["blueArmor"] = this.blueArmor;
        return data;
    }
}

export interface IDamageDto {
    targetId?: number;
    targetName?: string | undefined;
    damage?: number;
    greenArmor?: number;
    blueArmor?: number;
}

export class RoundBoxScoreDto implements IRoundBoxScoreDto {
    roundNumber?: number;
    roundTimeTotal?: string;
    redTeamBoxScore?: MatchStatsDto | undefined;
    blueTeamBoxScore?: MatchStatsDto | undefined;
    mapPlayed?: MatchMapsPlayedDto | undefined;
    captures?: MatchCapturesDto[] | undefined;
    redTeamPlayerRoundBoxScore?: GamePlayersDto[] | undefined;
    blueTeamPlayerRoundBoxScore?: GamePlayersDto[] | undefined;

    constructor(data?: IRoundBoxScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roundNumber = _data["roundNumber"];
            this.roundTimeTotal = _data["roundTimeTotal"];
            this.redTeamBoxScore = _data["redTeamBoxScore"] ? MatchStatsDto.fromJS(_data["redTeamBoxScore"]) : <any>undefined;
            this.blueTeamBoxScore = _data["blueTeamBoxScore"] ? MatchStatsDto.fromJS(_data["blueTeamBoxScore"]) : <any>undefined;
            this.mapPlayed = _data["mapPlayed"] ? MatchMapsPlayedDto.fromJS(_data["mapPlayed"]) : <any>undefined;
            if (Array.isArray(_data["captures"])) {
                this.captures = [] as any;
                for (let item of _data["captures"])
                    this.captures!.push(MatchCapturesDto.fromJS(item));
            }
            if (Array.isArray(_data["redTeamPlayerRoundBoxScore"])) {
                this.redTeamPlayerRoundBoxScore = [] as any;
                for (let item of _data["redTeamPlayerRoundBoxScore"])
                    this.redTeamPlayerRoundBoxScore!.push(GamePlayersDto.fromJS(item));
            }
            if (Array.isArray(_data["blueTeamPlayerRoundBoxScore"])) {
                this.blueTeamPlayerRoundBoxScore = [] as any;
                for (let item of _data["blueTeamPlayerRoundBoxScore"])
                    this.blueTeamPlayerRoundBoxScore!.push(GamePlayersDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoundBoxScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoundBoxScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roundNumber"] = this.roundNumber;
        data["roundTimeTotal"] = this.roundTimeTotal;
        data["redTeamBoxScore"] = this.redTeamBoxScore ? this.redTeamBoxScore.toJSON() : <any>undefined;
        data["blueTeamBoxScore"] = this.blueTeamBoxScore ? this.blueTeamBoxScore.toJSON() : <any>undefined;
        data["mapPlayed"] = this.mapPlayed ? this.mapPlayed.toJSON() : <any>undefined;
        if (Array.isArray(this.captures)) {
            data["captures"] = [];
            for (let item of this.captures)
                data["captures"].push(item.toJSON());
        }
        if (Array.isArray(this.redTeamPlayerRoundBoxScore)) {
            data["redTeamPlayerRoundBoxScore"] = [];
            for (let item of this.redTeamPlayerRoundBoxScore)
                data["redTeamPlayerRoundBoxScore"].push(item.toJSON());
        }
        if (Array.isArray(this.blueTeamPlayerRoundBoxScore)) {
            data["blueTeamPlayerRoundBoxScore"] = [];
            for (let item of this.blueTeamPlayerRoundBoxScore)
                data["blueTeamPlayerRoundBoxScore"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRoundBoxScoreDto {
    roundNumber?: number;
    roundTimeTotal?: string;
    redTeamBoxScore?: MatchStatsDto | undefined;
    blueTeamBoxScore?: MatchStatsDto | undefined;
    mapPlayed?: MatchMapsPlayedDto | undefined;
    captures?: MatchCapturesDto[] | undefined;
    redTeamPlayerRoundBoxScore?: GamePlayersDto[] | undefined;
    blueTeamPlayerRoundBoxScore?: GamePlayersDto[] | undefined;
}

export class MatchCapturesDto implements IMatchCapturesDto {
    playerName?: string | undefined;
    teamName?: string | undefined;
    teamColor?: string | undefined;
    captureNumber?: number;
    eventTime?: string;
    captureAmountTime?: string;
    assists?: MatchAssistDto[] | undefined;

    constructor(data?: IMatchCapturesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerName = _data["playerName"];
            this.teamName = _data["teamName"];
            this.teamColor = _data["teamColor"];
            this.captureNumber = _data["captureNumber"];
            this.eventTime = _data["eventTime"];
            this.captureAmountTime = _data["captureAmountTime"];
            if (Array.isArray(_data["assists"])) {
                this.assists = [] as any;
                for (let item of _data["assists"])
                    this.assists!.push(MatchAssistDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MatchCapturesDto {
        data = typeof data === 'object' ? data : {};
        let result = new MatchCapturesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerName"] = this.playerName;
        data["teamName"] = this.teamName;
        data["teamColor"] = this.teamColor;
        data["captureNumber"] = this.captureNumber;
        data["eventTime"] = this.eventTime;
        data["captureAmountTime"] = this.captureAmountTime;
        if (Array.isArray(this.assists)) {
            data["assists"] = [];
            for (let item of this.assists)
                data["assists"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMatchCapturesDto {
    playerName?: string | undefined;
    teamName?: string | undefined;
    teamColor?: string | undefined;
    captureNumber?: number;
    eventTime?: string;
    captureAmountTime?: string;
    assists?: MatchAssistDto[] | undefined;
}

export class MatchAssistDto implements IMatchAssistDto {
    playerName?: string | undefined;
    teamName?: string | undefined;
    teamColor?: string | undefined;
    captureNumber?: number;
    eventTime?: string;

    constructor(data?: IMatchAssistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerName = _data["playerName"];
            this.teamName = _data["teamName"];
            this.teamColor = _data["teamColor"];
            this.captureNumber = _data["captureNumber"];
            this.eventTime = _data["eventTime"];
        }
    }

    static fromJS(data: any): MatchAssistDto {
        data = typeof data === 'object' ? data : {};
        let result = new MatchAssistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerName"] = this.playerName;
        data["teamName"] = this.teamName;
        data["teamColor"] = this.teamColor;
        data["captureNumber"] = this.captureNumber;
        data["eventTime"] = this.eventTime;
        return data;
    }
}

export interface IMatchAssistDto {
    playerName?: string | undefined;
    teamName?: string | undefined;
    teamColor?: string | undefined;
    captureNumber?: number;
    eventTime?: string;
}

export class MatchSummaryDemoDto implements IMatchSummaryDemoDto {
    playerId?: number;
    playerName?: string | undefined;
    demoLost?: boolean;
    demoFilePath?: string | undefined;

    constructor(data?: IMatchSummaryDemoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.playerName = _data["playerName"];
            this.demoLost = _data["demoLost"];
            this.demoFilePath = _data["demoFilePath"];
        }
    }

    static fromJS(data: any): MatchSummaryDemoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MatchSummaryDemoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["playerName"] = this.playerName;
        data["demoLost"] = this.demoLost;
        data["demoFilePath"] = this.demoFilePath;
        return data;
    }
}

export interface IMatchSummaryDemoDto {
    playerId?: number;
    playerName?: string | undefined;
    demoLost?: boolean;
    demoFilePath?: string | undefined;
}

export class PlayerLineupVm implements IPlayerLineupVm {
    gamePlayerLineup?: PlayerLineupDto | undefined;

    constructor(data?: IPlayerLineupVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gamePlayerLineup = _data["gamePlayerLineup"] ? PlayerLineupDto.fromJS(_data["gamePlayerLineup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PlayerLineupVm {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerLineupVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gamePlayerLineup"] = this.gamePlayerLineup ? this.gamePlayerLineup.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPlayerLineupVm {
    gamePlayerLineup?: PlayerLineupDto | undefined;
}

export class PlayerLineupDto implements IPlayerLineupDto {
    id?: number;
    redTeamName?: string | undefined;
    blueTeamName?: string | undefined;
    redTeamPlayers?: TeamLineupPlayersDto[] | undefined;
    blueTeamPlayers?: TeamLineupPlayersDto[] | undefined;

    constructor(data?: IPlayerLineupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.redTeamName = _data["redTeamName"];
            this.blueTeamName = _data["blueTeamName"];
            if (Array.isArray(_data["redTeamPlayers"])) {
                this.redTeamPlayers = [] as any;
                for (let item of _data["redTeamPlayers"])
                    this.redTeamPlayers!.push(TeamLineupPlayersDto.fromJS(item));
            }
            if (Array.isArray(_data["blueTeamPlayers"])) {
                this.blueTeamPlayers = [] as any;
                for (let item of _data["blueTeamPlayers"])
                    this.blueTeamPlayers!.push(TeamLineupPlayersDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayerLineupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerLineupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["redTeamName"] = this.redTeamName;
        data["blueTeamName"] = this.blueTeamName;
        if (Array.isArray(this.redTeamPlayers)) {
            data["redTeamPlayers"] = [];
            for (let item of this.redTeamPlayers)
                data["redTeamPlayers"].push(item.toJSON());
        }
        if (Array.isArray(this.blueTeamPlayers)) {
            data["blueTeamPlayers"] = [];
            for (let item of this.blueTeamPlayers)
                data["blueTeamPlayers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlayerLineupDto {
    id?: number;
    redTeamName?: string | undefined;
    blueTeamName?: string | undefined;
    redTeamPlayers?: TeamLineupPlayersDto[] | undefined;
    blueTeamPlayers?: TeamLineupPlayersDto[] | undefined;
}

export class TeamLineupPlayersDto implements ITeamLineupPlayersDto {
    id?: number;
    playerName?: string | undefined;

    constructor(data?: ITeamLineupPlayersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.playerName = _data["playerName"];
        }
    }

    static fromJS(data: any): TeamLineupPlayersDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamLineupPlayersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["playerName"] = this.playerName;
        return data;
    }
}

export interface ITeamLineupPlayersDto {
    id?: number;
    playerName?: string | undefined;
}

export class UnplayedGamesVm implements IUnplayedGamesVm {
    unplayedGameList?: UnplayedGamesDto[] | undefined;

    constructor(data?: IUnplayedGamesVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["unplayedGameList"])) {
                this.unplayedGameList = [] as any;
                for (let item of _data["unplayedGameList"])
                    this.unplayedGameList!.push(UnplayedGamesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UnplayedGamesVm {
        data = typeof data === 'object' ? data : {};
        let result = new UnplayedGamesVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.unplayedGameList)) {
            data["unplayedGameList"] = [];
            for (let item of this.unplayedGameList)
                data["unplayedGameList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUnplayedGamesVm {
    unplayedGameList?: UnplayedGamesDto[] | undefined;
}

export class UnplayedGamesDto implements IUnplayedGamesDto {
    id?: number;
    redTeam?: number;
    redTeamName?: string | undefined;
    blueTeam?: number;
    blueTeamName?: string | undefined;
    weekNumber?: number;
    scheduledDate?: Date | undefined;

    constructor(data?: IUnplayedGamesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.redTeam = _data["redTeam"];
            this.redTeamName = _data["redTeamName"];
            this.blueTeam = _data["blueTeam"];
            this.blueTeamName = _data["blueTeamName"];
            this.weekNumber = _data["weekNumber"];
            this.scheduledDate = _data["scheduledDate"] ? new Date(_data["scheduledDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UnplayedGamesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnplayedGamesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["redTeam"] = this.redTeam;
        data["redTeamName"] = this.redTeamName;
        data["blueTeam"] = this.blueTeam;
        data["blueTeamName"] = this.blueTeamName;
        data["weekNumber"] = this.weekNumber;
        data["scheduledDate"] = this.scheduledDate ? this.scheduledDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUnplayedGamesDto {
    id?: number;
    redTeam?: number;
    redTeamName?: string | undefined;
    blueTeam?: number;
    blueTeamName?: string | undefined;
    weekNumber?: number;
    scheduledDate?: Date | undefined;
}

export class UnplayedPlayoffGamesVm implements IUnplayedPlayoffGamesVm {
    unplayedPlayoffGameList?: UnplayedPlayoffGamesDto[] | undefined;

    constructor(data?: IUnplayedPlayoffGamesVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["unplayedPlayoffGameList"])) {
                this.unplayedPlayoffGameList = [] as any;
                for (let item of _data["unplayedPlayoffGameList"])
                    this.unplayedPlayoffGameList!.push(UnplayedPlayoffGamesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UnplayedPlayoffGamesVm {
        data = typeof data === 'object' ? data : {};
        let result = new UnplayedPlayoffGamesVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.unplayedPlayoffGameList)) {
            data["unplayedPlayoffGameList"] = [];
            for (let item of this.unplayedPlayoffGameList)
                data["unplayedPlayoffGameList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUnplayedPlayoffGamesVm {
    unplayedPlayoffGameList?: UnplayedPlayoffGamesDto[] | undefined;
}

export class UnplayedPlayoffGamesDto implements IUnplayedPlayoffGamesDto {
    id?: number;
    redTeam?: number;
    redTeamName?: string | undefined;
    blueTeam?: number;
    blueTeamName?: string | undefined;
    weekNumber?: number;
    scheduledDate?: Date | undefined;

    constructor(data?: IUnplayedPlayoffGamesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.redTeam = _data["redTeam"];
            this.redTeamName = _data["redTeamName"];
            this.blueTeam = _data["blueTeam"];
            this.blueTeamName = _data["blueTeamName"];
            this.weekNumber = _data["weekNumber"];
            this.scheduledDate = _data["scheduledDate"] ? new Date(_data["scheduledDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UnplayedPlayoffGamesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnplayedPlayoffGamesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["redTeam"] = this.redTeam;
        data["redTeamName"] = this.redTeamName;
        data["blueTeam"] = this.blueTeam;
        data["blueTeamName"] = this.blueTeamName;
        data["weekNumber"] = this.weekNumber;
        data["scheduledDate"] = this.scheduledDate ? this.scheduledDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUnplayedPlayoffGamesDto {
    id?: number;
    redTeam?: number;
    redTeamName?: string | undefined;
    blueTeam?: number;
    blueTeamName?: string | undefined;
    weekNumber?: number;
    scheduledDate?: Date | undefined;
}

export class PlayedGamesVm implements IPlayedGamesVm {
    playedGameList?: PlayedGamesDto[] | undefined;

    constructor(data?: IPlayedGamesVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["playedGameList"])) {
                this.playedGameList = [] as any;
                for (let item of _data["playedGameList"])
                    this.playedGameList!.push(PlayedGamesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayedGamesVm {
        data = typeof data === 'object' ? data : {};
        let result = new PlayedGamesVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.playedGameList)) {
            data["playedGameList"] = [];
            for (let item of this.playedGameList)
                data["playedGameList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlayedGamesVm {
    playedGameList?: PlayedGamesDto[] | undefined;
}

export class PlayedGamesDto implements IPlayedGamesDto {
    id?: number;
    redTeamName?: string | undefined;
    blueTeamName?: string | undefined;
    weekNumber?: number;
    season?: string | undefined;
    winningTeam?: string | undefined;
    forfeit?: boolean;

    constructor(data?: IPlayedGamesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.redTeamName = _data["redTeamName"];
            this.blueTeamName = _data["blueTeamName"];
            this.weekNumber = _data["weekNumber"];
            this.season = _data["season"];
            this.winningTeam = _data["winningTeam"];
            this.forfeit = _data["forfeit"];
        }
    }

    static fromJS(data: any): PlayedGamesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayedGamesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["redTeamName"] = this.redTeamName;
        data["blueTeamName"] = this.blueTeamName;
        data["weekNumber"] = this.weekNumber;
        data["season"] = this.season;
        data["winningTeam"] = this.winningTeam;
        data["forfeit"] = this.forfeit;
        return data;
    }
}

export interface IPlayedGamesDto {
    id?: number;
    redTeamName?: string | undefined;
    blueTeamName?: string | undefined;
    weekNumber?: number;
    season?: string | undefined;
    winningTeam?: string | undefined;
    forfeit?: boolean;
}

export class UpcomingMatchesVm implements IUpcomingMatchesVm {
    upcomingMatches?: UpcomingMatchesDto[] | undefined;

    constructor(data?: IUpcomingMatchesVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["upcomingMatches"])) {
                this.upcomingMatches = [] as any;
                for (let item of _data["upcomingMatches"])
                    this.upcomingMatches!.push(UpcomingMatchesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpcomingMatchesVm {
        data = typeof data === 'object' ? data : {};
        let result = new UpcomingMatchesVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.upcomingMatches)) {
            data["upcomingMatches"] = [];
            for (let item of this.upcomingMatches)
                data["upcomingMatches"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpcomingMatchesVm {
    upcomingMatches?: UpcomingMatchesDto[] | undefined;
}

export class UpcomingMatchesDto implements IUpcomingMatchesDto {
    id?: number;
    redTeam?: number;
    seasonName?: string | undefined;
    redTeamName?: string | undefined;
    redTeamRecord?: string | undefined;
    blueTeam?: number;
    blueTeamName?: string | undefined;
    blueTeamRecord?: string | undefined;
    gameType?: string | undefined;
    scheduledTime?: Date | undefined;
    maps?: UpcomingMapsDto[] | undefined;

    constructor(data?: IUpcomingMatchesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.redTeam = _data["redTeam"];
            this.seasonName = _data["seasonName"];
            this.redTeamName = _data["redTeamName"];
            this.redTeamRecord = _data["redTeamRecord"];
            this.blueTeam = _data["blueTeam"];
            this.blueTeamName = _data["blueTeamName"];
            this.blueTeamRecord = _data["blueTeamRecord"];
            this.gameType = _data["gameType"];
            this.scheduledTime = _data["scheduledTime"] ? new Date(_data["scheduledTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["maps"])) {
                this.maps = [] as any;
                for (let item of _data["maps"])
                    this.maps!.push(UpcomingMapsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpcomingMatchesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpcomingMatchesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["redTeam"] = this.redTeam;
        data["seasonName"] = this.seasonName;
        data["redTeamName"] = this.redTeamName;
        data["redTeamRecord"] = this.redTeamRecord;
        data["blueTeam"] = this.blueTeam;
        data["blueTeamName"] = this.blueTeamName;
        data["blueTeamRecord"] = this.blueTeamRecord;
        data["gameType"] = this.gameType;
        data["scheduledTime"] = this.scheduledTime ? this.scheduledTime.toISOString() : <any>undefined;
        if (Array.isArray(this.maps)) {
            data["maps"] = [];
            for (let item of this.maps)
                data["maps"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpcomingMatchesDto {
    id?: number;
    redTeam?: number;
    seasonName?: string | undefined;
    redTeamName?: string | undefined;
    redTeamRecord?: string | undefined;
    blueTeam?: number;
    blueTeamName?: string | undefined;
    blueTeamRecord?: string | undefined;
    gameType?: string | undefined;
    scheduledTime?: Date | undefined;
    maps?: UpcomingMapsDto[] | undefined;
}

export class UpcomingMapsDto implements IUpcomingMapsDto {
    id?: number;
    mapName?: string | undefined;
    mapPack?: string | undefined;
    mapNumber?: string | undefined;
    mapImagePath?: string | undefined;

    constructor(data?: IUpcomingMapsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mapName = _data["mapName"];
            this.mapPack = _data["mapPack"];
            this.mapNumber = _data["mapNumber"];
            this.mapImagePath = _data["mapImagePath"];
        }
    }

    static fromJS(data: any): UpcomingMapsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpcomingMapsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mapName"] = this.mapName;
        data["mapPack"] = this.mapPack;
        data["mapNumber"] = this.mapNumber;
        data["mapImagePath"] = this.mapImagePath;
        return data;
    }
}

export interface IUpcomingMapsDto {
    id?: number;
    mapName?: string | undefined;
    mapPack?: string | undefined;
    mapNumber?: string | undefined;
    mapImagePath?: string | undefined;
}

export class PlayedMatchResultsVm implements IPlayedMatchResultsVm {
    playedMatches?: PlayedMatchResultsDto[] | undefined;
    totalCount?: number;
    perPage?: number;

    constructor(data?: IPlayedMatchResultsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["playedMatches"])) {
                this.playedMatches = [] as any;
                for (let item of _data["playedMatches"])
                    this.playedMatches!.push(PlayedMatchResultsDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.perPage = _data["perPage"];
        }
    }

    static fromJS(data: any): PlayedMatchResultsVm {
        data = typeof data === 'object' ? data : {};
        let result = new PlayedMatchResultsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.playedMatches)) {
            data["playedMatches"] = [];
            for (let item of this.playedMatches)
                data["playedMatches"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["perPage"] = this.perPage;
        return data;
    }
}

export interface IPlayedMatchResultsVm {
    playedMatches?: PlayedMatchResultsDto[] | undefined;
    totalCount?: number;
    perPage?: number;
}

export class PlayedMatchResultsDto implements IPlayedMatchResultsDto {
    id?: number;
    redTeam?: number;
    seasonName?: string | undefined;
    redTeamName?: string | undefined;
    redTeamAbv?: string | undefined;
    redTeamScore?: number;
    blueTeam?: number;
    blueTeamName?: string | undefined;
    blueTeamScore?: number;
    blueTeamAbv?: string | undefined;
    winningTeam?: number;
    gameType?: string | undefined;
    isForfeit?: boolean;
    forfeitTeam?: number;
    scheduledTime?: Date | undefined;
    maps?: PlayedMatchResultsMapsDto[] | undefined;
    topPerformers?: PlayedMatchResultsTopPerformersDto | undefined;

    constructor(data?: IPlayedMatchResultsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.redTeam = _data["redTeam"];
            this.seasonName = _data["seasonName"];
            this.redTeamName = _data["redTeamName"];
            this.redTeamAbv = _data["redTeamAbv"];
            this.redTeamScore = _data["redTeamScore"];
            this.blueTeam = _data["blueTeam"];
            this.blueTeamName = _data["blueTeamName"];
            this.blueTeamScore = _data["blueTeamScore"];
            this.blueTeamAbv = _data["blueTeamAbv"];
            this.winningTeam = _data["winningTeam"];
            this.gameType = _data["gameType"];
            this.isForfeit = _data["isForfeit"];
            this.forfeitTeam = _data["forfeitTeam"];
            this.scheduledTime = _data["scheduledTime"] ? new Date(_data["scheduledTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["maps"])) {
                this.maps = [] as any;
                for (let item of _data["maps"])
                    this.maps!.push(PlayedMatchResultsMapsDto.fromJS(item));
            }
            this.topPerformers = _data["topPerformers"] ? PlayedMatchResultsTopPerformersDto.fromJS(_data["topPerformers"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PlayedMatchResultsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayedMatchResultsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["redTeam"] = this.redTeam;
        data["seasonName"] = this.seasonName;
        data["redTeamName"] = this.redTeamName;
        data["redTeamAbv"] = this.redTeamAbv;
        data["redTeamScore"] = this.redTeamScore;
        data["blueTeam"] = this.blueTeam;
        data["blueTeamName"] = this.blueTeamName;
        data["blueTeamScore"] = this.blueTeamScore;
        data["blueTeamAbv"] = this.blueTeamAbv;
        data["winningTeam"] = this.winningTeam;
        data["gameType"] = this.gameType;
        data["isForfeit"] = this.isForfeit;
        data["forfeitTeam"] = this.forfeitTeam;
        data["scheduledTime"] = this.scheduledTime ? this.scheduledTime.toISOString() : <any>undefined;
        if (Array.isArray(this.maps)) {
            data["maps"] = [];
            for (let item of this.maps)
                data["maps"].push(item.toJSON());
        }
        data["topPerformers"] = this.topPerformers ? this.topPerformers.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPlayedMatchResultsDto {
    id?: number;
    redTeam?: number;
    seasonName?: string | undefined;
    redTeamName?: string | undefined;
    redTeamAbv?: string | undefined;
    redTeamScore?: number;
    blueTeam?: number;
    blueTeamName?: string | undefined;
    blueTeamScore?: number;
    blueTeamAbv?: string | undefined;
    winningTeam?: number;
    gameType?: string | undefined;
    isForfeit?: boolean;
    forfeitTeam?: number;
    scheduledTime?: Date | undefined;
    maps?: PlayedMatchResultsMapsDto[] | undefined;
    topPerformers?: PlayedMatchResultsTopPerformersDto | undefined;
}

export class PlayedMatchResultsMapsDto implements IPlayedMatchResultsMapsDto {
    id?: number;
    mapName?: string | undefined;
    mapPack?: string | undefined;
    mapNumber?: string | undefined;
    mapImagePath?: string | undefined;

    constructor(data?: IPlayedMatchResultsMapsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mapName = _data["mapName"];
            this.mapPack = _data["mapPack"];
            this.mapNumber = _data["mapNumber"];
            this.mapImagePath = _data["mapImagePath"];
        }
    }

    static fromJS(data: any): PlayedMatchResultsMapsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayedMatchResultsMapsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mapName"] = this.mapName;
        data["mapPack"] = this.mapPack;
        data["mapNumber"] = this.mapNumber;
        data["mapImagePath"] = this.mapImagePath;
        return data;
    }
}

export interface IPlayedMatchResultsMapsDto {
    id?: number;
    mapName?: string | undefined;
    mapPack?: string | undefined;
    mapNumber?: string | undefined;
    mapImagePath?: string | undefined;
}

export class PlayedMatchResultsTopPerformersDto implements IPlayedMatchResultsTopPerformersDto {
    mostDamage?: PlayedMatchResultsTopPerformersMostDamageDto | undefined;
    mostKills?: PlayedMatchResultsTopPerformersMostKillsDto | undefined;
    mostCaptures?: PlayedMatchResultsTopPerformersMostCapturesDto | undefined;
    mostFlagDefenses?: PlayedMatchResultsTopPerformersMostFlagDefensesDto | undefined;

    constructor(data?: IPlayedMatchResultsTopPerformersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mostDamage = _data["mostDamage"] ? PlayedMatchResultsTopPerformersMostDamageDto.fromJS(_data["mostDamage"]) : <any>undefined;
            this.mostKills = _data["mostKills"] ? PlayedMatchResultsTopPerformersMostKillsDto.fromJS(_data["mostKills"]) : <any>undefined;
            this.mostCaptures = _data["mostCaptures"] ? PlayedMatchResultsTopPerformersMostCapturesDto.fromJS(_data["mostCaptures"]) : <any>undefined;
            this.mostFlagDefenses = _data["mostFlagDefenses"] ? PlayedMatchResultsTopPerformersMostFlagDefensesDto.fromJS(_data["mostFlagDefenses"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PlayedMatchResultsTopPerformersDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayedMatchResultsTopPerformersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mostDamage"] = this.mostDamage ? this.mostDamage.toJSON() : <any>undefined;
        data["mostKills"] = this.mostKills ? this.mostKills.toJSON() : <any>undefined;
        data["mostCaptures"] = this.mostCaptures ? this.mostCaptures.toJSON() : <any>undefined;
        data["mostFlagDefenses"] = this.mostFlagDefenses ? this.mostFlagDefenses.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPlayedMatchResultsTopPerformersDto {
    mostDamage?: PlayedMatchResultsTopPerformersMostDamageDto | undefined;
    mostKills?: PlayedMatchResultsTopPerformersMostKillsDto | undefined;
    mostCaptures?: PlayedMatchResultsTopPerformersMostCapturesDto | undefined;
    mostFlagDefenses?: PlayedMatchResultsTopPerformersMostFlagDefensesDto | undefined;
}

export class PlayedMatchResultsTopPerformersMostDamageDto implements IPlayedMatchResultsTopPerformersMostDamageDto {
    playerId?: number;
    playerName?: string | undefined;
    teamColor?: string | undefined;
    teamAbv?: string | undefined;
    damage?: number;

    constructor(data?: IPlayedMatchResultsTopPerformersMostDamageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.playerName = _data["playerName"];
            this.teamColor = _data["teamColor"];
            this.teamAbv = _data["teamAbv"];
            this.damage = _data["damage"];
        }
    }

    static fromJS(data: any): PlayedMatchResultsTopPerformersMostDamageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayedMatchResultsTopPerformersMostDamageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["playerName"] = this.playerName;
        data["teamColor"] = this.teamColor;
        data["teamAbv"] = this.teamAbv;
        data["damage"] = this.damage;
        return data;
    }
}

export interface IPlayedMatchResultsTopPerformersMostDamageDto {
    playerId?: number;
    playerName?: string | undefined;
    teamColor?: string | undefined;
    teamAbv?: string | undefined;
    damage?: number;
}

export class PlayedMatchResultsTopPerformersMostKillsDto implements IPlayedMatchResultsTopPerformersMostKillsDto {
    playerId?: number;
    playerName?: string | undefined;
    teamColor?: string | undefined;
    teamAbv?: string | undefined;
    kills?: number;

    constructor(data?: IPlayedMatchResultsTopPerformersMostKillsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.playerName = _data["playerName"];
            this.teamColor = _data["teamColor"];
            this.teamAbv = _data["teamAbv"];
            this.kills = _data["kills"];
        }
    }

    static fromJS(data: any): PlayedMatchResultsTopPerformersMostKillsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayedMatchResultsTopPerformersMostKillsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["playerName"] = this.playerName;
        data["teamColor"] = this.teamColor;
        data["teamAbv"] = this.teamAbv;
        data["kills"] = this.kills;
        return data;
    }
}

export interface IPlayedMatchResultsTopPerformersMostKillsDto {
    playerId?: number;
    playerName?: string | undefined;
    teamColor?: string | undefined;
    teamAbv?: string | undefined;
    kills?: number;
}

export class PlayedMatchResultsTopPerformersMostCapturesDto implements IPlayedMatchResultsTopPerformersMostCapturesDto {
    playerId?: number;
    playerName?: string | undefined;
    teamColor?: string | undefined;
    teamAbv?: string | undefined;
    captures?: number;

    constructor(data?: IPlayedMatchResultsTopPerformersMostCapturesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.playerName = _data["playerName"];
            this.teamColor = _data["teamColor"];
            this.teamAbv = _data["teamAbv"];
            this.captures = _data["captures"];
        }
    }

    static fromJS(data: any): PlayedMatchResultsTopPerformersMostCapturesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayedMatchResultsTopPerformersMostCapturesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["playerName"] = this.playerName;
        data["teamColor"] = this.teamColor;
        data["teamAbv"] = this.teamAbv;
        data["captures"] = this.captures;
        return data;
    }
}

export interface IPlayedMatchResultsTopPerformersMostCapturesDto {
    playerId?: number;
    playerName?: string | undefined;
    teamColor?: string | undefined;
    teamAbv?: string | undefined;
    captures?: number;
}

export class PlayedMatchResultsTopPerformersMostFlagDefensesDto implements IPlayedMatchResultsTopPerformersMostFlagDefensesDto {
    playerId?: number;
    playerName?: string | undefined;
    teamColor?: string | undefined;
    teamAbv?: string | undefined;
    flagDefenses?: number;

    constructor(data?: IPlayedMatchResultsTopPerformersMostFlagDefensesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.playerName = _data["playerName"];
            this.teamColor = _data["teamColor"];
            this.teamAbv = _data["teamAbv"];
            this.flagDefenses = _data["flagDefenses"];
        }
    }

    static fromJS(data: any): PlayedMatchResultsTopPerformersMostFlagDefensesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayedMatchResultsTopPerformersMostFlagDefensesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["playerName"] = this.playerName;
        data["teamColor"] = this.teamColor;
        data["teamAbv"] = this.teamAbv;
        data["flagDefenses"] = this.flagDefenses;
        return data;
    }
}

export interface IPlayedMatchResultsTopPerformersMostFlagDefensesDto {
    playerId?: number;
    playerName?: string | undefined;
    teamColor?: string | undefined;
    teamAbv?: string | undefined;
    flagDefenses?: number;
}

export class GameMapsVm implements IGameMapsVm {
    gameMaps?: GameMapsDto[] | undefined;

    constructor(data?: IGameMapsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["gameMaps"])) {
                this.gameMaps = [] as any;
                for (let item of _data["gameMaps"])
                    this.gameMaps!.push(GameMapsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GameMapsVm {
        data = typeof data === 'object' ? data : {};
        let result = new GameMapsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.gameMaps)) {
            data["gameMaps"] = [];
            for (let item of this.gameMaps)
                data["gameMaps"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGameMapsVm {
    gameMaps?: GameMapsDto[] | undefined;
}

export class GameMapsDto implements IGameMapsDto {
    id?: number;
    mapName?: string | undefined;
    mapPack?: string | undefined;
    mapNumber?: number;

    constructor(data?: IGameMapsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mapName = _data["mapName"];
            this.mapPack = _data["mapPack"];
            this.mapNumber = _data["mapNumber"];
        }
    }

    static fromJS(data: any): GameMapsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GameMapsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mapName"] = this.mapName;
        data["mapPack"] = this.mapPack;
        data["mapNumber"] = this.mapNumber;
        return data;
    }
}

export interface IGameMapsDto {
    id?: number;
    mapName?: string | undefined;
    mapPack?: string | undefined;
    mapNumber?: number;
}

export class CreateMatchCommand implements ICreateMatchCommand {
    season?: number;
    week?: number;
    redTeam?: number;
    blueTeam?: number;
    gameDateTime?: Date | undefined;
    gameMapIds?: number[] | undefined;

    constructor(data?: ICreateMatchCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.season = _data["season"];
            this.week = _data["week"];
            this.redTeam = _data["redTeam"];
            this.blueTeam = _data["blueTeam"];
            this.gameDateTime = _data["gameDateTime"] ? new Date(_data["gameDateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["gameMapIds"])) {
                this.gameMapIds = [] as any;
                for (let item of _data["gameMapIds"])
                    this.gameMapIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateMatchCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMatchCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["season"] = this.season;
        data["week"] = this.week;
        data["redTeam"] = this.redTeam;
        data["blueTeam"] = this.blueTeam;
        data["gameDateTime"] = this.gameDateTime ? this.gameDateTime.toISOString() : <any>undefined;
        if (Array.isArray(this.gameMapIds)) {
            data["gameMapIds"] = [];
            for (let item of this.gameMapIds)
                data["gameMapIds"].push(item);
        }
        return data;
    }
}

export interface ICreateMatchCommand {
    season?: number;
    week?: number;
    redTeam?: number;
    blueTeam?: number;
    gameDateTime?: Date | undefined;
    gameMapIds?: number[] | undefined;
}

export class CreateMatchesCommand implements ICreateMatchesCommand {
    seasonId?: number;
    weeklyGames?: WeeklyRequest[] | undefined;

    constructor(data?: ICreateMatchesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seasonId = _data["seasonId"];
            if (Array.isArray(_data["weeklyGames"])) {
                this.weeklyGames = [] as any;
                for (let item of _data["weeklyGames"])
                    this.weeklyGames!.push(WeeklyRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateMatchesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMatchesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seasonId"] = this.seasonId;
        if (Array.isArray(this.weeklyGames)) {
            data["weeklyGames"] = [];
            for (let item of this.weeklyGames)
                data["weeklyGames"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateMatchesCommand {
    seasonId?: number;
    weeklyGames?: WeeklyRequest[] | undefined;
}

export class WeeklyRequest implements IWeeklyRequest {
    weekId?: number;
    mapId?: number | undefined;
    gameList?: NewGame[] | undefined;

    constructor(data?: IWeeklyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekId = _data["weekId"];
            this.mapId = _data["mapId"];
            if (Array.isArray(_data["gameList"])) {
                this.gameList = [] as any;
                for (let item of _data["gameList"])
                    this.gameList!.push(NewGame.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WeeklyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WeeklyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weekId"] = this.weekId;
        data["mapId"] = this.mapId;
        if (Array.isArray(this.gameList)) {
            data["gameList"] = [];
            for (let item of this.gameList)
                data["gameList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWeeklyRequest {
    weekId?: number;
    mapId?: number | undefined;
    gameList?: NewGame[] | undefined;
}

export class NewGame implements INewGame {
    redTeam?: number;
    blueTeam?: number;
    gameDateTime?: Date | undefined;

    constructor(data?: INewGame) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.redTeam = _data["redTeam"];
            this.blueTeam = _data["blueTeam"];
            this.gameDateTime = _data["gameDateTime"] ? new Date(_data["gameDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NewGame {
        data = typeof data === 'object' ? data : {};
        let result = new NewGame();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["redTeam"] = this.redTeam;
        data["blueTeam"] = this.blueTeam;
        data["gameDateTime"] = this.gameDateTime ? this.gameDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface INewGame {
    redTeam?: number;
    blueTeam?: number;
    gameDateTime?: Date | undefined;
}

export class ProcessMatchCommand implements IProcessMatchCommand {
    matchId?: number;
    flipTeams?: boolean;
    gameRounds?: RoundObject[] | undefined;

    constructor(data?: IProcessMatchCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchId = _data["matchId"];
            this.flipTeams = _data["flipTeams"];
            if (Array.isArray(_data["gameRounds"])) {
                this.gameRounds = [] as any;
                for (let item of _data["gameRounds"])
                    this.gameRounds!.push(RoundObject.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcessMatchCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessMatchCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchId"] = this.matchId;
        data["flipTeams"] = this.flipTeams;
        if (Array.isArray(this.gameRounds)) {
            data["gameRounds"] = [];
            for (let item of this.gameRounds)
                data["gameRounds"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProcessMatchCommand {
    matchId?: number;
    flipTeams?: boolean;
    gameRounds?: RoundObject[] | undefined;
}

export class RoundObject implements IRoundObject {
    redTeamPlayerIds?: number[] | undefined;
    blueTeamPlayerIds?: number[] | undefined;
    map?: number;
    roundFileName?: string | undefined;

    constructor(data?: IRoundObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["redTeamPlayerIds"])) {
                this.redTeamPlayerIds = [] as any;
                for (let item of _data["redTeamPlayerIds"])
                    this.redTeamPlayerIds!.push(item);
            }
            if (Array.isArray(_data["blueTeamPlayerIds"])) {
                this.blueTeamPlayerIds = [] as any;
                for (let item of _data["blueTeamPlayerIds"])
                    this.blueTeamPlayerIds!.push(item);
            }
            this.map = _data["map"];
            this.roundFileName = _data["roundFileName"];
        }
    }

    static fromJS(data: any): RoundObject {
        data = typeof data === 'object' ? data : {};
        let result = new RoundObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.redTeamPlayerIds)) {
            data["redTeamPlayerIds"] = [];
            for (let item of this.redTeamPlayerIds)
                data["redTeamPlayerIds"].push(item);
        }
        if (Array.isArray(this.blueTeamPlayerIds)) {
            data["blueTeamPlayerIds"] = [];
            for (let item of this.blueTeamPlayerIds)
                data["blueTeamPlayerIds"].push(item);
        }
        data["map"] = this.map;
        data["roundFileName"] = this.roundFileName;
        return data;
    }
}

export interface IRoundObject {
    redTeamPlayerIds?: number[] | undefined;
    blueTeamPlayerIds?: number[] | undefined;
    map?: number;
    roundFileName?: string | undefined;
}

export class UndoMatchCommand implements IUndoMatchCommand {
    match?: number;

    constructor(data?: IUndoMatchCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.match = _data["match"];
        }
    }

    static fromJS(data: any): UndoMatchCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UndoMatchCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["match"] = this.match;
        return data;
    }
}

export interface IUndoMatchCommand {
    match?: number;
}

export class ForfeitMatchCommand implements IForfeitMatchCommand {
    match?: number;
    redTeamForfeits?: boolean;
    blueTeamForfeits?: boolean;

    constructor(data?: IForfeitMatchCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.match = _data["match"];
            this.redTeamForfeits = _data["redTeamForfeits"];
            this.blueTeamForfeits = _data["blueTeamForfeits"];
        }
    }

    static fromJS(data: any): ForfeitMatchCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ForfeitMatchCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["match"] = this.match;
        data["redTeamForfeits"] = this.redTeamForfeits;
        data["blueTeamForfeits"] = this.blueTeamForfeits;
        return data;
    }
}

export interface IForfeitMatchCommand {
    match?: number;
    redTeamForfeits?: boolean;
    blueTeamForfeits?: boolean;
}

export class ScheduleMatchCommand implements IScheduleMatchCommand {
    match?: number;
    gameDateTime?: Date;

    constructor(data?: IScheduleMatchCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.match = _data["match"];
            this.gameDateTime = _data["gameDateTime"] ? new Date(_data["gameDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduleMatchCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleMatchCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["match"] = this.match;
        data["gameDateTime"] = this.gameDateTime ? this.gameDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IScheduleMatchCommand {
    match?: number;
    gameDateTime?: Date;
}

export class DeletePlayoffMatchCommand implements IDeletePlayoffMatchCommand {
    match?: number;

    constructor(data?: IDeletePlayoffMatchCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.match = _data["match"];
        }
    }

    static fromJS(data: any): DeletePlayoffMatchCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePlayoffMatchCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["match"] = this.match;
        return data;
    }
}

export interface IDeletePlayoffMatchCommand {
    match?: number;
}

export class PlayersVm implements IPlayersVm {
    playerList?: PlayerDto[] | undefined;

    constructor(data?: IPlayersVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["playerList"])) {
                this.playerList = [] as any;
                for (let item of _data["playerList"])
                    this.playerList!.push(PlayerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayersVm {
        data = typeof data === 'object' ? data : {};
        let result = new PlayersVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.playerList)) {
            data["playerList"] = [];
            for (let item of this.playerList)
                data["playerList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlayersVm {
    playerList?: PlayerDto[] | undefined;
}

export class PlayerDto implements IPlayerDto {
    id?: number;
    playerName?: string | undefined;
    playerAlias?: string | undefined;

    constructor(data?: IPlayerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.playerName = _data["playerName"];
            this.playerAlias = _data["playerAlias"];
        }
    }

    static fromJS(data: any): PlayerDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["playerName"] = this.playerName;
        data["playerAlias"] = this.playerAlias;
        return data;
    }
}

export interface IPlayerDto {
    id?: number;
    playerName?: string | undefined;
    playerAlias?: string | undefined;
}

export class PlayersWithDemosVm implements IPlayersWithDemosVm {
    playerList?: PlayerWithDemosDto[] | undefined;

    constructor(data?: IPlayersWithDemosVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["playerList"])) {
                this.playerList = [] as any;
                for (let item of _data["playerList"])
                    this.playerList!.push(PlayerWithDemosDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayersWithDemosVm {
        data = typeof data === 'object' ? data : {};
        let result = new PlayersWithDemosVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.playerList)) {
            data["playerList"] = [];
            for (let item of this.playerList)
                data["playerList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlayersWithDemosVm {
    playerList?: PlayerWithDemosDto[] | undefined;
}

export class PlayerWithDemosDto implements IPlayerWithDemosDto {
    id?: number;
    playerName?: string | undefined;
    playerAlias?: string | undefined;

    constructor(data?: IPlayerWithDemosDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.playerName = _data["playerName"];
            this.playerAlias = _data["playerAlias"];
        }
    }

    static fromJS(data: any): PlayerWithDemosDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerWithDemosDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["playerName"] = this.playerName;
        data["playerAlias"] = this.playerAlias;
        return data;
    }
}

export interface IPlayerWithDemosDto {
    id?: number;
    playerName?: string | undefined;
    playerAlias?: string | undefined;
}

export class PlayerAppearancesListVm implements IPlayerAppearancesListVm {
    playerList?: PlayerAppearancesListDto[] | undefined;

    constructor(data?: IPlayerAppearancesListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["playerList"])) {
                this.playerList = [] as any;
                for (let item of _data["playerList"])
                    this.playerList!.push(PlayerAppearancesListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayerAppearancesListVm {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerAppearancesListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.playerList)) {
            data["playerList"] = [];
            for (let item of this.playerList)
                data["playerList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlayerAppearancesListVm {
    playerList?: PlayerAppearancesListDto[] | undefined;
}

export class PlayerAppearancesListDto implements IPlayerAppearancesListDto {
    playerId?: number;
    playerName?: string | undefined;
    roundAppearances?: number;
    gameAppearances?: number;

    constructor(data?: IPlayerAppearancesListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.playerName = _data["playerName"];
            this.roundAppearances = _data["roundAppearances"];
            this.gameAppearances = _data["gameAppearances"];
        }
    }

    static fromJS(data: any): PlayerAppearancesListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerAppearancesListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["playerName"] = this.playerName;
        data["roundAppearances"] = this.roundAppearances;
        data["gameAppearances"] = this.gameAppearances;
        return data;
    }
}

export interface IPlayerAppearancesListDto {
    playerId?: number;
    playerName?: string | undefined;
    roundAppearances?: number;
    gameAppearances?: number;
}

export class PlayerSummaryVm implements IPlayerSummaryVm {
    id?: number;
    name?: string | undefined;
    drafts?: PlayerSummaryDraftDto[] | undefined;
    captainDrafts?: PlayerCaptainDraftRecordSeasonDto[] | undefined;
    trades?: PlayerSummaryTradeDto[] | undefined;
    seasonsPlayedIn?: SeasonsPlayedInDto[] | undefined;
    totalRecord?: PlayerCaptainRecordDto | undefined;
    regularSeasonRecord?: PlayerCaptainRecordDto | undefined;
    playoffRecord?: PlayerCaptainRecordDto | undefined;
    finalsRecord?: PlayerCaptainRecordDto | undefined;
    playerAllTimeStats?: PlayerSummaryStatsDto | undefined;

    constructor(data?: IPlayerSummaryVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["drafts"])) {
                this.drafts = [] as any;
                for (let item of _data["drafts"])
                    this.drafts!.push(PlayerSummaryDraftDto.fromJS(item));
            }
            if (Array.isArray(_data["captainDrafts"])) {
                this.captainDrafts = [] as any;
                for (let item of _data["captainDrafts"])
                    this.captainDrafts!.push(PlayerCaptainDraftRecordSeasonDto.fromJS(item));
            }
            if (Array.isArray(_data["trades"])) {
                this.trades = [] as any;
                for (let item of _data["trades"])
                    this.trades!.push(PlayerSummaryTradeDto.fromJS(item));
            }
            if (Array.isArray(_data["seasonsPlayedIn"])) {
                this.seasonsPlayedIn = [] as any;
                for (let item of _data["seasonsPlayedIn"])
                    this.seasonsPlayedIn!.push(SeasonsPlayedInDto.fromJS(item));
            }
            this.totalRecord = _data["totalRecord"] ? PlayerCaptainRecordDto.fromJS(_data["totalRecord"]) : <any>undefined;
            this.regularSeasonRecord = _data["regularSeasonRecord"] ? PlayerCaptainRecordDto.fromJS(_data["regularSeasonRecord"]) : <any>undefined;
            this.playoffRecord = _data["playoffRecord"] ? PlayerCaptainRecordDto.fromJS(_data["playoffRecord"]) : <any>undefined;
            this.finalsRecord = _data["finalsRecord"] ? PlayerCaptainRecordDto.fromJS(_data["finalsRecord"]) : <any>undefined;
            this.playerAllTimeStats = _data["playerAllTimeStats"] ? PlayerSummaryStatsDto.fromJS(_data["playerAllTimeStats"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PlayerSummaryVm {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerSummaryVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.drafts)) {
            data["drafts"] = [];
            for (let item of this.drafts)
                data["drafts"].push(item.toJSON());
        }
        if (Array.isArray(this.captainDrafts)) {
            data["captainDrafts"] = [];
            for (let item of this.captainDrafts)
                data["captainDrafts"].push(item.toJSON());
        }
        if (Array.isArray(this.trades)) {
            data["trades"] = [];
            for (let item of this.trades)
                data["trades"].push(item.toJSON());
        }
        if (Array.isArray(this.seasonsPlayedIn)) {
            data["seasonsPlayedIn"] = [];
            for (let item of this.seasonsPlayedIn)
                data["seasonsPlayedIn"].push(item.toJSON());
        }
        data["totalRecord"] = this.totalRecord ? this.totalRecord.toJSON() : <any>undefined;
        data["regularSeasonRecord"] = this.regularSeasonRecord ? this.regularSeasonRecord.toJSON() : <any>undefined;
        data["playoffRecord"] = this.playoffRecord ? this.playoffRecord.toJSON() : <any>undefined;
        data["finalsRecord"] = this.finalsRecord ? this.finalsRecord.toJSON() : <any>undefined;
        data["playerAllTimeStats"] = this.playerAllTimeStats ? this.playerAllTimeStats.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPlayerSummaryVm {
    id?: number;
    name?: string | undefined;
    drafts?: PlayerSummaryDraftDto[] | undefined;
    captainDrafts?: PlayerCaptainDraftRecordSeasonDto[] | undefined;
    trades?: PlayerSummaryTradeDto[] | undefined;
    seasonsPlayedIn?: SeasonsPlayedInDto[] | undefined;
    totalRecord?: PlayerCaptainRecordDto | undefined;
    regularSeasonRecord?: PlayerCaptainRecordDto | undefined;
    playoffRecord?: PlayerCaptainRecordDto | undefined;
    finalsRecord?: PlayerCaptainRecordDto | undefined;
    playerAllTimeStats?: PlayerSummaryStatsDto | undefined;
}

export class PlayerSummaryDraftDto implements IPlayerSummaryDraftDto {
    draftNominationPosition?: number;
    teamDraftPosition?: number;
    teamNominating?: string | undefined;
    playerNominatingId?: number;
    playerNominating?: string | undefined;
    playerNominatedId?: number;
    playerNominated?: string | undefined;
    playerSoldTo?: string | undefined;
    playerSoldToId?: number;
    teamSoldTo?: string | undefined;
    sellPrice?: number;
    seasonName?: string | undefined;
    seasonId?: number;

    constructor(data?: IPlayerSummaryDraftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.draftNominationPosition = _data["draftNominationPosition"];
            this.teamDraftPosition = _data["teamDraftPosition"];
            this.teamNominating = _data["teamNominating"];
            this.playerNominatingId = _data["playerNominatingId"];
            this.playerNominating = _data["playerNominating"];
            this.playerNominatedId = _data["playerNominatedId"];
            this.playerNominated = _data["playerNominated"];
            this.playerSoldTo = _data["playerSoldTo"];
            this.playerSoldToId = _data["playerSoldToId"];
            this.teamSoldTo = _data["teamSoldTo"];
            this.sellPrice = _data["sellPrice"];
            this.seasonName = _data["seasonName"];
            this.seasonId = _data["seasonId"];
        }
    }

    static fromJS(data: any): PlayerSummaryDraftDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerSummaryDraftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["draftNominationPosition"] = this.draftNominationPosition;
        data["teamDraftPosition"] = this.teamDraftPosition;
        data["teamNominating"] = this.teamNominating;
        data["playerNominatingId"] = this.playerNominatingId;
        data["playerNominating"] = this.playerNominating;
        data["playerNominatedId"] = this.playerNominatedId;
        data["playerNominated"] = this.playerNominated;
        data["playerSoldTo"] = this.playerSoldTo;
        data["playerSoldToId"] = this.playerSoldToId;
        data["teamSoldTo"] = this.teamSoldTo;
        data["sellPrice"] = this.sellPrice;
        data["seasonName"] = this.seasonName;
        data["seasonId"] = this.seasonId;
        return data;
    }
}

export interface IPlayerSummaryDraftDto {
    draftNominationPosition?: number;
    teamDraftPosition?: number;
    teamNominating?: string | undefined;
    playerNominatingId?: number;
    playerNominating?: string | undefined;
    playerNominatedId?: number;
    playerNominated?: string | undefined;
    playerSoldTo?: string | undefined;
    playerSoldToId?: number;
    teamSoldTo?: string | undefined;
    sellPrice?: number;
    seasonName?: string | undefined;
    seasonId?: number;
}

export class PlayerCaptainDraftRecordSeasonDto implements IPlayerCaptainDraftRecordSeasonDto {
    seasonId?: number;
    seasonName?: string | undefined;
    draftList?: PlayerSummaryDraftDto[] | undefined;

    constructor(data?: IPlayerCaptainDraftRecordSeasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seasonId = _data["seasonId"];
            this.seasonName = _data["seasonName"];
            if (Array.isArray(_data["draftList"])) {
                this.draftList = [] as any;
                for (let item of _data["draftList"])
                    this.draftList!.push(PlayerSummaryDraftDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayerCaptainDraftRecordSeasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerCaptainDraftRecordSeasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seasonId"] = this.seasonId;
        data["seasonName"] = this.seasonName;
        if (Array.isArray(this.draftList)) {
            data["draftList"] = [];
            for (let item of this.draftList)
                data["draftList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlayerCaptainDraftRecordSeasonDto {
    seasonId?: number;
    seasonName?: string | undefined;
    draftList?: PlayerSummaryDraftDto[] | undefined;
}

export class PlayerSummaryTradeDto implements IPlayerSummaryTradeDto {
    teamTradedFrom?: string | undefined;
    teamTradedTo?: string | undefined;
    tradedPlayerName?: string | undefined;
    playerTradedFor?: string | undefined;
    playerPromotedCaptain?: boolean;
    seasonName?: string | undefined;
    seasonId?: number;
    weekNumber?: number;

    constructor(data?: IPlayerSummaryTradeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamTradedFrom = _data["teamTradedFrom"];
            this.teamTradedTo = _data["teamTradedTo"];
            this.tradedPlayerName = _data["tradedPlayerName"];
            this.playerTradedFor = _data["playerTradedFor"];
            this.playerPromotedCaptain = _data["playerPromotedCaptain"];
            this.seasonName = _data["seasonName"];
            this.seasonId = _data["seasonId"];
            this.weekNumber = _data["weekNumber"];
        }
    }

    static fromJS(data: any): PlayerSummaryTradeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerSummaryTradeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamTradedFrom"] = this.teamTradedFrom;
        data["teamTradedTo"] = this.teamTradedTo;
        data["tradedPlayerName"] = this.tradedPlayerName;
        data["playerTradedFor"] = this.playerTradedFor;
        data["playerPromotedCaptain"] = this.playerPromotedCaptain;
        data["seasonName"] = this.seasonName;
        data["seasonId"] = this.seasonId;
        data["weekNumber"] = this.weekNumber;
        return data;
    }
}

export interface IPlayerSummaryTradeDto {
    teamTradedFrom?: string | undefined;
    teamTradedTo?: string | undefined;
    tradedPlayerName?: string | undefined;
    playerTradedFor?: string | undefined;
    playerPromotedCaptain?: boolean;
    seasonName?: string | undefined;
    seasonId?: number;
    weekNumber?: number;
}

export class SeasonsPlayedInDto implements ISeasonsPlayedInDto {
    id?: number;
    seasonName?: string | undefined;
    teamsPlayedFor?: TeamsPlayedForDto[] | undefined;

    constructor(data?: ISeasonsPlayedInDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.seasonName = _data["seasonName"];
            if (Array.isArray(_data["teamsPlayedFor"])) {
                this.teamsPlayedFor = [] as any;
                for (let item of _data["teamsPlayedFor"])
                    this.teamsPlayedFor!.push(TeamsPlayedForDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SeasonsPlayedInDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonsPlayedInDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["seasonName"] = this.seasonName;
        if (Array.isArray(this.teamsPlayedFor)) {
            data["teamsPlayedFor"] = [];
            for (let item of this.teamsPlayedFor)
                data["teamsPlayedFor"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISeasonsPlayedInDto {
    id?: number;
    seasonName?: string | undefined;
    teamsPlayedFor?: TeamsPlayedForDto[] | undefined;
}

export class TeamsPlayedForDto implements ITeamsPlayedForDto {
    id?: number;
    teamName?: string | undefined;
    didTeamWinSeason?: boolean;
    asCaptain?: boolean;

    constructor(data?: ITeamsPlayedForDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamName = _data["teamName"];
            this.didTeamWinSeason = _data["didTeamWinSeason"];
            this.asCaptain = _data["asCaptain"];
        }
    }

    static fromJS(data: any): TeamsPlayedForDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamsPlayedForDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamName"] = this.teamName;
        data["didTeamWinSeason"] = this.didTeamWinSeason;
        data["asCaptain"] = this.asCaptain;
        return data;
    }
}

export interface ITeamsPlayedForDto {
    id?: number;
    teamName?: string | undefined;
    didTeamWinSeason?: boolean;
    asCaptain?: boolean;
}

export class PlayerCaptainRecordDto implements IPlayerCaptainRecordDto {
    total?: RoundGameRecordDto | undefined;
    asCaptain?: RoundGameRecordDto | undefined;

    constructor(data?: IPlayerCaptainRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"] ? RoundGameRecordDto.fromJS(_data["total"]) : <any>undefined;
            this.asCaptain = _data["asCaptain"] ? RoundGameRecordDto.fromJS(_data["asCaptain"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PlayerCaptainRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerCaptainRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total ? this.total.toJSON() : <any>undefined;
        data["asCaptain"] = this.asCaptain ? this.asCaptain.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPlayerCaptainRecordDto {
    total?: RoundGameRecordDto | undefined;
    asCaptain?: RoundGameRecordDto | undefined;
}

export class RoundGameRecordDto implements IRoundGameRecordDto {
    rounds?: RecordDto | undefined;
    matches?: RecordDto | undefined;

    constructor(data?: IRoundGameRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rounds = _data["rounds"] ? RecordDto.fromJS(_data["rounds"]) : <any>undefined;
            this.matches = _data["matches"] ? RecordDto.fromJS(_data["matches"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RoundGameRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoundGameRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rounds"] = this.rounds ? this.rounds.toJSON() : <any>undefined;
        data["matches"] = this.matches ? this.matches.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRoundGameRecordDto {
    rounds?: RecordDto | undefined;
    matches?: RecordDto | undefined;
}

export class RecordDto implements IRecordDto {
    wins?: number;
    losses?: number;
    ties?: number;
    winPercentage?: number;

    constructor(data?: IRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wins = _data["wins"];
            this.losses = _data["losses"];
            this.ties = _data["ties"];
            this.winPercentage = _data["winPercentage"];
        }
    }

    static fromJS(data: any): RecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wins"] = this.wins;
        data["losses"] = this.losses;
        data["ties"] = this.ties;
        data["winPercentage"] = this.winPercentage;
        return data;
    }
}

export interface IRecordDto {
    wins?: number;
    losses?: number;
    ties?: number;
    winPercentage?: number;
}

export class PlayerSummaryStatsDto implements IPlayerSummaryStatsDto {
    roundsPlayed?: number;
    gamesPlayed?: number;
    totalTimePlayed?: string;
    totalFrags?: number;
    flagCarrierFrags?: number;
    deaths?: number;
    environmentalDeaths?: number;
    damage?: number;
    flagCarrierDamage?: number;
    damageWithFlag?: number;
    flagTouches?: number;
    pickupFlagTouches?: number;
    points?: number;
    assists?: number;
    captures?: number;
    pickupCaptures?: number;
    flagReturns?: number;
    powerPickups?: number;
    longestSpree?: number;
    highestMultiKill?: number;

    constructor(data?: IPlayerSummaryStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roundsPlayed = _data["roundsPlayed"];
            this.gamesPlayed = _data["gamesPlayed"];
            this.totalTimePlayed = _data["totalTimePlayed"];
            this.totalFrags = _data["totalFrags"];
            this.flagCarrierFrags = _data["flagCarrierFrags"];
            this.deaths = _data["deaths"];
            this.environmentalDeaths = _data["environmentalDeaths"];
            this.damage = _data["damage"];
            this.flagCarrierDamage = _data["flagCarrierDamage"];
            this.damageWithFlag = _data["damageWithFlag"];
            this.flagTouches = _data["flagTouches"];
            this.pickupFlagTouches = _data["pickupFlagTouches"];
            this.points = _data["points"];
            this.assists = _data["assists"];
            this.captures = _data["captures"];
            this.pickupCaptures = _data["pickupCaptures"];
            this.flagReturns = _data["flagReturns"];
            this.powerPickups = _data["powerPickups"];
            this.longestSpree = _data["longestSpree"];
            this.highestMultiKill = _data["highestMultiKill"];
        }
    }

    static fromJS(data: any): PlayerSummaryStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerSummaryStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roundsPlayed"] = this.roundsPlayed;
        data["gamesPlayed"] = this.gamesPlayed;
        data["totalTimePlayed"] = this.totalTimePlayed;
        data["totalFrags"] = this.totalFrags;
        data["flagCarrierFrags"] = this.flagCarrierFrags;
        data["deaths"] = this.deaths;
        data["environmentalDeaths"] = this.environmentalDeaths;
        data["damage"] = this.damage;
        data["flagCarrierDamage"] = this.flagCarrierDamage;
        data["damageWithFlag"] = this.damageWithFlag;
        data["flagTouches"] = this.flagTouches;
        data["pickupFlagTouches"] = this.pickupFlagTouches;
        data["points"] = this.points;
        data["assists"] = this.assists;
        data["captures"] = this.captures;
        data["pickupCaptures"] = this.pickupCaptures;
        data["flagReturns"] = this.flagReturns;
        data["powerPickups"] = this.powerPickups;
        data["longestSpree"] = this.longestSpree;
        data["highestMultiKill"] = this.highestMultiKill;
        return data;
    }
}

export interface IPlayerSummaryStatsDto {
    roundsPlayed?: number;
    gamesPlayed?: number;
    totalTimePlayed?: string;
    totalFrags?: number;
    flagCarrierFrags?: number;
    deaths?: number;
    environmentalDeaths?: number;
    damage?: number;
    flagCarrierDamage?: number;
    damageWithFlag?: number;
    flagTouches?: number;
    pickupFlagTouches?: number;
    points?: number;
    assists?: number;
    captures?: number;
    pickupCaptures?: number;
    flagReturns?: number;
    powerPickups?: number;
    longestSpree?: number;
    highestMultiKill?: number;
}

export class CreatePlayerCommand implements ICreatePlayerCommand {
    playerName?: string | undefined;
    playerAlias?: string | undefined;

    constructor(data?: ICreatePlayerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerName = _data["playerName"];
            this.playerAlias = _data["playerAlias"];
        }
    }

    static fromJS(data: any): CreatePlayerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePlayerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerName"] = this.playerName;
        data["playerAlias"] = this.playerAlias;
        return data;
    }
}

export interface ICreatePlayerCommand {
    playerName?: string | undefined;
    playerAlias?: string | undefined;
}

export class AssociatePlayerWithUserCommand implements IAssociatePlayerWithUserCommand {
    playerId?: number;
    userId?: string | undefined;

    constructor(data?: IAssociatePlayerWithUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AssociatePlayerWithUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssociatePlayerWithUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IAssociatePlayerWithUserCommand {
    playerId?: number;
    userId?: string | undefined;
}

export class DisassociatePlayerWithUserCommand implements IDisassociatePlayerWithUserCommand {
    userId?: string | undefined;

    constructor(data?: IDisassociatePlayerWithUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): DisassociatePlayerWithUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DisassociatePlayerWithUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data;
    }
}

export interface IDisassociatePlayerWithUserCommand {
    userId?: string | undefined;
}

export class UpdatePlayerCommand implements IUpdatePlayerCommand {
    playerId?: number;
    playerName?: string | undefined;
    playerAlias?: string | undefined;

    constructor(data?: IUpdatePlayerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.playerName = _data["playerName"];
            this.playerAlias = _data["playerAlias"];
        }
    }

    static fromJS(data: any): UpdatePlayerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlayerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["playerName"] = this.playerName;
        data["playerAlias"] = this.playerAlias;
        return data;
    }
}

export interface IUpdatePlayerCommand {
    playerId?: number;
    playerName?: string | undefined;
    playerAlias?: string | undefined;
}

export class TradePlayerToTeamCommand implements ITradePlayerToTeamCommand {
    season?: number;
    week?: number;
    tradedPlayer?: number;
    tradedPlayerFor?: number;
    teamTradedFrom?: number;
    teamTradedTo?: number;

    constructor(data?: ITradePlayerToTeamCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.season = _data["season"];
            this.week = _data["week"];
            this.tradedPlayer = _data["tradedPlayer"];
            this.tradedPlayerFor = _data["tradedPlayerFor"];
            this.teamTradedFrom = _data["teamTradedFrom"];
            this.teamTradedTo = _data["teamTradedTo"];
        }
    }

    static fromJS(data: any): TradePlayerToTeamCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TradePlayerToTeamCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["season"] = this.season;
        data["week"] = this.week;
        data["tradedPlayer"] = this.tradedPlayer;
        data["tradedPlayerFor"] = this.tradedPlayerFor;
        data["teamTradedFrom"] = this.teamTradedFrom;
        data["teamTradedTo"] = this.teamTradedTo;
        return data;
    }
}

export interface ITradePlayerToTeamCommand {
    season?: number;
    week?: number;
    tradedPlayer?: number;
    tradedPlayerFor?: number;
    teamTradedFrom?: number;
    teamTradedTo?: number;
}

export class TradePlayerToFreeAgencyCommand implements ITradePlayerToFreeAgencyCommand {
    season?: number;
    week?: number;
    tradedPlayer?: number;
    tradedPlayerFor?: number;
    teamTradedFrom?: number;

    constructor(data?: ITradePlayerToFreeAgencyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.season = _data["season"];
            this.week = _data["week"];
            this.tradedPlayer = _data["tradedPlayer"];
            this.tradedPlayerFor = _data["tradedPlayerFor"];
            this.teamTradedFrom = _data["teamTradedFrom"];
        }
    }

    static fromJS(data: any): TradePlayerToFreeAgencyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TradePlayerToFreeAgencyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["season"] = this.season;
        data["week"] = this.week;
        data["tradedPlayer"] = this.tradedPlayer;
        data["tradedPlayerFor"] = this.tradedPlayerFor;
        data["teamTradedFrom"] = this.teamTradedFrom;
        return data;
    }
}

export interface ITradePlayerToFreeAgencyCommand {
    season?: number;
    week?: number;
    tradedPlayer?: number;
    tradedPlayerFor?: number;
    teamTradedFrom?: number;
}

export class PromotePlayerToCaptainCommand implements IPromotePlayerToCaptainCommand {
    season?: number;
    week?: number;
    playerPromotedCaptain?: number;
    team?: number;

    constructor(data?: IPromotePlayerToCaptainCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.season = _data["season"];
            this.week = _data["week"];
            this.playerPromotedCaptain = _data["playerPromotedCaptain"];
            this.team = _data["team"];
        }
    }

    static fromJS(data: any): PromotePlayerToCaptainCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PromotePlayerToCaptainCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["season"] = this.season;
        data["week"] = this.week;
        data["playerPromotedCaptain"] = this.playerPromotedCaptain;
        data["team"] = this.team;
        return data;
    }
}

export interface IPromotePlayerToCaptainCommand {
    season?: number;
    week?: number;
    playerPromotedCaptain?: number;
    team?: number;
}

export class ReverseLastTradeCommand implements IReverseLastTradeCommand {
    season?: number;

    constructor(data?: IReverseLastTradeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.season = _data["season"];
        }
    }

    static fromJS(data: any): ReverseLastTradeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReverseLastTradeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["season"] = this.season;
        return data;
    }
}

export interface IReverseLastTradeCommand {
    season?: number;
}

export enum RoundsOutputFileType {
    Csv = 0,
}

export class SeasonsVm implements ISeasonsVm {
    seasonList?: SeasonDto[] | undefined;

    constructor(data?: ISeasonsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["seasonList"])) {
                this.seasonList = [] as any;
                for (let item of _data["seasonList"])
                    this.seasonList!.push(SeasonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SeasonsVm {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.seasonList)) {
            data["seasonList"] = [];
            for (let item of this.seasonList)
                data["seasonList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISeasonsVm {
    seasonList?: SeasonDto[] | undefined;
}

export class SeasonDto implements ISeasonDto {
    id?: number;
    seasonName?: string | undefined;
    dateStart?: Date;
    engineId?: number;
    engine?: string | undefined;
    wadId?: number;
    wadPlayed?: string | undefined;

    constructor(data?: ISeasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.seasonName = _data["seasonName"];
            this.dateStart = _data["dateStart"] ? new Date(_data["dateStart"].toString()) : <any>undefined;
            this.engineId = _data["engineId"];
            this.engine = _data["engine"];
            this.wadId = _data["wadId"];
            this.wadPlayed = _data["wadPlayed"];
        }
    }

    static fromJS(data: any): SeasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["seasonName"] = this.seasonName;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>undefined;
        data["engineId"] = this.engineId;
        data["engine"] = this.engine;
        data["wadId"] = this.wadId;
        data["wadPlayed"] = this.wadPlayed;
        return data;
    }
}

export interface ISeasonDto {
    id?: number;
    seasonName?: string | undefined;
    dateStart?: Date;
    engineId?: number;
    engine?: string | undefined;
    wadId?: number;
    wadPlayed?: string | undefined;
}

export class PlayedSeasonsVm implements IPlayedSeasonsVm {
    seasonList?: PlayedSeasonDto[] | undefined;

    constructor(data?: IPlayedSeasonsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["seasonList"])) {
                this.seasonList = [] as any;
                for (let item of _data["seasonList"])
                    this.seasonList!.push(PlayedSeasonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayedSeasonsVm {
        data = typeof data === 'object' ? data : {};
        let result = new PlayedSeasonsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.seasonList)) {
            data["seasonList"] = [];
            for (let item of this.seasonList)
                data["seasonList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlayedSeasonsVm {
    seasonList?: PlayedSeasonDto[] | undefined;
}

export class PlayedSeasonDto implements IPlayedSeasonDto {
    id?: number;
    seasonName?: string | undefined;
    dateStart?: Date;
    engine?: string | undefined;
    wadPlayed?: string | undefined;

    constructor(data?: IPlayedSeasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.seasonName = _data["seasonName"];
            this.dateStart = _data["dateStart"] ? new Date(_data["dateStart"].toString()) : <any>undefined;
            this.engine = _data["engine"];
            this.wadPlayed = _data["wadPlayed"];
        }
    }

    static fromJS(data: any): PlayedSeasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayedSeasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["seasonName"] = this.seasonName;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>undefined;
        data["engine"] = this.engine;
        data["wadPlayed"] = this.wadPlayed;
        return data;
    }
}

export interface IPlayedSeasonDto {
    id?: number;
    seasonName?: string | undefined;
    dateStart?: Date;
    engine?: string | undefined;
    wadPlayed?: string | undefined;
}

export class SeasonsWithDemosVm implements ISeasonsWithDemosVm {
    seasonList?: SeasonWithDemosDto[] | undefined;

    constructor(data?: ISeasonsWithDemosVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["seasonList"])) {
                this.seasonList = [] as any;
                for (let item of _data["seasonList"])
                    this.seasonList!.push(SeasonWithDemosDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SeasonsWithDemosVm {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonsWithDemosVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.seasonList)) {
            data["seasonList"] = [];
            for (let item of this.seasonList)
                data["seasonList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISeasonsWithDemosVm {
    seasonList?: SeasonWithDemosDto[] | undefined;
}

export class SeasonWithDemosDto implements ISeasonWithDemosDto {
    id?: number;
    seasonName?: string | undefined;
    dateStart?: Date;
    engine?: string | undefined;
    wadPlayed?: string | undefined;

    constructor(data?: ISeasonWithDemosDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.seasonName = _data["seasonName"];
            this.dateStart = _data["dateStart"] ? new Date(_data["dateStart"].toString()) : <any>undefined;
            this.engine = _data["engine"];
            this.wadPlayed = _data["wadPlayed"];
        }
    }

    static fromJS(data: any): SeasonWithDemosDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonWithDemosDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["seasonName"] = this.seasonName;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>undefined;
        data["engine"] = this.engine;
        data["wadPlayed"] = this.wadPlayed;
        return data;
    }
}

export interface ISeasonWithDemosDto {
    id?: number;
    seasonName?: string | undefined;
    dateStart?: Date;
    engine?: string | undefined;
    wadPlayed?: string | undefined;
}

export class SeasonsWithPlayersVm implements ISeasonsWithPlayersVm {
    seasonList?: SeasonWithPlayersDto[] | undefined;

    constructor(data?: ISeasonsWithPlayersVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["seasonList"])) {
                this.seasonList = [] as any;
                for (let item of _data["seasonList"])
                    this.seasonList!.push(SeasonWithPlayersDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SeasonsWithPlayersVm {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonsWithPlayersVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.seasonList)) {
            data["seasonList"] = [];
            for (let item of this.seasonList)
                data["seasonList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISeasonsWithPlayersVm {
    seasonList?: SeasonWithPlayersDto[] | undefined;
}

export class SeasonWithPlayersDto implements ISeasonWithPlayersDto {
    id?: number;
    seasonName?: string | undefined;
    dateStart?: Date;
    engine?: string | undefined;
    wadPlayed?: string | undefined;

    constructor(data?: ISeasonWithPlayersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.seasonName = _data["seasonName"];
            this.dateStart = _data["dateStart"] ? new Date(_data["dateStart"].toString()) : <any>undefined;
            this.engine = _data["engine"];
            this.wadPlayed = _data["wadPlayed"];
        }
    }

    static fromJS(data: any): SeasonWithPlayersDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonWithPlayersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["seasonName"] = this.seasonName;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>undefined;
        data["engine"] = this.engine;
        data["wadPlayed"] = this.wadPlayed;
        return data;
    }
}

export interface ISeasonWithPlayersDto {
    id?: number;
    seasonName?: string | undefined;
    dateStart?: Date;
    engine?: string | undefined;
    wadPlayed?: string | undefined;
}

export class SeasonSummaryVm implements ISeasonSummaryVm {
    seasonSummary?: SeasonSummaryDto | undefined;

    constructor(data?: ISeasonSummaryVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seasonSummary = _data["seasonSummary"] ? SeasonSummaryDto.fromJS(_data["seasonSummary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SeasonSummaryVm {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonSummaryVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seasonSummary"] = this.seasonSummary ? this.seasonSummary.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISeasonSummaryVm {
    seasonSummary?: SeasonSummaryDto | undefined;
}

export class SeasonSummaryDto implements ISeasonSummaryDto {
    id?: number;
    seasonName?: string | undefined;
    winningTeam?: number | undefined;
    winningTeamName?: string | undefined;
    signupsDateStart?: Date;
    seasonTeams?: SeasonTeamDto[] | undefined;
    seasonDraft?: SeasonDraftDto[] | undefined;
    seasonTrades?: SeasonTradesDto[] | undefined;
    regularSeasonWeeks?: SeasonRegularSeasonWeekDto[] | undefined;
    playoffsWeeks?: SeasonPlayoffWeekDto[] | undefined;
    finalsWeek?: SeasonPlayoffWeekDto | undefined;
    seasonStats?: SeasonCombinedStatsDto | undefined;
    seasonStandings?: SeasonStandingsDto[] | undefined;

    constructor(data?: ISeasonSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.seasonName = _data["seasonName"];
            this.winningTeam = _data["winningTeam"];
            this.winningTeamName = _data["winningTeamName"];
            this.signupsDateStart = _data["signupsDateStart"] ? new Date(_data["signupsDateStart"].toString()) : <any>undefined;
            if (Array.isArray(_data["seasonTeams"])) {
                this.seasonTeams = [] as any;
                for (let item of _data["seasonTeams"])
                    this.seasonTeams!.push(SeasonTeamDto.fromJS(item));
            }
            if (Array.isArray(_data["seasonDraft"])) {
                this.seasonDraft = [] as any;
                for (let item of _data["seasonDraft"])
                    this.seasonDraft!.push(SeasonDraftDto.fromJS(item));
            }
            if (Array.isArray(_data["seasonTrades"])) {
                this.seasonTrades = [] as any;
                for (let item of _data["seasonTrades"])
                    this.seasonTrades!.push(SeasonTradesDto.fromJS(item));
            }
            if (Array.isArray(_data["regularSeasonWeeks"])) {
                this.regularSeasonWeeks = [] as any;
                for (let item of _data["regularSeasonWeeks"])
                    this.regularSeasonWeeks!.push(SeasonRegularSeasonWeekDto.fromJS(item));
            }
            if (Array.isArray(_data["playoffsWeeks"])) {
                this.playoffsWeeks = [] as any;
                for (let item of _data["playoffsWeeks"])
                    this.playoffsWeeks!.push(SeasonPlayoffWeekDto.fromJS(item));
            }
            this.finalsWeek = _data["finalsWeek"] ? SeasonPlayoffWeekDto.fromJS(_data["finalsWeek"]) : <any>undefined;
            this.seasonStats = _data["seasonStats"] ? SeasonCombinedStatsDto.fromJS(_data["seasonStats"]) : <any>undefined;
            if (Array.isArray(_data["seasonStandings"])) {
                this.seasonStandings = [] as any;
                for (let item of _data["seasonStandings"])
                    this.seasonStandings!.push(SeasonStandingsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SeasonSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["seasonName"] = this.seasonName;
        data["winningTeam"] = this.winningTeam;
        data["winningTeamName"] = this.winningTeamName;
        data["signupsDateStart"] = this.signupsDateStart ? this.signupsDateStart.toISOString() : <any>undefined;
        if (Array.isArray(this.seasonTeams)) {
            data["seasonTeams"] = [];
            for (let item of this.seasonTeams)
                data["seasonTeams"].push(item.toJSON());
        }
        if (Array.isArray(this.seasonDraft)) {
            data["seasonDraft"] = [];
            for (let item of this.seasonDraft)
                data["seasonDraft"].push(item.toJSON());
        }
        if (Array.isArray(this.seasonTrades)) {
            data["seasonTrades"] = [];
            for (let item of this.seasonTrades)
                data["seasonTrades"].push(item.toJSON());
        }
        if (Array.isArray(this.regularSeasonWeeks)) {
            data["regularSeasonWeeks"] = [];
            for (let item of this.regularSeasonWeeks)
                data["regularSeasonWeeks"].push(item.toJSON());
        }
        if (Array.isArray(this.playoffsWeeks)) {
            data["playoffsWeeks"] = [];
            for (let item of this.playoffsWeeks)
                data["playoffsWeeks"].push(item.toJSON());
        }
        data["finalsWeek"] = this.finalsWeek ? this.finalsWeek.toJSON() : <any>undefined;
        data["seasonStats"] = this.seasonStats ? this.seasonStats.toJSON() : <any>undefined;
        if (Array.isArray(this.seasonStandings)) {
            data["seasonStandings"] = [];
            for (let item of this.seasonStandings)
                data["seasonStandings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISeasonSummaryDto {
    id?: number;
    seasonName?: string | undefined;
    winningTeam?: number | undefined;
    winningTeamName?: string | undefined;
    signupsDateStart?: Date;
    seasonTeams?: SeasonTeamDto[] | undefined;
    seasonDraft?: SeasonDraftDto[] | undefined;
    seasonTrades?: SeasonTradesDto[] | undefined;
    regularSeasonWeeks?: SeasonRegularSeasonWeekDto[] | undefined;
    playoffsWeeks?: SeasonPlayoffWeekDto[] | undefined;
    finalsWeek?: SeasonPlayoffWeekDto | undefined;
    seasonStats?: SeasonCombinedStatsDto | undefined;
    seasonStandings?: SeasonStandingsDto[] | undefined;
}

export class SeasonTeamDto implements ISeasonTeamDto {
    idTeam?: number;
    teamName?: string | undefined;
    teamAbbreviation?: string | undefined;
    players?: SeasonTeamPlayerDto[] | undefined;

    constructor(data?: ISeasonTeamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idTeam = _data["idTeam"];
            this.teamName = _data["teamName"];
            this.teamAbbreviation = _data["teamAbbreviation"];
            if (Array.isArray(_data["players"])) {
                this.players = [] as any;
                for (let item of _data["players"])
                    this.players!.push(SeasonTeamPlayerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SeasonTeamDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonTeamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idTeam"] = this.idTeam;
        data["teamName"] = this.teamName;
        data["teamAbbreviation"] = this.teamAbbreviation;
        if (Array.isArray(this.players)) {
            data["players"] = [];
            for (let item of this.players)
                data["players"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISeasonTeamDto {
    idTeam?: number;
    teamName?: string | undefined;
    teamAbbreviation?: string | undefined;
    players?: SeasonTeamPlayerDto[] | undefined;
}

export class SeasonTeamPlayerDto implements ISeasonTeamPlayerDto {
    playerId?: number;
    playerName?: string | undefined;

    constructor(data?: ISeasonTeamPlayerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.playerName = _data["playerName"];
        }
    }

    static fromJS(data: any): SeasonTeamPlayerDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonTeamPlayerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["playerName"] = this.playerName;
        return data;
    }
}

export interface ISeasonTeamPlayerDto {
    playerId?: number;
    playerName?: string | undefined;
}

export class SeasonDraftDto implements ISeasonDraftDto {
    draftNominationPosition?: number;
    teamDraftPosition?: number;
    teamNominating?: string | undefined;
    playerNominated?: string | undefined;
    teamSoldTo?: string | undefined;
    sellPrice?: number;

    constructor(data?: ISeasonDraftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.draftNominationPosition = _data["draftNominationPosition"];
            this.teamDraftPosition = _data["teamDraftPosition"];
            this.teamNominating = _data["teamNominating"];
            this.playerNominated = _data["playerNominated"];
            this.teamSoldTo = _data["teamSoldTo"];
            this.sellPrice = _data["sellPrice"];
        }
    }

    static fromJS(data: any): SeasonDraftDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonDraftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["draftNominationPosition"] = this.draftNominationPosition;
        data["teamDraftPosition"] = this.teamDraftPosition;
        data["teamNominating"] = this.teamNominating;
        data["playerNominated"] = this.playerNominated;
        data["teamSoldTo"] = this.teamSoldTo;
        data["sellPrice"] = this.sellPrice;
        return data;
    }
}

export interface ISeasonDraftDto {
    draftNominationPosition?: number;
    teamDraftPosition?: number;
    teamNominating?: string | undefined;
    playerNominated?: string | undefined;
    teamSoldTo?: string | undefined;
    sellPrice?: number;
}

export class SeasonTradesDto implements ISeasonTradesDto {
    weekNumber?: number;
    weekTrades?: SeasonWeekTradeDto[] | undefined;

    constructor(data?: ISeasonTradesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekNumber = _data["weekNumber"];
            if (Array.isArray(_data["weekTrades"])) {
                this.weekTrades = [] as any;
                for (let item of _data["weekTrades"])
                    this.weekTrades!.push(SeasonWeekTradeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SeasonTradesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonTradesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weekNumber"] = this.weekNumber;
        if (Array.isArray(this.weekTrades)) {
            data["weekTrades"] = [];
            for (let item of this.weekTrades)
                data["weekTrades"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISeasonTradesDto {
    weekNumber?: number;
    weekTrades?: SeasonWeekTradeDto[] | undefined;
}

export class SeasonWeekTradeDto implements ISeasonWeekTradeDto {
    teamTradedFrom?: string | undefined;
    teamTradedTo?: string | undefined;
    tradedPlayerName?: string | undefined;
    playerTradedFor?: string | undefined;
    playerPromotedCaptain?: boolean;

    constructor(data?: ISeasonWeekTradeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamTradedFrom = _data["teamTradedFrom"];
            this.teamTradedTo = _data["teamTradedTo"];
            this.tradedPlayerName = _data["tradedPlayerName"];
            this.playerTradedFor = _data["playerTradedFor"];
            this.playerPromotedCaptain = _data["playerPromotedCaptain"];
        }
    }

    static fromJS(data: any): SeasonWeekTradeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonWeekTradeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamTradedFrom"] = this.teamTradedFrom;
        data["teamTradedTo"] = this.teamTradedTo;
        data["tradedPlayerName"] = this.tradedPlayerName;
        data["playerTradedFor"] = this.playerTradedFor;
        data["playerPromotedCaptain"] = this.playerPromotedCaptain;
        return data;
    }
}

export interface ISeasonWeekTradeDto {
    teamTradedFrom?: string | undefined;
    teamTradedTo?: string | undefined;
    tradedPlayerName?: string | undefined;
    playerTradedFor?: string | undefined;
    playerPromotedCaptain?: boolean;
}

export class SeasonRegularSeasonWeekDto implements ISeasonRegularSeasonWeekDto {
    weekNumber?: number;
    weekType?: string | undefined;
    weekStartDate?: Date;
    weekMap?: SeasonMapDto | undefined;
    games?: SeasonGameDto[] | undefined;

    constructor(data?: ISeasonRegularSeasonWeekDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekNumber = _data["weekNumber"];
            this.weekType = _data["weekType"];
            this.weekStartDate = _data["weekStartDate"] ? new Date(_data["weekStartDate"].toString()) : <any>undefined;
            this.weekMap = _data["weekMap"] ? SeasonMapDto.fromJS(_data["weekMap"]) : <any>undefined;
            if (Array.isArray(_data["games"])) {
                this.games = [] as any;
                for (let item of _data["games"])
                    this.games!.push(SeasonGameDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SeasonRegularSeasonWeekDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonRegularSeasonWeekDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weekNumber"] = this.weekNumber;
        data["weekType"] = this.weekType;
        data["weekStartDate"] = this.weekStartDate ? this.weekStartDate.toISOString() : <any>undefined;
        data["weekMap"] = this.weekMap ? this.weekMap.toJSON() : <any>undefined;
        if (Array.isArray(this.games)) {
            data["games"] = [];
            for (let item of this.games)
                data["games"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISeasonRegularSeasonWeekDto {
    weekNumber?: number;
    weekType?: string | undefined;
    weekStartDate?: Date;
    weekMap?: SeasonMapDto | undefined;
    games?: SeasonGameDto[] | undefined;
}

export class SeasonMapDto implements ISeasonMapDto {
    idMap?: number;
    mapPack?: string | undefined;
    mapName?: string | undefined;
    mapNumber?: string | undefined;
    mapImagePath?: string | undefined;

    constructor(data?: ISeasonMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idMap = _data["idMap"];
            this.mapPack = _data["mapPack"];
            this.mapName = _data["mapName"];
            this.mapNumber = _data["mapNumber"];
            this.mapImagePath = _data["mapImagePath"];
        }
    }

    static fromJS(data: any): SeasonMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMap"] = this.idMap;
        data["mapPack"] = this.mapPack;
        data["mapName"] = this.mapName;
        data["mapNumber"] = this.mapNumber;
        data["mapImagePath"] = this.mapImagePath;
        return data;
    }
}

export interface ISeasonMapDto {
    idMap?: number;
    mapPack?: string | undefined;
    mapName?: string | undefined;
    mapNumber?: string | undefined;
    mapImagePath?: string | undefined;
}

export class SeasonGameDto implements ISeasonGameDto {
    idGame?: number;
    gameType?: string | undefined;
    gamePlayed?: boolean;
    isForfeit?: boolean;
    gameDatetime?: Date | undefined;
    teamWinnerColor?: string | undefined;
    teamForfeitColor?: string | undefined;
    redTeamScore?: number;
    blueTeamScore?: number;
    doubleForfeit?: boolean;
    redTeamName?: string | undefined;
    blueTeamName?: string | undefined;
    gameMap?: SeasonMapDto[] | undefined;

    constructor(data?: ISeasonGameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idGame = _data["idGame"];
            this.gameType = _data["gameType"];
            this.gamePlayed = _data["gamePlayed"];
            this.isForfeit = _data["isForfeit"];
            this.gameDatetime = _data["gameDatetime"] ? new Date(_data["gameDatetime"].toString()) : <any>undefined;
            this.teamWinnerColor = _data["teamWinnerColor"];
            this.teamForfeitColor = _data["teamForfeitColor"];
            this.redTeamScore = _data["redTeamScore"];
            this.blueTeamScore = _data["blueTeamScore"];
            this.doubleForfeit = _data["doubleForfeit"];
            this.redTeamName = _data["redTeamName"];
            this.blueTeamName = _data["blueTeamName"];
            if (Array.isArray(_data["gameMap"])) {
                this.gameMap = [] as any;
                for (let item of _data["gameMap"])
                    this.gameMap!.push(SeasonMapDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SeasonGameDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonGameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idGame"] = this.idGame;
        data["gameType"] = this.gameType;
        data["gamePlayed"] = this.gamePlayed;
        data["isForfeit"] = this.isForfeit;
        data["gameDatetime"] = this.gameDatetime ? this.gameDatetime.toISOString() : <any>undefined;
        data["teamWinnerColor"] = this.teamWinnerColor;
        data["teamForfeitColor"] = this.teamForfeitColor;
        data["redTeamScore"] = this.redTeamScore;
        data["blueTeamScore"] = this.blueTeamScore;
        data["doubleForfeit"] = this.doubleForfeit;
        data["redTeamName"] = this.redTeamName;
        data["blueTeamName"] = this.blueTeamName;
        if (Array.isArray(this.gameMap)) {
            data["gameMap"] = [];
            for (let item of this.gameMap)
                data["gameMap"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISeasonGameDto {
    idGame?: number;
    gameType?: string | undefined;
    gamePlayed?: boolean;
    isForfeit?: boolean;
    gameDatetime?: Date | undefined;
    teamWinnerColor?: string | undefined;
    teamForfeitColor?: string | undefined;
    redTeamScore?: number;
    blueTeamScore?: number;
    doubleForfeit?: boolean;
    redTeamName?: string | undefined;
    blueTeamName?: string | undefined;
    gameMap?: SeasonMapDto[] | undefined;
}

export class SeasonPlayoffWeekDto implements ISeasonPlayoffWeekDto {
    weekNumber?: number;
    weekType?: string | undefined;
    weekStartDate?: Date;
    games?: SeasonGameDto[] | undefined;

    constructor(data?: ISeasonPlayoffWeekDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekNumber = _data["weekNumber"];
            this.weekType = _data["weekType"];
            this.weekStartDate = _data["weekStartDate"] ? new Date(_data["weekStartDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["games"])) {
                this.games = [] as any;
                for (let item of _data["games"])
                    this.games!.push(SeasonGameDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SeasonPlayoffWeekDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonPlayoffWeekDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weekNumber"] = this.weekNumber;
        data["weekType"] = this.weekType;
        data["weekStartDate"] = this.weekStartDate ? this.weekStartDate.toISOString() : <any>undefined;
        if (Array.isArray(this.games)) {
            data["games"] = [];
            for (let item of this.games)
                data["games"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISeasonPlayoffWeekDto {
    weekNumber?: number;
    weekType?: string | undefined;
    weekStartDate?: Date;
    games?: SeasonGameDto[] | undefined;
}

export class SeasonCombinedStatsDto implements ISeasonCombinedStatsDto {
    roundsPlayed?: number;
    totalGameTime?: string;
    totalFrags?: number;
    totalDeaths?: number;
    totalCaptures?: number;
    totalPickupCaptures?: number;
    totalAssists?: number;
    totalTouches?: number;
    totalPickupTouches?: number;
    totalFlagDefs?: number;
    totalDamage?: number;

    constructor(data?: ISeasonCombinedStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roundsPlayed = _data["roundsPlayed"];
            this.totalGameTime = _data["totalGameTime"];
            this.totalFrags = _data["totalFrags"];
            this.totalDeaths = _data["totalDeaths"];
            this.totalCaptures = _data["totalCaptures"];
            this.totalPickupCaptures = _data["totalPickupCaptures"];
            this.totalAssists = _data["totalAssists"];
            this.totalTouches = _data["totalTouches"];
            this.totalPickupTouches = _data["totalPickupTouches"];
            this.totalFlagDefs = _data["totalFlagDefs"];
            this.totalDamage = _data["totalDamage"];
        }
    }

    static fromJS(data: any): SeasonCombinedStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonCombinedStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roundsPlayed"] = this.roundsPlayed;
        data["totalGameTime"] = this.totalGameTime;
        data["totalFrags"] = this.totalFrags;
        data["totalDeaths"] = this.totalDeaths;
        data["totalCaptures"] = this.totalCaptures;
        data["totalPickupCaptures"] = this.totalPickupCaptures;
        data["totalAssists"] = this.totalAssists;
        data["totalTouches"] = this.totalTouches;
        data["totalPickupTouches"] = this.totalPickupTouches;
        data["totalFlagDefs"] = this.totalFlagDefs;
        data["totalDamage"] = this.totalDamage;
        return data;
    }
}

export interface ISeasonCombinedStatsDto {
    roundsPlayed?: number;
    totalGameTime?: string;
    totalFrags?: number;
    totalDeaths?: number;
    totalCaptures?: number;
    totalPickupCaptures?: number;
    totalAssists?: number;
    totalTouches?: number;
    totalPickupTouches?: number;
    totalFlagDefs?: number;
    totalDamage?: number;
}

export class SeasonStandingsDto implements ISeasonStandingsDto {
    teamId?: number;
    teamName?: string | undefined;
    points?: number;
    gamesPlayed?: number;
    roundsPlayed?: number;
    timePlayed?: string;
    wins?: number;
    ties?: number;
    losses?: number;
    flagCapturesFor?: number;
    flagCapturesAgainst?: number;
    flagDefenses?: number;
    frags?: number;
    damage?: number;

    constructor(data?: ISeasonStandingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.teamName = _data["teamName"];
            this.points = _data["points"];
            this.gamesPlayed = _data["gamesPlayed"];
            this.roundsPlayed = _data["roundsPlayed"];
            this.timePlayed = _data["timePlayed"];
            this.wins = _data["wins"];
            this.ties = _data["ties"];
            this.losses = _data["losses"];
            this.flagCapturesFor = _data["flagCapturesFor"];
            this.flagCapturesAgainst = _data["flagCapturesAgainst"];
            this.flagDefenses = _data["flagDefenses"];
            this.frags = _data["frags"];
            this.damage = _data["damage"];
        }
    }

    static fromJS(data: any): SeasonStandingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonStandingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["teamName"] = this.teamName;
        data["points"] = this.points;
        data["gamesPlayed"] = this.gamesPlayed;
        data["roundsPlayed"] = this.roundsPlayed;
        data["timePlayed"] = this.timePlayed;
        data["wins"] = this.wins;
        data["ties"] = this.ties;
        data["losses"] = this.losses;
        data["flagCapturesFor"] = this.flagCapturesFor;
        data["flagCapturesAgainst"] = this.flagCapturesAgainst;
        data["flagDefenses"] = this.flagDefenses;
        data["frags"] = this.frags;
        data["damage"] = this.damage;
        return data;
    }
}

export interface ISeasonStandingsDto {
    teamId?: number;
    teamName?: string | undefined;
    points?: number;
    gamesPlayed?: number;
    roundsPlayed?: number;
    timePlayed?: string;
    wins?: number;
    ties?: number;
    losses?: number;
    flagCapturesFor?: number;
    flagCapturesAgainst?: number;
    flagDefenses?: number;
    frags?: number;
    damage?: number;
}

export class SeasonListVm implements ISeasonListVm {
    seasons?: SeasonStandingsVm[] | undefined;

    constructor(data?: ISeasonListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["seasons"])) {
                this.seasons = [] as any;
                for (let item of _data["seasons"])
                    this.seasons!.push(SeasonStandingsVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SeasonListVm {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.seasons)) {
            data["seasons"] = [];
            for (let item of this.seasons)
                data["seasons"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISeasonListVm {
    seasons?: SeasonStandingsVm[] | undefined;
}

export class SeasonStandingsVm implements ISeasonStandingsVm {
    seasonName?: string | undefined;
    seasonStandings?: SeasonStandingsDto[] | undefined;

    constructor(data?: ISeasonStandingsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seasonName = _data["seasonName"];
            if (Array.isArray(_data["seasonStandings"])) {
                this.seasonStandings = [] as any;
                for (let item of _data["seasonStandings"])
                    this.seasonStandings!.push(SeasonStandingsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SeasonStandingsVm {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonStandingsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seasonName"] = this.seasonName;
        if (Array.isArray(this.seasonStandings)) {
            data["seasonStandings"] = [];
            for (let item of this.seasonStandings)
                data["seasonStandings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISeasonStandingsVm {
    seasonName?: string | undefined;
    seasonStandings?: SeasonStandingsDto[] | undefined;
}

export class UnfinishedSeasonsVm implements IUnfinishedSeasonsVm {
    seasonList?: UnfinishedSeasonDto[] | undefined;

    constructor(data?: IUnfinishedSeasonsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["seasonList"])) {
                this.seasonList = [] as any;
                for (let item of _data["seasonList"])
                    this.seasonList!.push(UnfinishedSeasonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UnfinishedSeasonsVm {
        data = typeof data === 'object' ? data : {};
        let result = new UnfinishedSeasonsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.seasonList)) {
            data["seasonList"] = [];
            for (let item of this.seasonList)
                data["seasonList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUnfinishedSeasonsVm {
    seasonList?: UnfinishedSeasonDto[] | undefined;
}

export class UnfinishedSeasonDto implements IUnfinishedSeasonDto {
    id?: number;
    seasonName?: string | undefined;
    dateStart?: Date;
    engine?: string | undefined;
    wadPlayed?: string | undefined;

    constructor(data?: IUnfinishedSeasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.seasonName = _data["seasonName"];
            this.dateStart = _data["dateStart"] ? new Date(_data["dateStart"].toString()) : <any>undefined;
            this.engine = _data["engine"];
            this.wadPlayed = _data["wadPlayed"];
        }
    }

    static fromJS(data: any): UnfinishedSeasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnfinishedSeasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["seasonName"] = this.seasonName;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>undefined;
        data["engine"] = this.engine;
        data["wadPlayed"] = this.wadPlayed;
        return data;
    }
}

export interface IUnfinishedSeasonDto {
    id?: number;
    seasonName?: string | undefined;
    dateStart?: Date;
    engine?: string | undefined;
    wadPlayed?: string | undefined;
}

export class ActiveInactiveSeasonVm implements IActiveInactiveSeasonVm {
    activeSeasonList?: ActiveInactiveSeasonDto[] | undefined;
    inactiveSeasonList?: ActiveInactiveSeasonDto[] | undefined;

    constructor(data?: IActiveInactiveSeasonVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["activeSeasonList"])) {
                this.activeSeasonList = [] as any;
                for (let item of _data["activeSeasonList"])
                    this.activeSeasonList!.push(ActiveInactiveSeasonDto.fromJS(item));
            }
            if (Array.isArray(_data["inactiveSeasonList"])) {
                this.inactiveSeasonList = [] as any;
                for (let item of _data["inactiveSeasonList"])
                    this.inactiveSeasonList!.push(ActiveInactiveSeasonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActiveInactiveSeasonVm {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveInactiveSeasonVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activeSeasonList)) {
            data["activeSeasonList"] = [];
            for (let item of this.activeSeasonList)
                data["activeSeasonList"].push(item.toJSON());
        }
        if (Array.isArray(this.inactiveSeasonList)) {
            data["inactiveSeasonList"] = [];
            for (let item of this.inactiveSeasonList)
                data["inactiveSeasonList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IActiveInactiveSeasonVm {
    activeSeasonList?: ActiveInactiveSeasonDto[] | undefined;
    inactiveSeasonList?: ActiveInactiveSeasonDto[] | undefined;
}

export class ActiveInactiveSeasonDto implements IActiveInactiveSeasonDto {
    id?: number;
    seasonName?: string | undefined;

    constructor(data?: IActiveInactiveSeasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.seasonName = _data["seasonName"];
        }
    }

    static fromJS(data: any): ActiveInactiveSeasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveInactiveSeasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["seasonName"] = this.seasonName;
        return data;
    }
}

export interface IActiveInactiveSeasonDto {
    id?: number;
    seasonName?: string | undefined;
}

export class SeasonPlayersVm implements ISeasonPlayersVm {
    seasonStandings?: SeasonPlayersDto[] | undefined;

    constructor(data?: ISeasonPlayersVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["seasonStandings"])) {
                this.seasonStandings = [] as any;
                for (let item of _data["seasonStandings"])
                    this.seasonStandings!.push(SeasonPlayersDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SeasonPlayersVm {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonPlayersVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.seasonStandings)) {
            data["seasonStandings"] = [];
            for (let item of this.seasonStandings)
                data["seasonStandings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISeasonPlayersVm {
    seasonStandings?: SeasonPlayersDto[] | undefined;
}

export class SeasonPlayersDto implements ISeasonPlayersDto {
    playerName?: string | undefined;
    gamesPlayed?: number;
    roundsPlayed?: number;
    timePlayed?: string;
    points?: number;
    captures?: number;
    pickupCaptures?: number;
    assists?: number;
    flagTouches?: number;
    flagDefenses?: number;
    flagReturns?: number;
    frags?: number;
    deaths?: number;
    damage?: number;
    powerups?: number;

    constructor(data?: ISeasonPlayersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerName = _data["playerName"];
            this.gamesPlayed = _data["gamesPlayed"];
            this.roundsPlayed = _data["roundsPlayed"];
            this.timePlayed = _data["timePlayed"];
            this.points = _data["points"];
            this.captures = _data["captures"];
            this.pickupCaptures = _data["pickupCaptures"];
            this.assists = _data["assists"];
            this.flagTouches = _data["flagTouches"];
            this.flagDefenses = _data["flagDefenses"];
            this.flagReturns = _data["flagReturns"];
            this.frags = _data["frags"];
            this.deaths = _data["deaths"];
            this.damage = _data["damage"];
            this.powerups = _data["powerups"];
        }
    }

    static fromJS(data: any): SeasonPlayersDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonPlayersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerName"] = this.playerName;
        data["gamesPlayed"] = this.gamesPlayed;
        data["roundsPlayed"] = this.roundsPlayed;
        data["timePlayed"] = this.timePlayed;
        data["points"] = this.points;
        data["captures"] = this.captures;
        data["pickupCaptures"] = this.pickupCaptures;
        data["assists"] = this.assists;
        data["flagTouches"] = this.flagTouches;
        data["flagDefenses"] = this.flagDefenses;
        data["flagReturns"] = this.flagReturns;
        data["frags"] = this.frags;
        data["deaths"] = this.deaths;
        data["damage"] = this.damage;
        data["powerups"] = this.powerups;
        return data;
    }
}

export interface ISeasonPlayersDto {
    playerName?: string | undefined;
    gamesPlayed?: number;
    roundsPlayed?: number;
    timePlayed?: string;
    points?: number;
    captures?: number;
    pickupCaptures?: number;
    assists?: number;
    flagTouches?: number;
    flagDefenses?: number;
    flagReturns?: number;
    frags?: number;
    deaths?: number;
    damage?: number;
    powerups?: number;
}

export class FreeAgencyPlayersVm implements IFreeAgencyPlayersVm {
    freeAgency?: FreeAgencyPlayersDto[] | undefined;

    constructor(data?: IFreeAgencyPlayersVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["freeAgency"])) {
                this.freeAgency = [] as any;
                for (let item of _data["freeAgency"])
                    this.freeAgency!.push(FreeAgencyPlayersDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FreeAgencyPlayersVm {
        data = typeof data === 'object' ? data : {};
        let result = new FreeAgencyPlayersVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.freeAgency)) {
            data["freeAgency"] = [];
            for (let item of this.freeAgency)
                data["freeAgency"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFreeAgencyPlayersVm {
    freeAgency?: FreeAgencyPlayersDto[] | undefined;
}

export class FreeAgencyPlayersDto implements IFreeAgencyPlayersDto {
    playerId?: number;
    playerName?: string | undefined;

    constructor(data?: IFreeAgencyPlayersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.playerName = _data["playerName"];
        }
    }

    static fromJS(data: any): FreeAgencyPlayersDto {
        data = typeof data === 'object' ? data : {};
        let result = new FreeAgencyPlayersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["playerName"] = this.playerName;
        return data;
    }
}

export interface IFreeAgencyPlayersDto {
    playerId?: number;
    playerName?: string | undefined;
}

export class CreateSeasonCommand implements ICreateSeasonCommand {
    wadId?: number;
    seasonName?: string | undefined;
    enginePlayed?: number;
    leagueId?: number;
    seasonDateStart?: Date;

    constructor(data?: ICreateSeasonCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wadId = _data["wadId"];
            this.seasonName = _data["seasonName"];
            this.enginePlayed = _data["enginePlayed"];
            this.leagueId = _data["leagueId"];
            this.seasonDateStart = _data["seasonDateStart"] ? new Date(_data["seasonDateStart"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateSeasonCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSeasonCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wadId"] = this.wadId;
        data["seasonName"] = this.seasonName;
        data["enginePlayed"] = this.enginePlayed;
        data["leagueId"] = this.leagueId;
        data["seasonDateStart"] = this.seasonDateStart ? this.seasonDateStart.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateSeasonCommand {
    wadId?: number;
    seasonName?: string | undefined;
    enginePlayed?: number;
    leagueId?: number;
    seasonDateStart?: Date;
}

export class UpdateSeasonCommand implements IUpdateSeasonCommand {
    seasonId?: number;
    wadId?: number;
    engineId?: number;
    leagueId?: number;
    seasonName?: string | undefined;
    dateStart?: Date;

    constructor(data?: IUpdateSeasonCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seasonId = _data["seasonId"];
            this.wadId = _data["wadId"];
            this.engineId = _data["engineId"];
            this.leagueId = _data["leagueId"];
            this.seasonName = _data["seasonName"];
            this.dateStart = _data["dateStart"] ? new Date(_data["dateStart"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateSeasonCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSeasonCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seasonId"] = this.seasonId;
        data["wadId"] = this.wadId;
        data["engineId"] = this.engineId;
        data["leagueId"] = this.leagueId;
        data["seasonName"] = this.seasonName;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateSeasonCommand {
    seasonId?: number;
    wadId?: number;
    engineId?: number;
    leagueId?: number;
    seasonName?: string | undefined;
    dateStart?: Date;
}

export class DeleteSeasonCommand implements IDeleteSeasonCommand {
    seasonId?: number;

    constructor(data?: IDeleteSeasonCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seasonId = _data["seasonId"];
        }
    }

    static fromJS(data: any): DeleteSeasonCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSeasonCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seasonId"] = this.seasonId;
        return data;
    }
}

export interface IDeleteSeasonCommand {
    seasonId?: number;
}

export class CreateSeasonWeeksCommand implements ICreateSeasonWeeksCommand {
    seasonId?: number;
    weekOneDateStart?: Date;
    numWeeksRegularSeason?: number;
    numWeeksPlayoffs?: number;

    constructor(data?: ICreateSeasonWeeksCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seasonId = _data["seasonId"];
            this.weekOneDateStart = _data["weekOneDateStart"] ? new Date(_data["weekOneDateStart"].toString()) : <any>undefined;
            this.numWeeksRegularSeason = _data["numWeeksRegularSeason"];
            this.numWeeksPlayoffs = _data["numWeeksPlayoffs"];
        }
    }

    static fromJS(data: any): CreateSeasonWeeksCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSeasonWeeksCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seasonId"] = this.seasonId;
        data["weekOneDateStart"] = this.weekOneDateStart ? this.weekOneDateStart.toISOString() : <any>undefined;
        data["numWeeksRegularSeason"] = this.numWeeksRegularSeason;
        data["numWeeksPlayoffs"] = this.numWeeksPlayoffs;
        return data;
    }
}

export interface ICreateSeasonWeeksCommand {
    seasonId?: number;
    weekOneDateStart?: Date;
    numWeeksRegularSeason?: number;
    numWeeksPlayoffs?: number;
}

export class TeamSummaryVm implements ITeamSummaryVm {
    teamId?: number;
    seasonId?: number;
    teamCaptainId?: number;
    teamCaptainName?: string | undefined;
    teamName?: string | undefined;
    seasonName?: string | undefined;
    didTeamWinSeason?: boolean;
    record?: TeamRecordDto | undefined;
    homefieldMap?: TeamMapDto | undefined;
    draft?: TeamDraftDto[] | undefined;
    initialLineup?: TeamPlayerDto[] | undefined;
    currentLineup?: TeamPlayerDto[] | undefined;
    allGamePlayers?: TeamPlayerDto[] | undefined;
    trades?: TeamTradesDto[] | undefined;
    regularSeasonGamesPlayed?: TeamGameDto[] | undefined;
    playoffGamesPlayed?: TeamGameDto[] | undefined;
    finalsGamesPlayed?: TeamGameDto[] | undefined;
    stats?: TeamStatsDto | undefined;

    constructor(data?: ITeamSummaryVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.seasonId = _data["seasonId"];
            this.teamCaptainId = _data["teamCaptainId"];
            this.teamCaptainName = _data["teamCaptainName"];
            this.teamName = _data["teamName"];
            this.seasonName = _data["seasonName"];
            this.didTeamWinSeason = _data["didTeamWinSeason"];
            this.record = _data["record"] ? TeamRecordDto.fromJS(_data["record"]) : <any>undefined;
            this.homefieldMap = _data["homefieldMap"] ? TeamMapDto.fromJS(_data["homefieldMap"]) : <any>undefined;
            if (Array.isArray(_data["draft"])) {
                this.draft = [] as any;
                for (let item of _data["draft"])
                    this.draft!.push(TeamDraftDto.fromJS(item));
            }
            if (Array.isArray(_data["initialLineup"])) {
                this.initialLineup = [] as any;
                for (let item of _data["initialLineup"])
                    this.initialLineup!.push(TeamPlayerDto.fromJS(item));
            }
            if (Array.isArray(_data["currentLineup"])) {
                this.currentLineup = [] as any;
                for (let item of _data["currentLineup"])
                    this.currentLineup!.push(TeamPlayerDto.fromJS(item));
            }
            if (Array.isArray(_data["allGamePlayers"])) {
                this.allGamePlayers = [] as any;
                for (let item of _data["allGamePlayers"])
                    this.allGamePlayers!.push(TeamPlayerDto.fromJS(item));
            }
            if (Array.isArray(_data["trades"])) {
                this.trades = [] as any;
                for (let item of _data["trades"])
                    this.trades!.push(TeamTradesDto.fromJS(item));
            }
            if (Array.isArray(_data["regularSeasonGamesPlayed"])) {
                this.regularSeasonGamesPlayed = [] as any;
                for (let item of _data["regularSeasonGamesPlayed"])
                    this.regularSeasonGamesPlayed!.push(TeamGameDto.fromJS(item));
            }
            if (Array.isArray(_data["playoffGamesPlayed"])) {
                this.playoffGamesPlayed = [] as any;
                for (let item of _data["playoffGamesPlayed"])
                    this.playoffGamesPlayed!.push(TeamGameDto.fromJS(item));
            }
            if (Array.isArray(_data["finalsGamesPlayed"])) {
                this.finalsGamesPlayed = [] as any;
                for (let item of _data["finalsGamesPlayed"])
                    this.finalsGamesPlayed!.push(TeamGameDto.fromJS(item));
            }
            this.stats = _data["stats"] ? TeamStatsDto.fromJS(_data["stats"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TeamSummaryVm {
        data = typeof data === 'object' ? data : {};
        let result = new TeamSummaryVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["seasonId"] = this.seasonId;
        data["teamCaptainId"] = this.teamCaptainId;
        data["teamCaptainName"] = this.teamCaptainName;
        data["teamName"] = this.teamName;
        data["seasonName"] = this.seasonName;
        data["didTeamWinSeason"] = this.didTeamWinSeason;
        data["record"] = this.record ? this.record.toJSON() : <any>undefined;
        data["homefieldMap"] = this.homefieldMap ? this.homefieldMap.toJSON() : <any>undefined;
        if (Array.isArray(this.draft)) {
            data["draft"] = [];
            for (let item of this.draft)
                data["draft"].push(item.toJSON());
        }
        if (Array.isArray(this.initialLineup)) {
            data["initialLineup"] = [];
            for (let item of this.initialLineup)
                data["initialLineup"].push(item.toJSON());
        }
        if (Array.isArray(this.currentLineup)) {
            data["currentLineup"] = [];
            for (let item of this.currentLineup)
                data["currentLineup"].push(item.toJSON());
        }
        if (Array.isArray(this.allGamePlayers)) {
            data["allGamePlayers"] = [];
            for (let item of this.allGamePlayers)
                data["allGamePlayers"].push(item.toJSON());
        }
        if (Array.isArray(this.trades)) {
            data["trades"] = [];
            for (let item of this.trades)
                data["trades"].push(item.toJSON());
        }
        if (Array.isArray(this.regularSeasonGamesPlayed)) {
            data["regularSeasonGamesPlayed"] = [];
            for (let item of this.regularSeasonGamesPlayed)
                data["regularSeasonGamesPlayed"].push(item.toJSON());
        }
        if (Array.isArray(this.playoffGamesPlayed)) {
            data["playoffGamesPlayed"] = [];
            for (let item of this.playoffGamesPlayed)
                data["playoffGamesPlayed"].push(item.toJSON());
        }
        if (Array.isArray(this.finalsGamesPlayed)) {
            data["finalsGamesPlayed"] = [];
            for (let item of this.finalsGamesPlayed)
                data["finalsGamesPlayed"].push(item.toJSON());
        }
        data["stats"] = this.stats ? this.stats.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITeamSummaryVm {
    teamId?: number;
    seasonId?: number;
    teamCaptainId?: number;
    teamCaptainName?: string | undefined;
    teamName?: string | undefined;
    seasonName?: string | undefined;
    didTeamWinSeason?: boolean;
    record?: TeamRecordDto | undefined;
    homefieldMap?: TeamMapDto | undefined;
    draft?: TeamDraftDto[] | undefined;
    initialLineup?: TeamPlayerDto[] | undefined;
    currentLineup?: TeamPlayerDto[] | undefined;
    allGamePlayers?: TeamPlayerDto[] | undefined;
    trades?: TeamTradesDto[] | undefined;
    regularSeasonGamesPlayed?: TeamGameDto[] | undefined;
    playoffGamesPlayed?: TeamGameDto[] | undefined;
    finalsGamesPlayed?: TeamGameDto[] | undefined;
    stats?: TeamStatsDto | undefined;
}

export class TeamRecordDto implements ITeamRecordDto {
    win?: number;
    tie?: number;
    loss?: number;

    constructor(data?: ITeamRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.win = _data["win"];
            this.tie = _data["tie"];
            this.loss = _data["loss"];
        }
    }

    static fromJS(data: any): TeamRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["win"] = this.win;
        data["tie"] = this.tie;
        data["loss"] = this.loss;
        return data;
    }
}

export interface ITeamRecordDto {
    win?: number;
    tie?: number;
    loss?: number;
}

export class TeamMapDto implements ITeamMapDto {
    idMap?: number;
    mapPack?: string | undefined;
    mapName?: string | undefined;
    mapNumber?: string | undefined;
    mapImagePath?: string | undefined;

    constructor(data?: ITeamMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idMap = _data["idMap"];
            this.mapPack = _data["mapPack"];
            this.mapName = _data["mapName"];
            this.mapNumber = _data["mapNumber"];
            this.mapImagePath = _data["mapImagePath"];
        }
    }

    static fromJS(data: any): TeamMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMap"] = this.idMap;
        data["mapPack"] = this.mapPack;
        data["mapName"] = this.mapName;
        data["mapNumber"] = this.mapNumber;
        data["mapImagePath"] = this.mapImagePath;
        return data;
    }
}

export interface ITeamMapDto {
    idMap?: number;
    mapPack?: string | undefined;
    mapName?: string | undefined;
    mapNumber?: string | undefined;
    mapImagePath?: string | undefined;
}

export class TeamDraftDto implements ITeamDraftDto {
    draftNominationPosition?: number;
    teamDraftPosition?: number;
    teamNominating?: string | undefined;
    playerNominatedId?: number;
    playerNominated?: string | undefined;
    playerSoldTo?: string | undefined;
    playerSoldToId?: number;
    teamSoldTo?: string | undefined;
    sellPrice?: number;

    constructor(data?: ITeamDraftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.draftNominationPosition = _data["draftNominationPosition"];
            this.teamDraftPosition = _data["teamDraftPosition"];
            this.teamNominating = _data["teamNominating"];
            this.playerNominatedId = _data["playerNominatedId"];
            this.playerNominated = _data["playerNominated"];
            this.playerSoldTo = _data["playerSoldTo"];
            this.playerSoldToId = _data["playerSoldToId"];
            this.teamSoldTo = _data["teamSoldTo"];
            this.sellPrice = _data["sellPrice"];
        }
    }

    static fromJS(data: any): TeamDraftDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamDraftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["draftNominationPosition"] = this.draftNominationPosition;
        data["teamDraftPosition"] = this.teamDraftPosition;
        data["teamNominating"] = this.teamNominating;
        data["playerNominatedId"] = this.playerNominatedId;
        data["playerNominated"] = this.playerNominated;
        data["playerSoldTo"] = this.playerSoldTo;
        data["playerSoldToId"] = this.playerSoldToId;
        data["teamSoldTo"] = this.teamSoldTo;
        data["sellPrice"] = this.sellPrice;
        return data;
    }
}

export interface ITeamDraftDto {
    draftNominationPosition?: number;
    teamDraftPosition?: number;
    teamNominating?: string | undefined;
    playerNominatedId?: number;
    playerNominated?: string | undefined;
    playerSoldTo?: string | undefined;
    playerSoldToId?: number;
    teamSoldTo?: string | undefined;
    sellPrice?: number;
}

export class TeamPlayerDto implements ITeamPlayerDto {
    playerId?: number;
    playerName?: string | undefined;

    constructor(data?: ITeamPlayerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.playerName = _data["playerName"];
        }
    }

    static fromJS(data: any): TeamPlayerDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamPlayerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["playerName"] = this.playerName;
        return data;
    }
}

export interface ITeamPlayerDto {
    playerId?: number;
    playerName?: string | undefined;
}

export class TeamTradesDto implements ITeamTradesDto {
    weekNumber?: number;
    weekTrades?: TeamWeekTradeDto[] | undefined;

    constructor(data?: ITeamTradesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekNumber = _data["weekNumber"];
            if (Array.isArray(_data["weekTrades"])) {
                this.weekTrades = [] as any;
                for (let item of _data["weekTrades"])
                    this.weekTrades!.push(TeamWeekTradeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TeamTradesDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamTradesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weekNumber"] = this.weekNumber;
        if (Array.isArray(this.weekTrades)) {
            data["weekTrades"] = [];
            for (let item of this.weekTrades)
                data["weekTrades"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITeamTradesDto {
    weekNumber?: number;
    weekTrades?: TeamWeekTradeDto[] | undefined;
}

export class TeamWeekTradeDto implements ITeamWeekTradeDto {
    teamTradedFrom?: string | undefined;
    teamTradedTo?: string | undefined;
    tradedPlayerName?: string | undefined;
    playerTradedFor?: string | undefined;
    playerPromotedCaptain?: boolean;

    constructor(data?: ITeamWeekTradeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamTradedFrom = _data["teamTradedFrom"];
            this.teamTradedTo = _data["teamTradedTo"];
            this.tradedPlayerName = _data["tradedPlayerName"];
            this.playerTradedFor = _data["playerTradedFor"];
            this.playerPromotedCaptain = _data["playerPromotedCaptain"];
        }
    }

    static fromJS(data: any): TeamWeekTradeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamWeekTradeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamTradedFrom"] = this.teamTradedFrom;
        data["teamTradedTo"] = this.teamTradedTo;
        data["tradedPlayerName"] = this.tradedPlayerName;
        data["playerTradedFor"] = this.playerTradedFor;
        data["playerPromotedCaptain"] = this.playerPromotedCaptain;
        return data;
    }
}

export interface ITeamWeekTradeDto {
    teamTradedFrom?: string | undefined;
    teamTradedTo?: string | undefined;
    tradedPlayerName?: string | undefined;
    playerTradedFor?: string | undefined;
    playerPromotedCaptain?: boolean;
}

export class TeamGameDto implements ITeamGameDto {
    idGame?: number;
    gameType?: string | undefined;
    weekNumber?: number;
    gamePlayed?: boolean;
    isForfeit?: boolean;
    gameDatetime?: Date | undefined;
    teamWinnerColor?: string | undefined;
    teamForfeitColor?: string | undefined;
    redTeamScore?: number;
    blueTeamScore?: number;
    doubleForfeit?: boolean;
    redTeamName?: string | undefined;
    blueTeamName?: string | undefined;
    gameMap?: TeamMapDto[] | undefined;

    constructor(data?: ITeamGameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idGame = _data["idGame"];
            this.gameType = _data["gameType"];
            this.weekNumber = _data["weekNumber"];
            this.gamePlayed = _data["gamePlayed"];
            this.isForfeit = _data["isForfeit"];
            this.gameDatetime = _data["gameDatetime"] ? new Date(_data["gameDatetime"].toString()) : <any>undefined;
            this.teamWinnerColor = _data["teamWinnerColor"];
            this.teamForfeitColor = _data["teamForfeitColor"];
            this.redTeamScore = _data["redTeamScore"];
            this.blueTeamScore = _data["blueTeamScore"];
            this.doubleForfeit = _data["doubleForfeit"];
            this.redTeamName = _data["redTeamName"];
            this.blueTeamName = _data["blueTeamName"];
            if (Array.isArray(_data["gameMap"])) {
                this.gameMap = [] as any;
                for (let item of _data["gameMap"])
                    this.gameMap!.push(TeamMapDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TeamGameDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamGameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idGame"] = this.idGame;
        data["gameType"] = this.gameType;
        data["weekNumber"] = this.weekNumber;
        data["gamePlayed"] = this.gamePlayed;
        data["isForfeit"] = this.isForfeit;
        data["gameDatetime"] = this.gameDatetime ? this.gameDatetime.toISOString() : <any>undefined;
        data["teamWinnerColor"] = this.teamWinnerColor;
        data["teamForfeitColor"] = this.teamForfeitColor;
        data["redTeamScore"] = this.redTeamScore;
        data["blueTeamScore"] = this.blueTeamScore;
        data["doubleForfeit"] = this.doubleForfeit;
        data["redTeamName"] = this.redTeamName;
        data["blueTeamName"] = this.blueTeamName;
        if (Array.isArray(this.gameMap)) {
            data["gameMap"] = [];
            for (let item of this.gameMap)
                data["gameMap"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITeamGameDto {
    idGame?: number;
    gameType?: string | undefined;
    weekNumber?: number;
    gamePlayed?: boolean;
    isForfeit?: boolean;
    gameDatetime?: Date | undefined;
    teamWinnerColor?: string | undefined;
    teamForfeitColor?: string | undefined;
    redTeamScore?: number;
    blueTeamScore?: number;
    doubleForfeit?: boolean;
    redTeamName?: string | undefined;
    blueTeamName?: string | undefined;
    gameMap?: TeamMapDto[] | undefined;
}

export class TeamStatsDto implements ITeamStatsDto {
    gamesPlayed?: number;
    roundsPlayed?: number;
    timePlayed?: string;
    points?: number;
    captures?: number;
    pickupCaptures?: number;
    assists?: number;
    damageBetweenTouchAndCaptureMin?: number | undefined;
    damageBetweenTouchAndCaptureMax?: number | undefined;
    damageBetweenTouchAndCaptureAverage?: number | undefined;
    captureTimeMin?: string;
    captureTimeMax?: string;
    captureTimeAverage?: string;
    captureHealthMin?: number | undefined;
    captureHealthMax?: number | undefined;
    captureHealthAverage?: number | undefined;
    captureGreenArmorMin?: number | undefined;
    captureGreenArmorMax?: number | undefined;
    captureGreenArmorAverage?: number | undefined;
    captureBlueArmorMin?: number | undefined;
    captureBlueArmorMax?: number | undefined;
    captureBlueArmorAverage?: number | undefined;
    capturesWithSuperPickups?: number;
    flagCarriersKilledWhileHoldingFlag?: number;
    highestKillsBeforeCapturing?: number;
    pickupCaptureTimeMin?: string;
    pickupCaptureTimeMax?: string;
    pickupCaptureTimeAverage?: string;
    flagTouches?: number;
    pickupFlagTouches?: number;
    flagDefenses?: number;
    flagReturns?: number;
    frags?: number;
    deaths?: number;
    environmentalDeaths?: number;
    environmentalFlagCarrierDeaths?: number;
    teamKills?: number;
    killingSprees?: number;
    rampages?: number;
    dominatings?: number;
    unstoppables?: number;
    godLikes?: number;
    wickedSicks?: number;
    longestSpree?: number;
    doubleKills?: number;
    multiKills?: number;
    ultraKills?: number;
    monsterKills?: number;
    highestMultiKill?: number;
    pickupHealthGained?: number;
    healthFromNonPowerups?: number;
    healthWhenTouchingFlagMin?: number | undefined;
    healthWhenTouchingFlagMax?: number | undefined;
    healthWhenTouchingFlagAverage?: number | undefined;
    greenArmorWhenTouchingFlagMin?: number | undefined;
    greenArmorWhenTouchingFlagMax?: number | undefined;
    greenArmorWhenTouchingFlagAverage?: number | undefined;
    blueArmorWhenTouchingFlagMin?: number | undefined;
    blueArmorWhenTouchingFlagMax?: number | undefined;
    blueArmorWhenTouchingFlagAverage?: number | undefined;
    healthWhenTouchingFlagThatResultsInCaptureMin?: number | undefined;
    healthWhenTouchingFlagThatResultsInCaptureMax?: number | undefined;
    healthWhenTouchingFlagThatResultsInCaptureAverage?: number | undefined;
    damage?: number;
    damageTakenFromEnvironment?: number;
    damageTakenFromEnvironmentAsFlagCarrier?: number;
    damageToFlagCarriers?: number;
    damageDoneWithFlag?: number;
    damageToGreenArmor?: number;
    damageToBlueArmor?: number;
    powerups?: number;

    constructor(data?: ITeamStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gamesPlayed = _data["gamesPlayed"];
            this.roundsPlayed = _data["roundsPlayed"];
            this.timePlayed = _data["timePlayed"];
            this.points = _data["points"];
            this.captures = _data["captures"];
            this.pickupCaptures = _data["pickupCaptures"];
            this.assists = _data["assists"];
            this.damageBetweenTouchAndCaptureMin = _data["damageBetweenTouchAndCaptureMin"];
            this.damageBetweenTouchAndCaptureMax = _data["damageBetweenTouchAndCaptureMax"];
            this.damageBetweenTouchAndCaptureAverage = _data["damageBetweenTouchAndCaptureAverage"];
            this.captureTimeMin = _data["captureTimeMin"];
            this.captureTimeMax = _data["captureTimeMax"];
            this.captureTimeAverage = _data["captureTimeAverage"];
            this.captureHealthMin = _data["captureHealthMin"];
            this.captureHealthMax = _data["captureHealthMax"];
            this.captureHealthAverage = _data["captureHealthAverage"];
            this.captureGreenArmorMin = _data["captureGreenArmorMin"];
            this.captureGreenArmorMax = _data["captureGreenArmorMax"];
            this.captureGreenArmorAverage = _data["captureGreenArmorAverage"];
            this.captureBlueArmorMin = _data["captureBlueArmorMin"];
            this.captureBlueArmorMax = _data["captureBlueArmorMax"];
            this.captureBlueArmorAverage = _data["captureBlueArmorAverage"];
            this.capturesWithSuperPickups = _data["capturesWithSuperPickups"];
            this.flagCarriersKilledWhileHoldingFlag = _data["flagCarriersKilledWhileHoldingFlag"];
            this.highestKillsBeforeCapturing = _data["highestKillsBeforeCapturing"];
            this.pickupCaptureTimeMin = _data["pickupCaptureTimeMin"];
            this.pickupCaptureTimeMax = _data["pickupCaptureTimeMax"];
            this.pickupCaptureTimeAverage = _data["pickupCaptureTimeAverage"];
            this.flagTouches = _data["flagTouches"];
            this.pickupFlagTouches = _data["pickupFlagTouches"];
            this.flagDefenses = _data["flagDefenses"];
            this.flagReturns = _data["flagReturns"];
            this.frags = _data["frags"];
            this.deaths = _data["deaths"];
            this.environmentalDeaths = _data["environmentalDeaths"];
            this.environmentalFlagCarrierDeaths = _data["environmentalFlagCarrierDeaths"];
            this.teamKills = _data["teamKills"];
            this.killingSprees = _data["killingSprees"];
            this.rampages = _data["rampages"];
            this.dominatings = _data["dominatings"];
            this.unstoppables = _data["unstoppables"];
            this.godLikes = _data["godLikes"];
            this.wickedSicks = _data["wickedSicks"];
            this.longestSpree = _data["longestSpree"];
            this.doubleKills = _data["doubleKills"];
            this.multiKills = _data["multiKills"];
            this.ultraKills = _data["ultraKills"];
            this.monsterKills = _data["monsterKills"];
            this.highestMultiKill = _data["highestMultiKill"];
            this.pickupHealthGained = _data["pickupHealthGained"];
            this.healthFromNonPowerups = _data["healthFromNonPowerups"];
            this.healthWhenTouchingFlagMin = _data["healthWhenTouchingFlagMin"];
            this.healthWhenTouchingFlagMax = _data["healthWhenTouchingFlagMax"];
            this.healthWhenTouchingFlagAverage = _data["healthWhenTouchingFlagAverage"];
            this.greenArmorWhenTouchingFlagMin = _data["greenArmorWhenTouchingFlagMin"];
            this.greenArmorWhenTouchingFlagMax = _data["greenArmorWhenTouchingFlagMax"];
            this.greenArmorWhenTouchingFlagAverage = _data["greenArmorWhenTouchingFlagAverage"];
            this.blueArmorWhenTouchingFlagMin = _data["blueArmorWhenTouchingFlagMin"];
            this.blueArmorWhenTouchingFlagMax = _data["blueArmorWhenTouchingFlagMax"];
            this.blueArmorWhenTouchingFlagAverage = _data["blueArmorWhenTouchingFlagAverage"];
            this.healthWhenTouchingFlagThatResultsInCaptureMin = _data["healthWhenTouchingFlagThatResultsInCaptureMin"];
            this.healthWhenTouchingFlagThatResultsInCaptureMax = _data["healthWhenTouchingFlagThatResultsInCaptureMax"];
            this.healthWhenTouchingFlagThatResultsInCaptureAverage = _data["healthWhenTouchingFlagThatResultsInCaptureAverage"];
            this.damage = _data["damage"];
            this.damageTakenFromEnvironment = _data["damageTakenFromEnvironment"];
            this.damageTakenFromEnvironmentAsFlagCarrier = _data["damageTakenFromEnvironmentAsFlagCarrier"];
            this.damageToFlagCarriers = _data["damageToFlagCarriers"];
            this.damageDoneWithFlag = _data["damageDoneWithFlag"];
            this.damageToGreenArmor = _data["damageToGreenArmor"];
            this.damageToBlueArmor = _data["damageToBlueArmor"];
            this.powerups = _data["powerups"];
        }
    }

    static fromJS(data: any): TeamStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gamesPlayed"] = this.gamesPlayed;
        data["roundsPlayed"] = this.roundsPlayed;
        data["timePlayed"] = this.timePlayed;
        data["points"] = this.points;
        data["captures"] = this.captures;
        data["pickupCaptures"] = this.pickupCaptures;
        data["assists"] = this.assists;
        data["damageBetweenTouchAndCaptureMin"] = this.damageBetweenTouchAndCaptureMin;
        data["damageBetweenTouchAndCaptureMax"] = this.damageBetweenTouchAndCaptureMax;
        data["damageBetweenTouchAndCaptureAverage"] = this.damageBetweenTouchAndCaptureAverage;
        data["captureTimeMin"] = this.captureTimeMin;
        data["captureTimeMax"] = this.captureTimeMax;
        data["captureTimeAverage"] = this.captureTimeAverage;
        data["captureHealthMin"] = this.captureHealthMin;
        data["captureHealthMax"] = this.captureHealthMax;
        data["captureHealthAverage"] = this.captureHealthAverage;
        data["captureGreenArmorMin"] = this.captureGreenArmorMin;
        data["captureGreenArmorMax"] = this.captureGreenArmorMax;
        data["captureGreenArmorAverage"] = this.captureGreenArmorAverage;
        data["captureBlueArmorMin"] = this.captureBlueArmorMin;
        data["captureBlueArmorMax"] = this.captureBlueArmorMax;
        data["captureBlueArmorAverage"] = this.captureBlueArmorAverage;
        data["capturesWithSuperPickups"] = this.capturesWithSuperPickups;
        data["flagCarriersKilledWhileHoldingFlag"] = this.flagCarriersKilledWhileHoldingFlag;
        data["highestKillsBeforeCapturing"] = this.highestKillsBeforeCapturing;
        data["pickupCaptureTimeMin"] = this.pickupCaptureTimeMin;
        data["pickupCaptureTimeMax"] = this.pickupCaptureTimeMax;
        data["pickupCaptureTimeAverage"] = this.pickupCaptureTimeAverage;
        data["flagTouches"] = this.flagTouches;
        data["pickupFlagTouches"] = this.pickupFlagTouches;
        data["flagDefenses"] = this.flagDefenses;
        data["flagReturns"] = this.flagReturns;
        data["frags"] = this.frags;
        data["deaths"] = this.deaths;
        data["environmentalDeaths"] = this.environmentalDeaths;
        data["environmentalFlagCarrierDeaths"] = this.environmentalFlagCarrierDeaths;
        data["teamKills"] = this.teamKills;
        data["killingSprees"] = this.killingSprees;
        data["rampages"] = this.rampages;
        data["dominatings"] = this.dominatings;
        data["unstoppables"] = this.unstoppables;
        data["godLikes"] = this.godLikes;
        data["wickedSicks"] = this.wickedSicks;
        data["longestSpree"] = this.longestSpree;
        data["doubleKills"] = this.doubleKills;
        data["multiKills"] = this.multiKills;
        data["ultraKills"] = this.ultraKills;
        data["monsterKills"] = this.monsterKills;
        data["highestMultiKill"] = this.highestMultiKill;
        data["pickupHealthGained"] = this.pickupHealthGained;
        data["healthFromNonPowerups"] = this.healthFromNonPowerups;
        data["healthWhenTouchingFlagMin"] = this.healthWhenTouchingFlagMin;
        data["healthWhenTouchingFlagMax"] = this.healthWhenTouchingFlagMax;
        data["healthWhenTouchingFlagAverage"] = this.healthWhenTouchingFlagAverage;
        data["greenArmorWhenTouchingFlagMin"] = this.greenArmorWhenTouchingFlagMin;
        data["greenArmorWhenTouchingFlagMax"] = this.greenArmorWhenTouchingFlagMax;
        data["greenArmorWhenTouchingFlagAverage"] = this.greenArmorWhenTouchingFlagAverage;
        data["blueArmorWhenTouchingFlagMin"] = this.blueArmorWhenTouchingFlagMin;
        data["blueArmorWhenTouchingFlagMax"] = this.blueArmorWhenTouchingFlagMax;
        data["blueArmorWhenTouchingFlagAverage"] = this.blueArmorWhenTouchingFlagAverage;
        data["healthWhenTouchingFlagThatResultsInCaptureMin"] = this.healthWhenTouchingFlagThatResultsInCaptureMin;
        data["healthWhenTouchingFlagThatResultsInCaptureMax"] = this.healthWhenTouchingFlagThatResultsInCaptureMax;
        data["healthWhenTouchingFlagThatResultsInCaptureAverage"] = this.healthWhenTouchingFlagThatResultsInCaptureAverage;
        data["damage"] = this.damage;
        data["damageTakenFromEnvironment"] = this.damageTakenFromEnvironment;
        data["damageTakenFromEnvironmentAsFlagCarrier"] = this.damageTakenFromEnvironmentAsFlagCarrier;
        data["damageToFlagCarriers"] = this.damageToFlagCarriers;
        data["damageDoneWithFlag"] = this.damageDoneWithFlag;
        data["damageToGreenArmor"] = this.damageToGreenArmor;
        data["damageToBlueArmor"] = this.damageToBlueArmor;
        data["powerups"] = this.powerups;
        return data;
    }
}

export interface ITeamStatsDto {
    gamesPlayed?: number;
    roundsPlayed?: number;
    timePlayed?: string;
    points?: number;
    captures?: number;
    pickupCaptures?: number;
    assists?: number;
    damageBetweenTouchAndCaptureMin?: number | undefined;
    damageBetweenTouchAndCaptureMax?: number | undefined;
    damageBetweenTouchAndCaptureAverage?: number | undefined;
    captureTimeMin?: string;
    captureTimeMax?: string;
    captureTimeAverage?: string;
    captureHealthMin?: number | undefined;
    captureHealthMax?: number | undefined;
    captureHealthAverage?: number | undefined;
    captureGreenArmorMin?: number | undefined;
    captureGreenArmorMax?: number | undefined;
    captureGreenArmorAverage?: number | undefined;
    captureBlueArmorMin?: number | undefined;
    captureBlueArmorMax?: number | undefined;
    captureBlueArmorAverage?: number | undefined;
    capturesWithSuperPickups?: number;
    flagCarriersKilledWhileHoldingFlag?: number;
    highestKillsBeforeCapturing?: number;
    pickupCaptureTimeMin?: string;
    pickupCaptureTimeMax?: string;
    pickupCaptureTimeAverage?: string;
    flagTouches?: number;
    pickupFlagTouches?: number;
    flagDefenses?: number;
    flagReturns?: number;
    frags?: number;
    deaths?: number;
    environmentalDeaths?: number;
    environmentalFlagCarrierDeaths?: number;
    teamKills?: number;
    killingSprees?: number;
    rampages?: number;
    dominatings?: number;
    unstoppables?: number;
    godLikes?: number;
    wickedSicks?: number;
    longestSpree?: number;
    doubleKills?: number;
    multiKills?: number;
    ultraKills?: number;
    monsterKills?: number;
    highestMultiKill?: number;
    pickupHealthGained?: number;
    healthFromNonPowerups?: number;
    healthWhenTouchingFlagMin?: number | undefined;
    healthWhenTouchingFlagMax?: number | undefined;
    healthWhenTouchingFlagAverage?: number | undefined;
    greenArmorWhenTouchingFlagMin?: number | undefined;
    greenArmorWhenTouchingFlagMax?: number | undefined;
    greenArmorWhenTouchingFlagAverage?: number | undefined;
    blueArmorWhenTouchingFlagMin?: number | undefined;
    blueArmorWhenTouchingFlagMax?: number | undefined;
    blueArmorWhenTouchingFlagAverage?: number | undefined;
    healthWhenTouchingFlagThatResultsInCaptureMin?: number | undefined;
    healthWhenTouchingFlagThatResultsInCaptureMax?: number | undefined;
    healthWhenTouchingFlagThatResultsInCaptureAverage?: number | undefined;
    damage?: number;
    damageTakenFromEnvironment?: number;
    damageTakenFromEnvironmentAsFlagCarrier?: number;
    damageToFlagCarriers?: number;
    damageDoneWithFlag?: number;
    damageToGreenArmor?: number;
    damageToBlueArmor?: number;
    powerups?: number;
}

export class TeamsVm implements ITeamsVm {
    teamList?: TeamsDto[] | undefined;

    constructor(data?: ITeamsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["teamList"])) {
                this.teamList = [] as any;
                for (let item of _data["teamList"])
                    this.teamList!.push(TeamsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TeamsVm {
        data = typeof data === 'object' ? data : {};
        let result = new TeamsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.teamList)) {
            data["teamList"] = [];
            for (let item of this.teamList)
                data["teamList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITeamsVm {
    teamList?: TeamsDto[] | undefined;
}

export class TeamsDto implements ITeamsDto {
    id?: number;
    teamName?: string | undefined;
    teamAbbreviation?: string | undefined;
    homeFieldMapName?: string | undefined;
    homeFieldMapId?: number | undefined;

    constructor(data?: ITeamsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamName = _data["teamName"];
            this.teamAbbreviation = _data["teamAbbreviation"];
            this.homeFieldMapName = _data["homeFieldMapName"];
            this.homeFieldMapId = _data["homeFieldMapId"];
        }
    }

    static fromJS(data: any): TeamsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamName"] = this.teamName;
        data["teamAbbreviation"] = this.teamAbbreviation;
        data["homeFieldMapName"] = this.homeFieldMapName;
        data["homeFieldMapId"] = this.homeFieldMapId;
        return data;
    }
}

export interface ITeamsDto {
    id?: number;
    teamName?: string | undefined;
    teamAbbreviation?: string | undefined;
    homeFieldMapName?: string | undefined;
    homeFieldMapId?: number | undefined;
}

export class TeamPlayersVm implements ITeamPlayersVm {
    teamPlayers?: TeamPlayersDto | undefined;

    constructor(data?: ITeamPlayersVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamPlayers = _data["teamPlayers"] ? TeamPlayersDto.fromJS(_data["teamPlayers"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TeamPlayersVm {
        data = typeof data === 'object' ? data : {};
        let result = new TeamPlayersVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamPlayers"] = this.teamPlayers ? this.teamPlayers.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITeamPlayersVm {
    teamPlayers?: TeamPlayersDto | undefined;
}

export class TeamPlayersDto implements ITeamPlayersDto {
    id?: number;
    teamName?: string | undefined;
    teamPlayers?: PlayersDto[] | undefined;

    constructor(data?: ITeamPlayersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamName = _data["teamName"];
            if (Array.isArray(_data["teamPlayers"])) {
                this.teamPlayers = [] as any;
                for (let item of _data["teamPlayers"])
                    this.teamPlayers!.push(PlayersDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TeamPlayersDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamPlayersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamName"] = this.teamName;
        if (Array.isArray(this.teamPlayers)) {
            data["teamPlayers"] = [];
            for (let item of this.teamPlayers)
                data["teamPlayers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITeamPlayersDto {
    id?: number;
    teamName?: string | undefined;
    teamPlayers?: PlayersDto[] | undefined;
}

export class PlayersDto implements IPlayersDto {
    id?: number;
    playerName?: string | undefined;

    constructor(data?: IPlayersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.playerName = _data["playerName"];
        }
    }

    static fromJS(data: any): PlayersDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["playerName"] = this.playerName;
        return data;
    }
}

export interface IPlayersDto {
    id?: number;
    playerName?: string | undefined;
}

export class NonCaptainTeamPlayersVm implements INonCaptainTeamPlayersVm {
    teamPlayers?: NonCaptainTeamPlayersDto | undefined;

    constructor(data?: INonCaptainTeamPlayersVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamPlayers = _data["teamPlayers"] ? NonCaptainTeamPlayersDto.fromJS(_data["teamPlayers"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NonCaptainTeamPlayersVm {
        data = typeof data === 'object' ? data : {};
        let result = new NonCaptainTeamPlayersVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamPlayers"] = this.teamPlayers ? this.teamPlayers.toJSON() : <any>undefined;
        return data;
    }
}

export interface INonCaptainTeamPlayersVm {
    teamPlayers?: NonCaptainTeamPlayersDto | undefined;
}

export class NonCaptainTeamPlayersDto implements INonCaptainTeamPlayersDto {
    id?: number;
    teamName?: string | undefined;
    teamPlayers?: NonCaptainPlayersDto[] | undefined;

    constructor(data?: INonCaptainTeamPlayersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamName = _data["teamName"];
            if (Array.isArray(_data["teamPlayers"])) {
                this.teamPlayers = [] as any;
                for (let item of _data["teamPlayers"])
                    this.teamPlayers!.push(NonCaptainPlayersDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NonCaptainTeamPlayersDto {
        data = typeof data === 'object' ? data : {};
        let result = new NonCaptainTeamPlayersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamName"] = this.teamName;
        if (Array.isArray(this.teamPlayers)) {
            data["teamPlayers"] = [];
            for (let item of this.teamPlayers)
                data["teamPlayers"].push(item.toJSON());
        }
        return data;
    }
}

export interface INonCaptainTeamPlayersDto {
    id?: number;
    teamName?: string | undefined;
    teamPlayers?: NonCaptainPlayersDto[] | undefined;
}

export class NonCaptainPlayersDto implements INonCaptainPlayersDto {
    id?: number;
    playerName?: string | undefined;

    constructor(data?: INonCaptainPlayersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.playerName = _data["playerName"];
        }
    }

    static fromJS(data: any): NonCaptainPlayersDto {
        data = typeof data === 'object' ? data : {};
        let result = new NonCaptainPlayersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["playerName"] = this.playerName;
        return data;
    }
}

export interface INonCaptainPlayersDto {
    id?: number;
    playerName?: string | undefined;
}

export class CreateTeamCommand implements ICreateTeamCommand {
    teamName?: string | undefined;
    teamAbbreviation?: string | undefined;
    teamSeason?: number;
    teamCaptain?: number;

    constructor(data?: ICreateTeamCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamName = _data["teamName"];
            this.teamAbbreviation = _data["teamAbbreviation"];
            this.teamSeason = _data["teamSeason"];
            this.teamCaptain = _data["teamCaptain"];
        }
    }

    static fromJS(data: any): CreateTeamCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTeamCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamName"] = this.teamName;
        data["teamAbbreviation"] = this.teamAbbreviation;
        data["teamSeason"] = this.teamSeason;
        data["teamCaptain"] = this.teamCaptain;
        return data;
    }
}

export interface ICreateTeamCommand {
    teamName?: string | undefined;
    teamAbbreviation?: string | undefined;
    teamSeason?: number;
    teamCaptain?: number;
}

export class CreateTeamsCommand implements ICreateTeamsCommand {
    season?: number;
    teamsRequestList?: TeamsRequest[] | undefined;

    constructor(data?: ICreateTeamsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.season = _data["season"];
            if (Array.isArray(_data["teamsRequestList"])) {
                this.teamsRequestList = [] as any;
                for (let item of _data["teamsRequestList"])
                    this.teamsRequestList!.push(TeamsRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateTeamsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTeamsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["season"] = this.season;
        if (Array.isArray(this.teamsRequestList)) {
            data["teamsRequestList"] = [];
            for (let item of this.teamsRequestList)
                data["teamsRequestList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateTeamsCommand {
    season?: number;
    teamsRequestList?: TeamsRequest[] | undefined;
}

export class TeamsRequest implements ITeamsRequest {
    teamName?: string | undefined;
    teamAbbreviation?: string | undefined;
    teamCaptain?: number;

    constructor(data?: ITeamsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamName = _data["teamName"];
            this.teamAbbreviation = _data["teamAbbreviation"];
            this.teamCaptain = _data["teamCaptain"];
        }
    }

    static fromJS(data: any): TeamsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TeamsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamName"] = this.teamName;
        data["teamAbbreviation"] = this.teamAbbreviation;
        data["teamCaptain"] = this.teamCaptain;
        return data;
    }
}

export interface ITeamsRequest {
    teamName?: string | undefined;
    teamAbbreviation?: string | undefined;
    teamCaptain?: number;
}

export class AssignTeamHomefieldCommand implements IAssignTeamHomefieldCommand {
    teamId?: number;
    mapId?: number;

    constructor(data?: IAssignTeamHomefieldCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.mapId = _data["mapId"];
        }
    }

    static fromJS(data: any): AssignTeamHomefieldCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssignTeamHomefieldCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["mapId"] = this.mapId;
        return data;
    }
}

export interface IAssignTeamHomefieldCommand {
    teamId?: number;
    mapId?: number;
}

export class UpdateTeamCommand implements IUpdateTeamCommand {
    teamName?: string | undefined;
    teamAbbreviation?: string | undefined;
    teamId?: number;

    constructor(data?: IUpdateTeamCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamName = _data["teamName"];
            this.teamAbbreviation = _data["teamAbbreviation"];
            this.teamId = _data["teamId"];
        }
    }

    static fromJS(data: any): UpdateTeamCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTeamCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamName"] = this.teamName;
        data["teamAbbreviation"] = this.teamAbbreviation;
        data["teamId"] = this.teamId;
        return data;
    }
}

export interface IUpdateTeamCommand {
    teamName?: string | undefined;
    teamAbbreviation?: string | undefined;
    teamId?: number;
}

export class UsersVm implements IUsersVm {
    userList?: UserDto[] | undefined;

    constructor(data?: IUsersVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userList"])) {
                this.userList = [] as any;
                for (let item of _data["userList"])
                    this.userList!.push(UserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UsersVm {
        data = typeof data === 'object' ? data : {};
        let result = new UsersVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userList)) {
            data["userList"] = [];
            for (let item of this.userList)
                data["userList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUsersVm {
    userList?: UserDto[] | undefined;
}

export class UserDto implements IUserDto {
    id?: string | undefined;
    userName?: string | undefined;
    playerId?: number | undefined;
    playerName?: string | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.playerId = _data["playerId"];
            this.playerName = _data["playerName"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["playerId"] = this.playerId;
        data["playerName"] = this.playerName;
        return data;
    }
}

export interface IUserDto {
    id?: string | undefined;
    userName?: string | undefined;
    playerId?: number | undefined;
    playerName?: string | undefined;
}

export class RolesForUserVm implements IRolesForUserVm {
    id?: string | undefined;
    userName?: string | undefined;
    isAdmin?: boolean;
    isDemoAdmin?: boolean;
    isStatsRunner?: boolean;

    constructor(data?: IRolesForUserVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.isAdmin = _data["isAdmin"];
            this.isDemoAdmin = _data["isDemoAdmin"];
            this.isStatsRunner = _data["isStatsRunner"];
        }
    }

    static fromJS(data: any): RolesForUserVm {
        data = typeof data === 'object' ? data : {};
        let result = new RolesForUserVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["isAdmin"] = this.isAdmin;
        data["isDemoAdmin"] = this.isDemoAdmin;
        data["isStatsRunner"] = this.isStatsRunner;
        return data;
    }
}

export interface IRolesForUserVm {
    id?: string | undefined;
    userName?: string | undefined;
    isAdmin?: boolean;
    isDemoAdmin?: boolean;
    isStatsRunner?: boolean;
}

export class SetRolesForUserCommand implements ISetRolesForUserCommand {
    userId?: string | undefined;
    isAdmin?: boolean;
    isDemoAdmin?: boolean;
    isStatsRunner?: boolean;

    constructor(data?: ISetRolesForUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.isAdmin = _data["isAdmin"];
            this.isDemoAdmin = _data["isDemoAdmin"];
            this.isStatsRunner = _data["isStatsRunner"];
        }
    }

    static fromJS(data: any): SetRolesForUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetRolesForUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["isAdmin"] = this.isAdmin;
        data["isDemoAdmin"] = this.isDemoAdmin;
        data["isStatsRunner"] = this.isStatsRunner;
        return data;
    }
}

export interface ISetRolesForUserCommand {
    userId?: string | undefined;
    isAdmin?: boolean;
    isDemoAdmin?: boolean;
    isStatsRunner?: boolean;
}

export class RegularSeasonWeeksVm implements IRegularSeasonWeeksVm {
    weekList?: RegularSeasonWeeksDto[] | undefined;

    constructor(data?: IRegularSeasonWeeksVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["weekList"])) {
                this.weekList = [] as any;
                for (let item of _data["weekList"])
                    this.weekList!.push(RegularSeasonWeeksDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegularSeasonWeeksVm {
        data = typeof data === 'object' ? data : {};
        let result = new RegularSeasonWeeksVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.weekList)) {
            data["weekList"] = [];
            for (let item of this.weekList)
                data["weekList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRegularSeasonWeeksVm {
    weekList?: RegularSeasonWeeksDto[] | undefined;
}

export class RegularSeasonWeeksDto implements IRegularSeasonWeeksDto {
    id?: number;
    weekNumber?: number;
    weekStartDate?: Date;

    constructor(data?: IRegularSeasonWeeksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.weekNumber = _data["weekNumber"];
            this.weekStartDate = _data["weekStartDate"] ? new Date(_data["weekStartDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RegularSeasonWeeksDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegularSeasonWeeksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["weekNumber"] = this.weekNumber;
        data["weekStartDate"] = this.weekStartDate ? this.weekStartDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRegularSeasonWeeksDto {
    id?: number;
    weekNumber?: number;
    weekStartDate?: Date;
}

export class PlayoffWeeksVm implements IPlayoffWeeksVm {
    weekList?: PlayoffWeeksDto[] | undefined;

    constructor(data?: IPlayoffWeeksVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["weekList"])) {
                this.weekList = [] as any;
                for (let item of _data["weekList"])
                    this.weekList!.push(PlayoffWeeksDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayoffWeeksVm {
        data = typeof data === 'object' ? data : {};
        let result = new PlayoffWeeksVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.weekList)) {
            data["weekList"] = [];
            for (let item of this.weekList)
                data["weekList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlayoffWeeksVm {
    weekList?: PlayoffWeeksDto[] | undefined;
}

export class PlayoffWeeksDto implements IPlayoffWeeksDto {
    id?: number;
    weekNumber?: number;
    weekType?: string | undefined;
    weekStartDate?: Date;

    constructor(data?: IPlayoffWeeksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.weekNumber = _data["weekNumber"];
            this.weekType = _data["weekType"];
            this.weekStartDate = _data["weekStartDate"] ? new Date(_data["weekStartDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PlayoffWeeksDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayoffWeeksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["weekNumber"] = this.weekNumber;
        data["weekType"] = this.weekType;
        data["weekStartDate"] = this.weekStartDate ? this.weekStartDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPlayoffWeeksDto {
    id?: number;
    weekNumber?: number;
    weekType?: string | undefined;
    weekStartDate?: Date;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}